/**
 * @license
 * @qwik.dev/core 2.0.0-beta.35-dev+986b0f2
 * Copyright QwikDev. All Rights Reserved.
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/QwikDev/qwik/blob/main/LICENSE
 */
import { isServer as oe, isBrowser as le } from "@qwik.dev/core/build";

export { isBrowser, isServer } from "@qwik.dev/core/build";

import { p as ie } from "@qwik.dev/core/preloader";

const ue = !1;

const fe = (t, n, ...e) => {
    const s = n instanceof Error ? n : Error(n);
    console.error("%cQWIK ERROR", "", s.message, ...e, s.stack);
    t && setTimeout(() => {
        throw s;
    }, 0);
    return s;
};

/*@__INLINE__*/ const ae = (t, n, e) => {
    let s = e >> 1;
    let o = t.length - 2 >> 1;
    for (;s <= o; ) {
        const e = s + (o - s >> 1);
        const r = t[e << 1];
        if (r === n) {
            return e << 1;
        }
        r < n ? s = e + 1 : o = e - 1;
    }
    return ~(s << 1);
};

const he = (t, n, e, s, o = !1) => {
    const r = ae(t, n, s);
    r >= 0 ? e != null || o ? t[r + 1] = e : t.splice(r, 2) : (e != null || o) && t.splice(r ^ -1, 0, n, e);
};

const de = (t, n, e) => {
    const s = ae(t, n, e);
    return s >= 0 ? t[s + 1] : null;
};

const pe = (t, n, e) => ae(t, n, e) >= 0;

const $e = t => {
    const n = Object.getPrototypeOf(t);
    return n === Object.prototype || n === Array.prototype || n === null;
};

const ye = t => typeof t === "object" && t !== null;

const me = t => Array.isArray(t);

const we = t => typeof t === "string";

const be = t => typeof t === "function";

const ve = (t, n = []) => {
    const e = (t => `Code(Q${t}) https://qwikdev-build-v2.qwik-8nx.pages.dev/docs/errors/#q${t}`)(t, ...n);
    return ((t, ...n) => {
        const e = fe(false, t, ...n);
        debugger;
        return e;
    })(e, ...n);
};

const ge = "<sync>";

const _e = t => typeof t === "function" && typeof t.getSymbol === "function";

const Ha = t => {
    const n = t.lastIndexOf("_") + 1;
    return t.slice(n);
};

const Se = "q:type";

const ke = {
    ["V"]: "Virtual",
    ["F"]: "Fragment",
    ["S"]: "Signal",
    ["A"]: "Awaited",
    ["C"]: "Component",
    ["I"]: "InlineComponent",
    ["P"]: "Projection"
};

const Ee = 124;

function t(t) {
    let n = "";
    for (let e = 0; e < t.length; e++) {
        if (t.charAt(e) === "\\" && e + 1 < t.length) {
            n += t.charAt(e + 1);
            e++;
        } else {
            n += t.charAt(e);
        }
    }
    return n;
}

const xe = "q:renderFn";

const qe = "q:targetEl";

const Te = "⚡️";

const Pe = "q:slot";

const Re = "q:s";

const Ae = "q:style";

const Me = "style[q\\:style]";

const Ne = Me + ",style[q\\:sstyle]";

const Ie = "q:sstyle";

const Ce = "q:ctx";

const je = "q:brefs";

const Oe = (t, n) => t["qFuncs_" + n] || [];

const Fe = "q:base";

const Le = "q:container-island";

const De = "/" + Le;

const Ve = "q:ignore";

const We = "/" + Ve;

const Ue = "q:container";

const Xe = "/" + Ue;

const ze = "q:template";

const Be = "http://www.w3.org/1999/xhtml";

const He = "http://www.w3.org/2000/svg";

const Je = "http://www.w3.org/1998/Math/MathML";

const Qe = "qRender";

const Ge = "q:key";

const Ke = "q:props";

const Ze = "q:seq";

const tr = "q:seqIdx";

const nr = "q:p";

const er = "q:ps";

const sr = ":on";

const ir = ":onIdx";

const or = ":onFlags";

const lr = "q:cursorBoundary";

const ur = ":nearestCursorBoundary";

const cr = ":";

const fr = "dangerouslySetInnerHTML";

const hr = 100;

const dr = t => !!t && typeof t == "object" && typeof t.then === "function";

const pr = (t, n, e) => {
    try {
        const s = t();
        return dr(s) ? s.then(n, e) : n(s);
    } catch (t) {
        return e(t);
    }
};

const $r = (t, n) => dr(t) ? t.then(n) : n(t);

const yr = t => {
    throw t;
};

function n(t, n = yr) {
    let e = !1;
    let s;
    try {
        s = t();
        e = !0;
    } catch (t) {
        s = t;
    }
    if (!dr(s)) {
        if (e) {
            return s;
        }
        return n(s);
    }
    let o = hr;
    const r = async e => {
        for (;dr(e); ) {
            try {
                await e;
                return await t();
            } catch (t) {
                if (!dr(t)) {
                    e = t;
                    break;
                }
                if (! --o) {
                    e = Error("Exceeded max retry count in retryOnPromise");
                    break;
                }
                e = t;
            }
        }
        return n(e);
    };
    return e ? s.catch(r) : r(s);
}

const mr = t => Te + t;

const wr = t => {
    if (t) {
        let n = 0;
        do {
            t = t.substring(0, n) + mr(t.substring(n));
        } while ((n = t.indexOf(" ", n) + 1) !== 0);
    }
    return t || null;
};

const br = t => t.charCodeAt(0) === 113 && t.charCodeAt(1) === 45 && (t.charCodeAt(3) === 58 || t.charCodeAt(3) === 112 && t.charCodeAt(4) === 58);

function e(t, n = !1) {
    if (t.endsWith("$")) {
        const [e, s] = function o(t, n = !1) {
            let e;
            let s = -1;
            if (t.startsWith("on")) {
                e = n ? "q-ep:" : "q-e:";
                s = 2;
            } else if (t.startsWith("window:on")) {
                e = n ? "q-wp:" : "q-w:";
                s = 9;
            } else if (t.startsWith("document:on")) {
                e = n ? "q-dp:" : "q-d:";
                s = 11;
            }
            return [ e, s ];
        }(t, n);
        if (s !== -1) {
            return e + vr(t.slice(s, -1));
        }
    }
    return null;
}

const vr = t => t === "DOMContentLoaded" ? "-d-o-m-content-loaded" : function n(t, e = "") {
    const s = gr(t);
    return e + s;
}(t.charAt(0) === "-" ? t.slice(1) : t.toLowerCase());

const gr = t => t.replace(/([A-Z-])/g, t => "-" + t.toLowerCase());

const _r = t => {
    const n = t.indexOf(":");
    return [ t.slice(2, n), t.slice(n + 1) ];
};

const Sr = new Set([ "animationIterationCount", "aspectRatio", "borderImageOutset", "borderImageSlice", "borderImageWidth", "boxFlex", "boxFlexGroup", "boxOrdinalGroup", "columnCount", "columns", "flex", "flexGrow", "flexShrink", "gridArea", "gridRow", "gridRowEnd", "gridRowStart", "gridColumn", "gridColumnEnd", "gridColumnStart", "fontWeight", "lineClamp", "lineHeight", "opacity", "order", "orphans", "scale", "tabSize", "widows", "zIndex", "zoom", "MozAnimationIterationCount", "MozBoxFlex", "msFlex", "msFlexPositive", "WebkitAnimationIterationCount", "WebkitBoxFlex", "WebkitBoxOrdinalGroup", "WebkitColumnCount", "WebkitColumns", "WebkitFlex", "WebkitFlexGrow", "WebkitFlexShrink", "WebkitLineClamp" ]);

const kr = (t, n = 0) => {
    for (let e = 0; e < t.length; e++) {
        const s = t.charCodeAt(e);
        n = (n << 5) - n + s;
        n |= 0;
    }
    return (+Math.abs(n)).toString(36);
};

const Er = t => {
    if (!t) {
        return "";
    }
    if (we(t)) {
        return t.trim();
    }
    const n = [];
    if (me(t)) {
        for (let e = 0; e < t.length; e++) {
            const s = t[e];
            const o = Er(s);
            o && n.push(o);
        }
    } else {
        for (const [e, s] of Object.entries(t)) {
            s && n.push(e.trim());
        }
    }
    return n.join(" ");
};

const xr = t => t.replace(/([A-Z])/g, "-$1").toLowerCase();

function r(t, n, e) {
    if (function s(t) {
        return t === "class";
    }(t)) {
        const t = Er(n);
        n = e ? e + (t.length ? " " + t : t) : t;
    } else {
        t === "style" ? n = (t => {
            if (t == null) {
                return "";
            }
            if (typeof t == "object") {
                if (me(t)) {
                    throw ve(0, [ t, "style" ]);
                }
                {
                    const n = [];
                    for (const e in t) {
                        if (Object.prototype.hasOwnProperty.call(t, e)) {
                            const s = t[e];
                            s != null && typeof s !== "function" && (e.startsWith("--") ? n.push(e + ":" + s) : n.push(xr(e) + ":" + qr(e, s)));
                        }
                    }
                    return n.join(";");
                }
            }
            return t + "";
        })(n) : function o(t) {
            return function n(t) {
                return t.startsWith("aria-");
            }(t) || [ "spellcheck", "draggable", "contenteditable" ].includes(t);
        }(t) || typeof n === "number" ? n = (t => t != null ? t + "" : null)(n) : n === !1 || n == null ? n = null : n === !0 && function r(t) {
            return t.startsWith("preventdefault:");
        }(t) && (n = "");
    }
    return n;
}

const qr = (t, n) => {
    if (typeof n === "number" && n !== 0 && !(t => Sr.has(t))(t)) {
        return n + "px";
    }
    return n;
};

const Tr = t => {
    let n;
    if (typeof MessageChannel !== "undefined") {
        const e = new MessageChannel;
        e.port1.onmessage = () => t();
        n = () => e.port2.postMessage(null);
    } else {
        n = () => setTimeout(t);
    }
    return n;
};

const Pr = () => ({
    isServer: oe,
    importSymbol(t, n, e) {
        if (oe) {
            const t = Ha(e);
            const n = globalThis.__qwik_reg_symbols?.get(t);
            if (n) {
                return n;
            }
            throw ve(6, [ e ]);
        }
        if (!n) {
            throw ve(14, [ e ]);
        }
        if (!t) {
            throw ve(13, [ n, e ]);
        }
        const s = "" + Rr(t.ownerDocument, t, n);
        const o = new URL(s);
        o.hash = "";
        const r = o.href;
        return import(r).then(t => t[e]);
    },
    raf: t => new Promise(n => {
        requestAnimationFrame(() => {
            n(t());
        });
    }),
    chunkForSymbol(t, n) {
        return [ t, n ?? "_" ];
    }
});

const Rr = (t, n, e) => {
    const s = t.baseURI;
    const o = new URL(n.getAttribute(Fe) ?? s, s);
    return new URL(e, o);
};

let Ar = /*#__PURE__ */ Pr();

const Mr = t => Ar = t;

const Nr = () => Ar;

const Ja = () => Ar.isServer;

const Qa = typeof document !== "undefined";

const Ir = !oe && Qa;

const Cr = Ir ? document : void 0;

const jr = Ir && Cr.createElement("link").relList?.supports?.("modulepreload") ? "modulePreload" : "preload";

performance.now();

const Or = /\.[mc]?js$/;

const Fr = 1e3 / 60;

const Lr = t => {
    let n = Dr.get(t);
    if (!n) {
        let e;
        n = ((t, n) => ({
            Dt: t,
            It: Or.test(t) ? 0 : 3,
            Vt: n,
            Wt: 1,
            Ut: performance.now(),
            Xt: 0,
            zt: 0
        }))(t, e);
        Dr.set(t, n);
    }
    return n;
};

const Dr = new Map;

let Vr = 0;

const Wr = [];

const Ur = Tr(function Ya() {
    zr = !1;
    if (!Wr.length) {
        return;
    }
    const t = performance.now() + Fr;
    let n = !1;
    for (;Wr.length; ) {
        const e = Wr[0];
        const s = e.Wt;
        const o = 1 - s;
        if (!(o >= .99 || Vr < 25)) {
            break;
        }
        Wr.shift();
        Yr(e);
        if (performance.now() >= t) {
            n = !0;
            break;
        }
    }
    if (n && Wr.length && !zr) {
        zr = !0;
        Ur();
    }
});

const Xr = Tr(s);

let zr = !1;

let Br = !1;

let Hr = !1;

const Jr = [];

const Qr = () => {
    const t = Jr[Jr.length - 1];
    const n = t.Bt;
    if (t.Vt) {
        const e = t.Ht;
        if (e >= t.Vt.length) {
            Jr.pop();
            return !1;
        }
        const s = t.Vt[e];
        t.Ht = e + 1;
        const o = Lr(s.Dt);
        if (o.Wt === 0) {
            return !0;
        }
        const r = 1 - n.Wt;
        let i;
        if (r === 1 || r >= .99) {
            i = Math.min(.01, 1 - s.Jt);
        } else {
            const t = 1 - s.Jt * r;
            const n = s.Qt;
            const e = t / n;
            i = Math.max(.02, o.Wt * e);
            s.Qt = e;
        }
        Jr.push({
            Bt: o,
            Wt: i,
            Yt: t.Yt
        });
        return !0;
    }
    if (t.Yt?.has(n)) {
        Jr.pop();
        return !1;
    }
    const e = n.Wt;
    n.Wt = t.Wt;
    if (e - n.Wt < .01) {
        Jr.pop();
        return !1;
    }
    if (n.Vt?.length) {
        const e = t.Yt || new Set;
        e.add(n);
        t.Yt = e;
        t.Vt = n.Vt;
        t.Ht = 0;
        return !1;
    }
    Jr.pop();
    return !1;
};

function s() {
    if (Hr || !Jr.length) {
        return;
    }
    Br = !1;
    Hr = !0;
    const t = Ir ? performance.now() + Fr : 0;
    let n = !1;
    for (;Jr.length; ) {
        n = !0;
        const e = Qr();
        if (Ir && e && performance.now() >= t) {
            if (!Br) {
                Br = !0;
                Xr();
            }
            break;
        }
    }
    Hr = !1;
    n && Ir && Ur();
}

const Yr = t => {
    if (t.It >= 2) {
        return;
    }
    Vr++;
    const n = performance.now();
    t.Xt = n - t.Ut;
    t.It = 2;
    const e = Cr.createElement("link");
    e.href = "" + new URL("undefined" + t.Dt, Cr.baseURI);
    e.rel = jr;
    e.as = "script";
    e.onload = e.onerror = () => {
        Vr--;
        const s = performance.now();
        t.zt = s - n;
        t.It = 4;
        e.remove();
        Ur();
    };
    Cr.head.appendChild(e);
};

const Gr = (t, n) => {
    const e = Lr(t);
    e && ((t, n) => {
        Jr.unshift({
            Bt: t,
            Wt: n,
            Yt: void 0
        });
    })(e, n);
};

Ir && document.addEventListener("qsymbol", t => {
    const {symbol: n, href: e} = t.detail;
    if (e) {
        const t = n.slice(n.lastIndexOf("_") + 1);
        (t => {
            if (!t?.length) {
                return;
            }
            if (Array.isArray(t)) {
                for (let n = t.length - 1; n >= 0; n--) {
                    const e = t[n];
                    Gr(e, 0);
                }
            } else {
                Gr(t, 0);
            }
            Ir ? Xr() : s();
        })(t);
    }
});

const Kr = t => {
    for (const n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
            return !1;
        }
    }
    return !0;
};

const Zr = ",";

const ts = "2.0.0-beta.35-dev+986b0f2";

const ns = t => t.nodeType === 1;

const es = Symbol();

class rs {
    [es]=void 0;
}

const ss = t => t === "foreignObject";

const is = t => t === "svg" || ss(t);

const os = t => t === "math";

function i(t, n, e, s = !1) {
    const o = t.ownerDocument.createElementNS(e, n);
    for (let n = 0; n < t.attributes.length; n++) {
        const e = t.attributes[n];
        e.name !== cr && o.setAttribute(e.name, e.value);
    }
    if (s) {
        for (let n = 0; n < t.childNodes.length; n++) {
            const r = t.childNodes[n];
            const c = r.nodeType;
            c === 3 ? o.appendChild(r.cloneNode()) : c === 1 && o.appendChild(i(r, r.localName, e, s));
        }
    }
    return o;
}

const ls = {
    elementNamespace: Be,
    elementNamespaceFlag: 0
};

function o(t, n) {
    const e = !t || !!rl(t) && (t => {
        const n = t.flags;
        return (n & 1536) === 0;
    })(t);
    const s = !e && ss(rl(t));
    let o = Be;
    let r = 0;
    const i = typeof n === "string" || Eo(n);
    if (i && function c(t) {
        if (typeof t === "string") {
            return is(t);
        }
        if (Eo(t)) {
            return is(rl(t)) || (t.flags & 512) !== 0;
        }
        return !1;
    }(n)) {
        o = He;
        r = 512;
    } else if (i && function l(t) {
        if (typeof t === "string") {
            return os(t);
        }
        if (Eo(t)) {
            return os(rl(t)) || (t.flags & 1024) !== 0;
        }
        return !1;
    }(n)) {
        o = Je;
        r = 1024;
    } else if (t && !s && !e) {
        const n = (t.flags & 512) !== 0;
        const e = (t.flags & 1024) !== 0;
        o = n ? He : e ? Je : Be;
        r = t.flags & 1536;
    }
    ls.elementNamespace = o;
    ls.elementNamespaceFlag = r;
    return ls;
}

class us {
    flags;
    parent;
    previousSibling;
    nextSibling;
    props;
    [es]=void 0;
    slotParent=null;
    dirty=0;
    dirtyChildren=null;
    nextDirtyChildIndex=0;
    constructor(t, n, e, s, o) {
        this.flags = t;
        this.parent = n;
        this.previousSibling = e;
        this.nextSibling = s;
        this.props = o;
    }
    toString() {
        return Object.prototype.toString.call(this);
    }
}

class cs extends us {
    key;
    firstChild;
    lastChild;
    constructor(t, n, e, s, o, r, i, c) {
        super(n, e, s, o, r);
        this.key = t;
        this.firstChild = i;
        this.lastChild = c;
    }
}

class fs extends cs {
    node;
    elementName;
    constructor(t, n, e, s, o, r, i, c, l, u) {
        super(t, n, e, s, o, r, i, c);
        this.node = l;
        this.elementName = u;
    }
}

class as extends us {
    node;
    text;
    constructor(t, n, e, s, o, r, i) {
        super(t, n, e, s, o);
        this.node = r;
        this.text = i;
    }
}

const hs = [];

const ds = [];

function l(t, n) {
    const e = d(n).priority;
    let s = hs.length;
    for (let t = 0; t < hs.length; t++) {
        const n = d(hs[t]).priority;
        if (e < n) {
            s = t;
            break;
        }
    }
    hs.splice(s, 0, n);
    t.o++;
    t.l ||= new Promise(n => t.u = n);
}

function u() {
    for (let t = 0; t < hs.length; t++) {
        const n = hs[t];
        let e = !1;
        for (let t = 0; t < ds.length; t++) {
            const s = ds[t];
            if (El(n, s)) {
                e = !0;
                break;
            }
        }
        if (!e) {
            return n;
        }
    }
    return null;
}

function c(t, n) {
    ds.push(t);
    a(t, n, !0);
    n.o++;
}

function f(t, n) {
    const e = ds.indexOf(t);
    if (e !== -1) {
        const t = ds.length - 1;
        e !== t && (ds[e] = ds[t]);
        ds.pop();
        n.o--;
    }
    l(n, t);
}

function a(t, n, e) {
    e || (t.flags &= -257);
    const s = hs.indexOf(t);
    if (s !== -1) {
        hs.splice(s, 1);
        n.o--;
    }
}

const ps = new WeakMap;

const $s = ":nodeProps";

const ys = ":nodeDiff";

const ms = ":errorData";

const ws = ":signal";

function h(t, n, e) {
    n.position = e;
    e && nn(e) && function s(t, n, e) {
        a(e, t);
        const s = d(e);
        if (s === n) {
            return;
        }
        const o = s.afterFlushTasks;
        if (o && o.length > 0) {
            const t = n.afterFlushTasks;
            t ? t.push(...o) : n.afterFlushTasks = o;
        }
        const r = s.extraPromises;
        if (r && r.length > 0) {
            const t = n.extraPromises;
            t ? t.push(...r) : n.extraPromises = r;
        }
        const i = s.journal;
        if (i && i.length > 0) {
            const t = n.journal;
            t ? t.push(...i) : n.journal = i;
        }
        const c = s.boundaries;
        if (__EXPERIMENTAL__.suspense && c && c.length > 0) {
            const t = n.boundaries ||= [];
            for (let n = 0; n < c.length; n++) {
                const e = c[n];
                t.includes(e) || t.push(e);
            }
        }
    }(t, n, e);
}

function d(t) {
    return ps.get(t) ?? null;
}

const bs = Symbol();

class vs {
    consumer;
    property;
    backRef;
    data;
    constructor(t, n, e = null, s = null) {
        this.consumer = t;
        this.property = n;
        this.backRef = e;
        this.data = s;
    }
}

const gs = Symbol();

const _s = Symbol();

const Ss = Symbol();

function p(t, n, e) {
    t[es] || (oe && function s(t) {
        return "__brand__" in t && t.__brand__ === "SsrNode";
    }(t) ? t.setProp(je, new Map) : t[es] = new Map);
    const o = t[es];
    let r = o.get(n);
    if (!r) {
        r = new vs(t, n);
        o.set(n, r);
    }
    e && (r.data = e);
    return r;
}

const ks = (t, n) => (e, s) => {
    const o = re();
    o.Ot = p(t, ":");
    o.$ = n || void 0;
    return te(o, () => {
        if (be(e)) {
            return e();
        }
        if (s) {
            return e[s];
        }
        if (Ll(e)) {
            return e.value;
        }
        if (ye(e) && Zl(e)) {
            _n(Ql(e), Ss, Jl(e), o.Ot);
            return e;
        }
        throw ve(2);
    });
};

class Es {
    Gt;
    ut=void 0;
    $=null;
    Kt=null;
    constructor(t, n) {
        this.$ = t || Ec()?.$ || null;
        this.Gt = n;
    }
    trigger() {
        Ul(this.$, this, this.ut);
    }
    force() {
        Ul(this.$, this, this.ut);
    }
    get untrackedValue() {
        return this.Gt;
    }
    set untrackedValue(t) {
        this.Gt = t;
    }
    get value() {
        const t = this.untrackedValue;
        const n = Ec();
        if (!n) {
            return t;
        }
        this.$ === null && (this.$ = n.$);
        const e = n.Ot;
        if (e) {
            Dl(this.ut ||= new Set, e);
            Vl(e, this);
            oe && Wl(e, this.$);
        }
        return t;
    }
    set value(t) {
        if (t !== this.Gt) {
            this.Gt = t;
            Ul(this.$, this, this.ut);
        }
    }
    valueOf() {}
    toString() {
        return this.constructor.name;
    }
    toJSON() {
        return {
            value: this.Gt
        };
    }
}

class xs extends Es {
    Zt;
    h;
    [es]=void 0;
    constructor(t, n, e = 17) {
        super(t || Ec()?.$, bs);
        this.Zt = n;
        this.h = e;
    }
    invalidate() {
        this.h |= 1;
        const t = re();
        t.$ = this.$ || void 0;
        const e = n(ne.bind(this, t, this.p));
        e && e.catch(t => {
            this.$ ? this.$.handleError(t, null) : console.error("Error during computation", t);
        });
    }
    get untrackedValue() {
        this.p();
        return this.Gt;
    }
    set untrackedValue(t) {
        this.Gt = t;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = this.Zt;
        Fl(t);
        const n = Ec();
        const e = n?.Ot;
        if (n) {
            const t = p(this, ".");
            $n(this.$, t);
            n.Ot = t;
        }
        try {
            const e = t.getFn(n)();
            if (dr(e)) {
                throw ve(29, [ t.dev ? t.dev.file : "", t.it ]);
            }
            this.h &= -2;
            super.value = e;
        } finally {
            n && (n.Ot = e);
        }
    }
}

class qs {
    tn;
    nn=null;
    en=!1;
    rn=!0;
    constructor(t, n, e) {
        this.tn = t;
        if (n !== void 0) {
            this.info = n;
            this.sn = e;
        }
    }
    get track() {
        return this.ln ||= ks(this.tn, this.tn.$);
    }
    get abortSignal() {
        return (this.un ||= new AbortController).signal;
    }
    cache() {}
    get previous() {
        const t = this.tn.Gt;
        if (t !== bs) {
            return t;
        }
    }
    cleanup(t) {
        typeof t === "function" && (this.cn ||= []).push(t);
    }
}

class Ts extends xs {
    fn=!1;
    an=void 0;
    hn=null;
    [es]=void 0;
    constructor(t, n, e = 17, s) {
        super(t, n, e);
        if (!s) {
            return;
        }
        const o = s.initial;
        if (o !== void 0) {
            const t = typeof o === "function" ? o() : o;
            this.Gt = t;
        }
        const r = s.concurrency;
        if (r !== void 0 && r >= 0 && r !== 1) {
            this.dn = r;
            this.pn = [];
        }
        const i = s.timeout;
        i && (this.$n = i);
        s.eagerCleanup && (this.h |= 32);
        s.clientOnly && (this.h |= 64);
        s.allowStale === !1 && (this.h |= 128);
        const c = s.expires ?? (s.interval ? Math.abs(s.interval) : void 0);
        c && (this.expires = c);
        (s.poll === !1 || s.interval !== void 0 && s.interval < 0) && (this.h |= 256);
    }
    get untrackedValue() {
        this.p();
        if (this.hn?.nn) {
            if (this.Gt === bs || oe) {
                throw this.hn?.nn;
            }
            return this.Gt;
        }
        if (this.an) {
            throw this.an;
        }
        if (oe && this.h & 64 && this.Gt === bs) {
            throw ve(35);
        }
        return this.Gt;
    }
    set untrackedValue(t) {
        this.Gt = t;
    }
    get value() {
        return super.value;
    }
    set value(t) {
        this.h &= -2;
        this.untrackedLoading = !1;
        this.untrackedError = void 0;
        this.yn = void 0;
        if (this.pn) {
            for (let t = 0; t < this.pn.length; t++) {
                this.pn[t].rn = !1;
            }
        } else {
            this.hn && (this.hn.rn = !1);
        }
        this.mn();
        super.value = t;
        this.wn();
    }
    get loading() {
        const t = this.untrackedLoading;
        const n = Ec();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.Ot;
            if (t) {
                Dl(this.dt ||= new Set, t);
                Vl(t, this);
                Wl(t, this.$);
            }
        }
        return t;
    }
    set untrackedLoading(t) {
        if (t !== this.fn) {
            this.fn = t;
            Ul(this.$, this, this.dt);
        }
    }
    get untrackedLoading() {
        this.p();
        if (oe && this.hn?.nn) {
            throw this.hn?.nn;
        }
        return this.fn;
    }
    get error() {
        const t = this.untrackedError;
        const n = Ec();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.Ot;
            if (t) {
                Dl(this.$t ||= new Set, t);
                Vl(t, this);
                Wl(t, this.$);
            }
        }
        return t;
    }
    set untrackedError(t) {
        if (t !== this.an) {
            this.an = t;
            Ul(this.$, this, this.$t);
        }
    }
    get untrackedError() {
        return this.an;
    }
    get expires() {
        return this.xt || 0;
    }
    set expires(t) {
        this.mn();
        this.xt = t;
        this.xt && this.bn() && this.wn();
    }
    get poll() {
        return !(this.h & 256);
    }
    set poll(t) {
        t ? this.h &= -257 : this.h |= 256;
        if (this.xt && this.bn()) {
            this.mn();
            this.wn();
        }
    }
    get interval() {
        const t = this.xt || 0;
        return this.h & 256 ? -t : t;
    }
    set interval(t) {
        t < 0 ? this.h |= 256 : this.h &= -257;
        this.expires = Math.abs(t);
    }
    async invalidate(t) {
        if (arguments.length > 0) {
            this.yn = t;
            this.sn = this.sn === void 0 ? 1 : this.sn + 1;
        }
        this.vn(!0, this.h & 128);
    }
    vn(t, n) {
        this.h |= 1;
        this.mn();
        n && (this.Gt = bs);
        t && (this.ut?.size || this.dt?.size || this.$t?.size) && Promise.resolve().then(() => this.p());
    }
    abort(t) {
        this.hn && this.gn(this.hn, t);
    }
    yt() {
        if (!(this.h & 32) || this.bn()) {
            return;
        }
        if (!le) {
            return;
        }
        setTimeout(() => {
            this.bn() || this.abort();
        });
    }
    async promise() {
        this.p();
        for (;this.hn?.nn; ) {
            await (this.hn?.nn);
        }
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        if (oe && this.h & 64) {
            this.fn = !0;
            this.$?.serializationCtx.qt.add(this);
            return;
        }
        this.mn();
        this.h &= -2;
        const t = this.hn;
        t && this.gn(t);
        const n = this.dn === 0 ? Infinity : this.dn ?? 1;
        if (this.pn ? this.pn.length >= n : t?.nn) {
            this.h |= 1;
            return;
        }
        const e = this.sn;
        const s = new qs(this, this.yn, e);
        this.hn = s;
        this.pn && this.pn.push(s);
        s.nn = this._n(s);
    }
    async _n(t) {
        let e = this.Zt.resolved;
        if (!e) {
            this.untrackedLoading = !0;
            e = await this.Zt.resolve();
            if (t.un?.signal.aborted) {
                t.nn = null;
                return;
            }
        }
        try {
            this.$n && (this.Sn = setTimeout(() => {
                const n = Error(`timeout ${this.$n}ms`);
                this.kn(t, n);
                t.un?.abort(n);
            }, this.$n));
            const s = n(e.bind(null, t));
            let o;
            if (dr(s)) {
                this.untrackedLoading = !0;
                o = await s;
            } else {
                o = s;
            }
            t.nn = null;
            if (t.rn) {
                const n = this.pn;
                if (n) {
                    let e = !1;
                    for (let s = n.length - 1; s >= 0; s--) {
                        n[s] === t ? e = !0 : e && (n[s].rn = !1);
                    }
                }
                this.untrackedError = void 0;
                super.value = o;
            }
        } catch (n) {
            t.nn = null;
            this.kn(t, n);
        }
        if ((() => t === this.hn)()) {
            clearTimeout(this.Sn);
            t.sn === this.sn && (this.yn = void 0);
            if (this.h & 1) {
                this.p();
            } else {
                this.untrackedLoading = !1;
                this.wn();
            }
        }
    }
    kn(t, n) {
        if (t !== this.hn || !t.rn) {
            return;
        }
        t.rn = !1;
        if (n instanceof Error && n.name === "AbortError") {
            return;
        }
        this.untrackedError = n;
        this.untrackedValue = bs;
    }
    async En() {
        this.mn();
        clearTimeout(this.Sn);
        const t = this.hn;
        t && this.gn(t);
        this.pn ? await Promise.all(this.pn.map(t => t.nn)) : await (t?.nn);
    }
    mn() {
        if (this.xn !== void 0) {
            clearTimeout(this.xn);
            this.xn = void 0;
        }
    }
    wn() {
        if (oe || !this.xt) {
            return;
        }
        this.mn();
        const t = !(this.h & 256);
        const n = this.h & 128 && !t;
        this.xn = setTimeout(() => this.vn(t, n), this.xt);
        this.xn?.unref?.();
    }
    bn() {
        return !!(this.ut?.size || this.dt?.size || this.$t?.size);
    }
    gn(t, n) {
        if (t.en) {
            return;
        }
        t.en = !0;
        t.un?.abort(n);
        t.nn = $r(t.nn, () => this.qn(t));
    }
    qn(t) {
        const n = t.cn;
        const e = t => {
            const n = this.$?.handleError;
            n ? n(t, null) : console.error("Error in async signal cleanup", t);
        };
        const s = () => {
            t.nn = null;
            n && (n.length = 0);
            const e = this.pn;
            if (e) {
                const n = e.indexOf(t);
                n !== -1 && e.splice(n, 1);
            }
            this.p();
        };
        let o;
        if (n) {
            for (let t = 0; t < n.length; t++) {
                try {
                    const s = n[t]();
                    dr(s) && (o = (o ? o.then(() => s) : s).catch(e));
                } catch (t) {
                    e(t);
                }
            }
        }
        if (o) {
            return o.then(s);
        }
        s();
    }
}

const Ps = Symbol();

const Rs = Symbol();

const As = Symbol();

const Ms = Symbol();

const Ns = Symbol();

const Is = Symbol();

const Cs = [];

const js = {};

Object.freeze(Cs);

Object.freeze(js);

function $(t) {
    return new Proxy({}, new Os(t));
}

class Os {
    owner;
    ut=void 0;
    $=null;
    constructor(t) {
        this.owner = t;
    }
    get(t, n) {
        if (n === Ps) {
            return this.owner.constProps;
        }
        if (n === Rs) {
            return this.owner.varProps;
        }
        if (n === As) {
            return this.owner;
        }
        if (n === Ms) {
            return this;
        }
        let s;
        if (n === "children") {
            s = this.owner.children;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            s = Ds(this.owner, n);
            n in this.owner.varProps && Fs(this, n);
        }
        return s instanceof oi && s.h & 4 ? s.value : s;
    }
    set(t, n, s) {
        if (n === As) {
            this.owner = s;
        } else if (n === "children") {
            this.owner.children = s;
        } else if (n === Ps) {
            this.owner.constProps = s;
        } else if (n === Rs) {
            this.owner.varProps = s;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            this.owner.constProps && n in this.owner.constProps && delete this.owner.constProps[n];
            this.owner.varProps === js ? this.owner.varProps = {} : n in this.owner.varProps || (this.owner.toSort = !0);
            if (this.owner.varProps[n] !== s) {
                this.owner.varProps[n] = s;
                Ls(this, n);
            }
        }
        return !0;
    }
    deleteProperty(t, n) {
        let e = delete this.owner.varProps[n];
        e && Ls(this, n);
        this.owner.constProps && (e = delete this.owner.constProps[n] || e);
        if (this.owner.children != null && n === "children") {
            this.owner.children = null;
            e = !0;
        }
        return e;
    }
    has(t, n) {
        if (n === "children") {
            return this.owner.children != null;
        }
        if (n === Ps || n === Rs) {
            return !0;
        }
        const s = n in this.owner.varProps;
        if (typeof n === "string") {
            s && Fs(this, n);
            if (typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
        }
        return s || !!this.owner.constProps && n in this.owner.constProps;
    }
    getOwnPropertyDescriptor(t, n) {
        const e = n === "children" ? this.owner.children : this.owner.constProps && n in this.owner.constProps ? this.owner.constProps[n] : this.owner.varProps[n];
        return {
            configurable: !0,
            enumerable: !0,
            value: e
        };
    }
    ownKeys() {
        const t = Object.keys(this.owner.varProps);
        this.owner.children != null && t.push("children");
        if (this.owner.constProps) {
            for (const n in this.owner.constProps) {
                t.indexOf(n) === -1 && t.push(n);
            }
        }
        return t;
    }
}

const Fs = (t, n) => {
    const e = Ec();
    e && t.$ === null && e.$ && (t.$ = e.$);
    const s = e?.Ot;
    s && _n(t.owner._proxy, n, t, s);
};

const Ls = (t, n) => {
    const e = function s(t, n) {
        return t?.get(n);
    }(t.ut, n);
    e && Ul(t.$, t, e);
    return !!e;
};

const Ds = (t, n) => t.constProps && n in t.constProps ? t.constProps[n] : t.varProps[n];

const Vs = (t, n) => Ws(t)?.[n] || Us(t)?.[n] || null;

const Ws = t => {
    if (!t) {
        return null;
    }
    return Rs in t ? "children" in t ? {
        ...t[Rs],
        children: t.children
    } : t[Rs] : t;
};

const Us = t => {
    if (!t) {
        return null;
    }
    return Ps in t ? t[Ps] : null;
};

const Xs = t => t && Rs in t;

const zs = t => (n, ...e) => t.call(null, lf(n), ...e);

class Bs extends xs {
    constructor(t, n) {
        super(t, n, 17);
    }
    Tn=!1;
    p() {
        if (!(this.h & 1)) {
            return;
        }
        Fl(this.Zt);
        const t = Pc(this.Zt.resolved);
        const {deserialize: n, initial: e} = t;
        const s = t.update;
        const o = this.Gt === bs ? e : this.Gt;
        const r = Ac(() => this.Tn ? s?.(o) || o : n(o), this, ".", this.$);
        this.Tn = !0;
        this.h &= -2;
        const i = this.Tn && r !== "undefined" || r !== this.Gt;
        if (i) {
            this.Gt = r;
            Ul(this.$, this, this.ut);
        }
    }
}

const Hs = (t, n) => new xs(n?.container || null, t, zl(n?.serializationStrategy || "always"));

const Js = (t, n) => new Ts(n?.container || null, t, zl(n?.serializationStrategy || "always"), n);

const Qs = t => new Bs(null, t);

const Ys = t => new Es(null, t);

const Gs = /*#__PURE__*/ zs(Hs);

const Ks = /*#__PURE__*/ zs(Js);

const Zs = zs(Qs);

const ti = t => t.value;

const ni = (t, n) => t[n];

const ei = t => {
    if (t.length === 1) {
        if (Ll(t[0])) {
            return t[0].Kt ||= new oi(null, ti, t, null);
        }
        if (Zl(t[0])) {
            return new oi(null, ti, t, null);
        }
        return t[0].value;
    }
    return new oi(null, ni, t, null);
};

const ri = (...t) => {
    const n = t[0];
    const e = t.length < 2 ? "value" : t[1];
    if (!ye(n)) {
        return n[e];
    }
    if (Ll(n)) {
        if (n instanceof oi && n.h & 4) {
            return n;
        }
        return ei(t);
    }
    if (Xs(n)) {
        const s = n[Ps];
        const o = n[Rs];
        if (s && Object.prototype.hasOwnProperty.call(s, e)) {
            return s[e];
        }
        if (Object.prototype.hasOwnProperty.call(o, e)) {
            const n = o[e];
            return si(n, t);
        }
    } else {
        const s = Ql(n);
        if (s) {
            const n = s[e];
            return si(n, t);
        }
    }
    return n[e];
};

const si = (t, n) => Ll(t) ? t : ei(n);

const ii = (t, n) => {
    const e = ri(t, n);
    if (e === Ns) {
        return t[n];
    }
    return e;
};

class oi extends Es {
    lt;
    ot;
    kt;
    h;
    m=void 0;
    [es]=void 0;
    constructor(t, n, e, s, o = 5) {
        super(t, bs);
        this.lt = e;
        this.ot = n;
        this.kt = s;
        this.h = o;
    }
    invalidate() {
        this.h |= 1;
        try {
            this.p();
        } catch (t) {
            if (this.$ && this.m) {
                this.$.setHostProp(this.m, ws, this);
                sn(this.$, this.m, 16);
            }
        }
        if (this.h & 2) {
            this.h &= -3;
            Ul(this.$, this, this.ut);
        }
    }
    get untrackedValue() {
        this.p();
        return this.Gt;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = Ac(() => this.ot(...this.lt), this, ".", this.$);
        this.h &= -3;
        const n = t !== this.Gt;
        if (n) {
            this.h |= 2;
            this.Gt = t;
        }
    }
    st() {
        return this.ot === ti && Ll(this.lt[0]) ? this.lt[0] : this;
    }
    set value(t) {
        throw ve(31);
    }
    get value() {
        return super.value;
    }
}

class li {
    data;
    constructor(t) {
        this.data = t;
    }
}

const ui = (t, n) => {
    if (typeof t === "string") {
        const e = Qn(n);
        Hc(Jc(e, t));
    }
    return null;
};

function y(t, n) {
    ui(this, n);
    const e = Bc[0];
    e.value = n.type === "number" ? n.valueAsNumber : n.value;
}

function m(t, n) {
    ui(this, n);
    const e = Bc[0];
    e.value = n.checked;
}

function w(t, n) {
    ui(this, n);
    if (Bc) {
        for (let t = 0; t < Bc.length; t++) {
            const n = Bc[t];
            n instanceof Ts && n.h & 64 && n.p();
        }
    }
}

class ci {
    type;
    children;
    flags;
    toSort;
    key;
    varProps;
    constProps;
    dev;
    _proxy=null;
    constructor(t, n, e, s, o, r, i, c) {
        this.type = t;
        this.children = s;
        this.flags = o;
        this.toSort = !!i;
        this.key = r === null || r === void 0 ? null : typeof r === "string" ? r : "" + r;
        this.varProps = !n || Kr(n) ? js : n;
        this.constProps = !e || Kr(e) ? null : e;
    }
    get props() {
        return this._proxy ||= $(this);
    }
}

const fi = (t, n, e) => {
    let s = t[n];
    if (!s) {
        t[n] = e;
        return !0;
    }
    Array.isArray(s) ? s.push(e) : s = t[n] = [ s, e ];
};

const ai = t => t instanceof ci;

const hi = "bind:value";

const di = "bind:checked";

const pi = "passive:";

const $i = "preventdefault:";

const yi = Object.prototype.hasOwnProperty;

const mi = (t, n, e, s, o = !1) => {
    let r = t;
    let i = o;
    if (n.length > 0) {
        if (!i) {
            r = {
                ...r
            };
            i = !0;
        }
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            delete r[e];
        }
    }
    if (e.length > 0) {
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (s.has(vr(n.slice(15)))) {
                if (!i) {
                    r = {
                        ...r
                    };
                    i = !0;
                }
                delete r[n];
            }
        }
    }
    return r;
};

const wi = t => {
    if (t.startsWith("on") && t.endsWith("$")) {
        return vr(t.slice(2, -1));
    }
    if (t.startsWith("window:on") && t.endsWith("$")) {
        return vr(t.slice(9, -1));
    }
    if (t.startsWith("document:on") && t.endsWith("$")) {
        return vr(t.slice(11, -1));
    }
    return null;
};

const bi = (t, n, s, o, r = !1) => {
    let i = t;
    let c = r;
    for (let t = 0; t < n.length; t++) {
        const r = n[t];
        const l = wi(r);
        const u = e(r, o.has(l));
        if (u) {
            if (!c) {
                i = {
                    ...i
                };
                c = !0;
            }
            const t = s.get(u);
            (t === void 0 || t < s.get(r)) && (i[u] = i[r]);
            delete i[r];
        }
    }
    return i;
};

const vi = (t, n, e, s, o, r, i) => new ci(t, n, e, s, o, r, !1, i);

const gi = (t, n, e, s, o, r, i) => {
    let c = !1;
    let l = !1;
    let u = !1;
    let f = null;
    let a = null;
    if (typeof t === "string") {
        const t = new Set;
        const s = [];
        const o = [];
        const r = [];
        const i = [];
        const h = [];
        const d = [];
        const p = new Map;
        const $ = new Map;
        if (e) {
            let n = 0;
            for (const o in e) {
                p.set(o, n++);
                if (o.startsWith(pi)) {
                    r.push(o);
                    t.add(vr(o.slice(8)));
                } else {
                    o.startsWith($i) ? h.push(o) : wi(o) !== null ? s.push(o) : o === di ? a = e[o] : o === hi && (f = e[o]);
                }
            }
        }
        if (n) {
            let e = 0;
            for (const s in n) {
                $.set(s, e++);
                if (s.startsWith(pi)) {
                    i.push(s);
                    t.add(vr(s.slice(8)));
                } else {
                    s.startsWith($i) ? d.push(s) : wi(s) !== null ? o.push(s) : s === di ? a = n[s] : s === hi && (f = n[s]);
                }
            }
        }
        if (e) {
            const n = e;
            e = mi(e, r, h, t, l);
            l = l || e !== n;
            e = bi(e, s, p, t, l);
            l = l || e !== n;
        }
        if (n) {
            const e = n;
            n = mi(n, i, d, t, u);
            u = u || n !== e;
            n = bi(n, o, $, t, u);
            u = u || n !== e;
            c = c || o.length > 0;
        }
        if (a || f) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n ||= {};
            if (a) {
                n && yi.call(n, di) && delete n[di];
                if (e && yi.call(e, di)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[di];
                }
                n.checked = a;
                const t = Kc(null, "_chk", m, null, [ a ]);
                if (e && yi.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = fi(n, "q-e:input", t) || c;
                }
                c = fi(n, "q-e:input", t) || c;
            } else if (f) {
                n && yi.call(n, hi) && delete n[hi];
                if (e && yi.call(e, hi)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[hi];
                }
                n.value = f;
                const t = Kc(null, "_val", y, null, [ f ]);
                if (e && yi.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = fi(n, "q-e:input", t) || c;
                }
                c = fi(n, "q-e:input", t) || c;
            }
        }
        if (n && yi.call(n, "className")) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n.class = n.className;
            n.className = void 0;
            c = !0;
        }
        if (e && yi.call(e, "className")) {
            if (!l) {
                e = {
                    ...e
                };
                l = !0;
            }
            e.class = e.className;
            e.className = void 0;
        }
    }
    if (n) {
        for (const t in n) {
            if (t === "children") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                s ||= n.children;
                delete n.children;
            } else if (t === "key") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                r ||= n.key;
                delete n.key;
            } else if (e && t in e) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            } else if (n[t] === null) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            }
        }
    }
    return new ci(t, n, e, s, o, r, c || !0, i);
};

const _i = (t, n, e, s) => xi(t, n, s);

const Si = (t, n, e, s, o) => xi(t, {
    ...e,
    ...n
}, o);

const ki = (t, n, e, s, o, r) => xi(t, {
    ...e,
    ...n,
    children: s
}, r);

const Ei = t => t.children;

const xi = (t, n, e, s, o) => gi(t, n, null, null, 0, e, o);

const qi = xi;

const Ti = xi;

function b(t, n, ...e) {
    const s = {
        children: arguments.length > 2 ? e.flat(100) : null
    };
    let o = null;
    for (const t in n) {
        t == "key" ? o = n[t] : s[t] = n[t];
    }
    return gi(t, n, null, s.children, 0, o);
}

const Pi = t => t.children;

const Ri = (t, n) => new ci(Ei, null, null, t.children, 0, n);

const Ai = (t, n, e, s, o) => {
    const r = ee(t.Ct, e || n, t);
    if (e) {
        r.Ot = p(e, ":");
        r.$ = t;
    }
    let i;
    t.ensureProjectionResolved(n);
    let c = !1;
    s === null && (s = t.getHostProp(n, xe));
    if (_e(s)) {
        o = o || t.getHostProp(n, Ke) || js;
        "children" in o && delete o.children;
        i = s.getFn(r);
    } else if (df(s)) {
        const t = s;
        i = () => ne(r, t, [ o || js, null, 0 ]);
    } else {
        c = !0;
        const t = s;
        i = () => ne(r, t, [ o || js ]);
    }
    const l = oe;
    const u = (e = 0) => pr(() => {
        if (!c) {
            t.setHostProp(n, tr, null);
            t.setHostProp(n, ir, null);
        }
        e > 0 && ko(n) && pn(t, n);
        return $r(i(o), t => $r(r.Ft, () => t));
    }, s => {
        if (l && !c) {
            const t = n;
            if (t.dirty & 4) {
                t.dirty &= -5;
                if (e < hr) {
                    return u(e + 1);
                }
            }
        }
        const o = t.getHostProp(n, sr);
        if (o) {
            return function r(t, n) {
                const e = S(t);
                let s = t;
                const o = "q-e:qvisible";
                return $r(e, t => {
                    const e = !t;
                    let r = null;
                    for (const i in n) {
                        if (Object.prototype.hasOwnProperty.call(n, i)) {
                            let c = t;
                            let l = i;
                            if (e) {
                                if (i !== o && !i.startsWith("q-d:") && !i.startsWith("q-w:")) {
                                    continue;
                                }
                                if (!r) {
                                    const [t, n] = k(s);
                                    s = n;
                                    r = t;
                                }
                                c = r;
                            }
                            if (c) {
                                c.type === "script" && i === o && (l = "q-d:qinit");
                                g(c, l, n[i]);
                            }
                        }
                    }
                    return s;
                });
            }(s, o);
        }
        return s;
    }, t => {
        if (dr(t) && e < hr) {
            return t.then(() => u(++e));
        }
        if (e >= hr) {
            throw Error("Max retry count of component execution reached");
        }
        throw t;
    });
    return u();
};

function g(t, n, e) {
    const s = t.constProps ||= {};
    const o = s[n];
    const r = e.qrls;
    o == null ? s[n] = r : Array.isArray(o) ? o.push(...r) : s[n] = [ o, ...r ];
    const i = t.varProps[n];
    if (i) {
        Array.isArray(o) ? o.push(...s[n]) : t.varProps[n] = [ o, ...r ];
        s[n] = void 0;
    }
    const c = e.capture;
    const l = e.preventdefault;
    const u = e.stoppropagation;
    if (!c && !l && !u) {
        return;
    }
    const [, f] = _r(n);
    c && _(t, f, "capture");
    l && _(t, f, "preventdefault");
    u && _(t, f, "stoppropagation");
}

function _(t, n, e) {
    const s = `${e}:${n}`;
    const o = t.varProps;
    o === js && (t.varProps = {});
    t.varProps[s] = !0;
}

function S(t) {
    const n = [ t ];
    for (;n.length; ) {
        const t = n.shift();
        if (ai(t)) {
            if (typeof t.type === "string") {
                return t;
            }
            n.push(t.children);
        } else if (me(t)) {
            n.push(...t);
        } else {
            if (dr(t)) {
                return $r(t, t => S(t));
            }
            if (Ll(t)) {
                return S(t.untrackedValue);
            }
        }
    }
    return null;
}

function k(t) {
    if (ai(t)) {
        const n = E();
        if (t.type !== Pi && !df(t.type)) {
            return [ n, vi(Pi, null, null, [ t, n ], 0, null) ];
        }
        t.children == null ? t.children = n : me(t.children) ? t.children.push(n) : t.children = [ t.children, n ];
        return [ n, t ];
    }
    if ((t => typeof t !== "object" && typeof t !== "function" || t === null || t === void 0)(t)) {
        const n = E();
        return [ n, vi(Pi, null, null, [ t, n ], 0, null) ];
    }
    if (me(t) && t.length > 0) {
        const [n, e] = k(t[0]);
        return [ n, t ];
    }
    return [ null, t ];
}

function E() {
    return new ci("script", null, {
        hidden: ""
    }, null, 0, null);
}

const Mi = t => vi(Ei, null, {
    [Re]: ""
}, t.children, 0, t.name ?? "");

const Ni = Symbol();

const Ii = () => null;

const Ci = () => null;

const ji = t => t.children;

const Oi = (t, n) => xi(Ri, {
    children: xi(Fi, t)
}, n);

const Fi = () => null;

let Li = null;

let Di = null;

function x(t, n, e, s) {
    if (e != null) {
        if (s) {
            const s = function o(t) {
                switch (t) {
                  case "xlink:href":
                  case "xlink:actuate":
                  case "xlink:arcrole":
                  case "xlink:role":
                  case "xlink:show":
                  case "xlink:title":
                  case "xlink:type":
                    return "http://www.w3.org/1999/xlink";

                  case "xml:base":
                  case "xml:lang":
                  case "xml:space":
                    return "http://www.w3.org/XML/1998/namespace";

                  default:
                    return null;
                }
            }(n);
            if (s) {
                ((t, n, e, s) => {
                    Di || (Di = t.setAttributeNS);
                    Di.call(t, n, e, s);
                })(t, s, n, e);
                return;
            }
        }
        ((t, n, e) => {
            Li || (Li = t.setAttribute);
            Li.call(t, n, e);
        })(t, n, e);
    }
}

function q(t) {
    return !t.startsWith("q:") && !t.startsWith(":");
}

const Vi = (t, n = [], e = {}) => {
    let s = null;
    const o = t[Ps];
    if (o) {
        for (const t in o) {
            if (!n.includes(t)) {
                s ||= {};
                s[t] = o[t];
            }
        }
    }
    const r = e;
    const i = t[Rs];
    for (const t in i) {
        n.includes(t) || (r[t] = i[t]);
    }
    return $(new ci(null, r, s, null, 0, null));
};

class Wi {
    target;
    constructor(t) {
        this.target = t;
    }
}

class Ui {
    target;
    constructor(t) {
        this.target = t;
    }
}

class Xi {
    target;
    text;
    constructor(t, n) {
        this.target = t;
        this.text = n;
    }
}

class zi {
    target;
    parent;
    beforeTarget;
    constructor(t, n, e) {
        this.target = t;
        this.parent = n;
        this.beforeTarget = e;
    }
}

class Bi {
    target;
    attrName;
    attrValue;
    scopedStyleIdPrefix;
    isSvg;
    constructor(t, n, e, s, o) {
        this.target = t;
        this.attrName = n;
        this.attrValue = e;
        this.scopedStyleIdPrefix = s;
        this.isSvg = o;
    }
}

const Hi = t => new Wi(t);

const Ji = t => new Ui(t);

const Qi = (t, n) => new Xi(t, n);

const Yi = (t, n, e) => new zi(t, n, e);

const Gi = (t, n, e, s = null, o = !1) => new Bi(t, n, e, s, o);

const Ki = () => {
    const t = qc();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, Ze);
    if (s === null) {
        s = [];
        t.$.setHostProp(e, Ze, s);
    }
    let o = t.$.getHostProp(e, tr);
    o === null && (o = 0);
    t.$.setHostProp(e, tr, o + 1);
    for (;s.length <= o; ) {
        s.push(void 0);
    }
    return {
        val: s[o],
        set: t => s[o] = t,
        i: o,
        iCtx: t
    };
};

const Zi = t => {
    const n = be(t) && !df(t) ? te(void 0, t) : t;
    return Ys(n);
};

const to = t => no(Zi, t);

const no = (t, ...n) => {
    const {val: e, set: s} = Ki();
    if (e != null) {
        return e;
    }
    t = be(t) && !df(t) ? Pc(t, ...n) : t;
    return s(t);
};

const eo = () => ({
    pending: Ys(0),
    version: Ys(0)
});

function T(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = A(t.container, n);
    if (!e) {
        return;
    }
    const s = t.boundaries ||= [];
    if (!s.includes(e)) {
        s.push(e);
        e.pending.value++;
    }
}

function P(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return t.getHostProp(n, lr);
}

function R(t) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    Mo(t, ur, null);
}

function A(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return function e(t) {
        if (!__EXPERIMENTAL__.suspense) {
            return null;
        }
        return Ao(t, ur, null) || null;
    }(n) || P(t, n);
}

function M(t, n) {
    __EXPERIMENTAL__.suspense && Mo(t, ur, n);
}

function N(t, n, e) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    M(n, e);
    const s = n.dirtyChildren;
    if (!s || s.length === 0) {
        return;
    }
    for (let n = 0; n < s.length; n++) {
        const o = s[n];
        N(t, o, P(t, o) || e);
    }
}

const ro = t => {
    if (t.En) {
        try {
            t.En();
        } catch (t) {
            ((t, ...n) => {
                fe(!1, t, ...n);
            })(t);
        }
        t.En = null;
    }
};

function I(t, e, s, o) {
    if (!s.isConnected) {
        return;
    }
    o || (o = Tc(e, s));
    const r = o.$;
    const i = o.m;
    Co(r, i);
    let c = t;
    if (i.flags & 64) {
        let n;
        if (!(i.flags & 128)) {
            n = !0;
            i.flags |= 128;
        }
        const o = n ? r._ : null;
        const l = Ao(i, nr, o);
        if (l !== null) {
            c = () => t(e, s, l);
        } else {
            const n = Ao(i, er, o);
            n !== null && (c = () => t(e, s, ...n));
        }
    }
    return n(() => {
        if (!(i.flags & 32)) {
            return ne(o, c, [ e, s ]);
        }
    }, t => r.handleError(t, i));
}

function C(t, n) {
    if (!n.isConnected) {
        return;
    }
    const e = Tc(t, n);
    typeof this === "string" && Hc(Jc(e.$, this));
    const s = Bc[0];
    return I(s, t, n, e);
}

function j(t) {
    return t.k === t.q ? t.T : null;
}

function O(t) {
    return t.R || j(t);
}

function F(t, n) {
    const e = function s(t) {
        return t ? t.nextSibling : null;
    }(n);
    const o = j(t);
    return e === o ? null : e;
}

const so = Object.prototype.hasOwnProperty;

function L(t, n, e, s, o, r) {
    Mo(n, e, r);
    on(t, Gi(n.node, e, s, o, (n.flags & 512) !== 0));
}

function D(t, n, e, s) {
    return {
        $: t,
        M: n,
        N: e,
        j: s,
        O: [],
        L: [],
        D: [],
        k: null,
        R: null,
        W: null,
        T: null,
        q: null,
        U: null,
        X: null,
        B: null,
        H: null,
        J: null,
        Y: 0,
        G: 0,
        K: !0,
        Z: !1,
        tt: {
            nt: new li({
                j: s,
                et: !0
            }),
            rt: new li({
                j: s,
                et: !1
            })
        }
    };
}

function V(t, n, e, s, o) {
    const r = t ?? D(n, e, s, o);
    (function i(t, n, e, s, o) {
        t.$ = n;
        t.M = e;
        t.N = s;
        t.j = o;
        t.tt.nt.data.j = o;
        t.tt.rt.data.j = o;
        t.L.length = 0;
        t.D.length = 0;
    })(r, n, e, s, o);
    return r;
}

const io = (t, n, e, s, o, r, i) => W(V(i, t, n, o, r), e, s);

const oo = (t, n, e, s, o, r, i, c, l = !1, u) => W(V(u, t, n, i, c), e, s, o, r, l);

function W(t, n, e, s = ol(e), o = null, r = !1) {
    U(t, n, e, s, o, r);
    const i = Z(t);
    if (dr(i)) {
        return i.finally(() => {
            tt(t);
        });
    }
    tt(t);
}

function U(t, n, e, s = ol(e), o = null, r = !1) {
    const i = t.Z;
    t.Z = r || i;
    t.k = e;
    t.W = null;
    t.R = s;
    t.T = o;
    t.q = e;
    J(t, n, !0);
    try {
        if (t.k.flags & 32) {
            return;
        }
        for (;t.O.length; ) {
            for (;t.Y < t.G; ) {
                if (typeof t.J === "string") {
                    bt(t, t.J);
                } else if (typeof t.J === "number") {
                    bt(t, t.J + "");
                } else if (t.J && typeof t.J === "object") {
                    if (ai(t.J)) {
                        const n = t.J.type;
                        if (typeof n === "string") {
                            rt(t);
                            at(t, t.J, n);
                            const e = t.J.constProps && so.call(t.J.constProps, fr) || so.call(t.J.varProps, fr);
                            e ? t.W || nt(t, !1) : B(t, t.J.children, !0);
                        } else if (typeof n === "function") {
                            if (n === Pi) {
                                rt(t);
                                $t(t, "F", t.J.key);
                                B(t, t.J.children, !0);
                            } else if (n === Mi) {
                                rt(t);
                                G(t) || B(t, t.J.children, !0);
                            } else if (n === _t) {
                                Y(t);
                                B(t, t.J.children, !0, !1);
                            } else if (n === Ci) {
                                et(t);
                            } else if (n === Ii) {
                                et(t);
                            } else {
                                rt(t);
                                yt(t, n);
                            }
                        }
                    } else if (Array.isArray(t.J)) {
                        B(t, t.J, !1);
                    } else if (Ll(t.J)) {
                        $t(t, "S", null);
                        const n = t.J instanceof oi ? t.J.st() : t.J;
                        const e = t.R?.[es]?.get(".")?.backRef;
                        let s = e?.has(n);
                        e && n instanceof oi && (s = Pt(e, n));
                        if (!s) {
                            const e = t.W || t.R;
                            B(t, X(t, () => Mc(n, e, ".", t.$)), !0);
                        }
                    } else if (dr(t.J)) {
                        $t(t, "A", null);
                        t.L.push(t.J, t.W || t.R);
                    }
                } else {
                    t.J === Ni || bt(t, "");
                }
                z(t);
            }
            et(t);
            K(t);
            H(t);
        }
    } finally {
        t.Z = i;
    }
}

function X(t, e) {
    try {
        return e();
    } catch (s) {
        if (dr(s)) {
            const o = s.then(() => n(e));
            t.L.push(o, t.W || t.R);
            return null;
        }
        throw s;
    }
}

function z(t) {
    if (!t.K) {
        t.K = !0;
        return;
    }
    t.Y++;
    if (t.Y < t.G) {
        t.J = t.H[t.Y];
    } else if (t.O.length > 0 && t.O[t.O.length - 1] === !1) {
        return H(t);
    }
    t.W !== null ? t.W = null : t.R = F(t, t.R);
}

function B(t, n, e, s = !0) {
    if (s && (n == null || e && me(n) && n.length === 0)) {
        nt(t);
        return;
    }
    J(t, n, e);
    if (e) {
        const n = t.Z || !!t.W || !ol(t.R);
        t.Z = n;
        t.B = null;
        t.U = null;
        t.X = null;
        t.k = t.W || t.R;
        t.R = ol(t.k);
        t.W = null;
    }
    t.K = !1;
}

function H(t) {
    const n = t.O.pop();
    if (n) {
        t.Z = t.O.pop();
        t.B = t.O.pop();
        t.U = t.O.pop();
        t.X = t.O.pop();
        t.W = t.O.pop();
        t.R = t.O.pop();
        t.k = t.O.pop();
    }
    t.J = t.O.pop();
    t.G = t.O.pop();
    t.Y = t.O.pop();
    t.H = t.O.pop();
    z(t);
}

function J(t, n, e) {
    t.O.push(t.H, t.Y, t.G, t.J);
    e && t.O.push(t.k, t.R, t.W, t.X, t.U, t.B, t.Z);
    t.O.push(e);
    if (Array.isArray(n)) {
        t.Y = 0;
        t.G = n.length;
        t.H = n;
        t.J = t.G > 0 ? n[0] : null;
    } else if (n === void 0) {
        t.Y = 0;
        t.J = null;
        t.H = null;
        t.G = 0;
    } else {
        t.Y = 0;
        t.J = n;
        t.H = null;
        t.G = 1;
    }
}

function Q(t) {
    if (t.W) {
        return O(t);
    }
    return F(t, t.R) || j(t);
}

function Y(t) {
    const n = t.J;
    const e = n.key;
    t.R = Ao(t.k, e, n => Lo(t.$.rootVNode, n));
    t.R = t.R && t.R.flags & 32 ? null : t.R;
    if (t.R == null) {
        t.W = So();
        Mo(t.W, Pe, e);
        t.W.slotParent = t.k;
        Mo(t.k, e, t.W);
    }
}

function G(t) {
    const n = t.J;
    const e = Nl(t.k);
    const s = function o(t, n) {
        const e = t.J;
        const s = e.constProps;
        if (s && typeof s == "object" && so.call(s, "name")) {
            const e = s.name;
            if (n && e instanceof oi) {
                return Mc(e, n, ":", t.$);
            }
        }
        return Ds(e, "name") || "";
    }(t, e);
    const r = Ds(n, lr) || null;
    const i = e ? Ao(e, s, null) : null;
    if (i == null) {
        t.W = So();
        Mo(t.W, Pe, s);
        Mo(t.W, lr, r);
        N(t.$, t.W, r);
        e && Mo(e, s, t.W);
        Ko(t.M, t.k, t.W, Q(t));
        return !1;
    }
    if (i === t.R) {} else {
        const n = i.parent;
        t.W = i;
        Mo(t.W, Pe, s);
        Mo(t.W, lr, r);
        N(t.$, t.W, r);
        e && Mo(e, s, t.W);
        Go(t.M, t.W);
        Ko(t.M, t.k, t.W, Q(t));
        n && Eo(n) && !n.firstChild && rl(n) === ze && nl(t.M, n.parent, n, !0);
    }
    return !0;
}

function K(t) {
    const n = t.B;
    if (n) {
        for (const e of n.values()) {
            if (e.flags & 32) {
                continue;
            }
            Et(t.$, t.M, e, t.N);
            nl(t.M, t.k, e, !0);
        }
        n.clear();
        t.B = null;
    }
    t.R = null;
}

function Z(t) {
    for (;t.L.length; ) {
        const n = t.L.shift();
        const e = t.L.shift();
        if (dr(n)) {
            return n.then(n => {
                U(t, n, e);
                return Z(t);
            }).catch(n => {
                t.$.handleError(n, e);
                return Z(t);
            });
        }
        U(t, n, e);
    }
    if (t.D.length) {
        const n = t.D.splice(0);
        return Promise.all(n).then(() => Z(t));
    }
}

function tt(t) {
    t.M = null;
    t.N = null;
}

function nt(t, n = !0) {
    const e = t.R && ol(t.R);
    if (e !== null) {
        let s = e;
        for (;s; ) {
            Et(t.$, t.M, s, t.N);
            s = s.nextSibling;
        }
        el(t.M, t.R, e, n);
    }
}

function et(t) {
    const n = j(t);
    if (t.R !== null && t.R !== n) {
        for (;t.R && t.R !== n; ) {
            const n = t.R;
            t.R = F(t, t.R);
            if (t.k === n.parent) {
                Et(t.$, t.M, n, t.N);
                nl(t.M, t.k, n, !0);
            }
        }
    }
}

function rt(t) {
    if (t.R !== null && To(t.R)) {
        const n = t.R;
        t.R = F(t, t.R);
        nl(t.M, t.k, n, !0);
    }
}

function st(t, n, e) {
    if (Ll(t)) {
        t.value = n;
        return !0;
    }
    if (typeof t === "function") {
        t(n);
        return !0;
    }
    if (t == null) {
        return !0;
    }
    throw ve(15, [ e ]);
}

function it(t, e, s, o, r) {
    return n(() => Mc(o, e, s, t, r));
}

function ot(t, n, e, s, o) {
    const i = t.j;
    const c = s.then(t => x(n, e, r(e, t, i), o));
    t.D.push(c);
}

function lt(t, n) {
    if (n) {
        t.innerHTML = n + "";
        t.setAttribute(Ue, "html");
    }
}

function ut(t, n) {
    if (n && typeof n !== "string") {
        return !0;
    }
    t.value = function e(t) {
        let n = "";
        const e = t.length;
        let s = 0;
        let o = s;
        for (;s < e; s++) {
            const e = t.charCodeAt(s);
            if (e === 60) {
                n += t.substring(o, s) + "&lt;";
            } else if (e === 62) {
                n += t.substring(o, s) + "&gt;";
            } else if (e === 38) {
                n += t.substring(o, s) + "&amp;";
            } else if (e === 34) {
                n += t.substring(o, s) + "&quot;";
            } else {
                if (e !== 39) {
                    continue;
                }
                n += t.substring(o, s) + "&#39;";
            }
            o = s + 1;
        }
        return o === 0 ? t : n + t.substring(o);
    }(n || "");
    return !0;
}

function ct(t, n, e, s) {
    const i = function c(t, n) {
        const e = tl(t.k, !0);
        const s = o(e, n);
        const r = document;
        const i = s.elementNamespaceFlag === 0 ? r.createElement(n) : r.createElementNS(s.elementNamespace, n);
        t.W = vo(i, n);
        t.W.flags |= s.elementNamespaceFlag;
        return i;
    }(t, e);
    const l = t.W;
    const u = (l.flags & 512) !== 0;
    const {constProps: f} = n;
    if (f) {
        for (const n in f) {
            let o = f[n];
            if (br(n)) {
                ft(n, o, i, l, t);
                continue;
            }
            if (n === "ref" && st(o, i, s)) {
                continue;
            }
            Ll(o) && (o = it(t.$, t.W, n, o, t.tt.nt));
            if (dr(o)) {
                ot(t, i, n, o, u);
                continue;
            }
            if (n === fr) {
                lt(i, o);
                continue;
            }
            if (e === "textarea" && n === "value" && ut(i, o)) {
                continue;
            }
            x(i, n, r(n, o, t.j), u);
        }
    }
    const a = n.key;
    a && (t.W.key = a);
    if (t.j) {
        const e = so.call(n.varProps, "class") || n.constProps && so.call(n.constProps, "class");
        e || i.setAttribute("class", t.j);
    }
    Bo(t.M, t.k, t.W, O(t));
}

function ft(t, n, e, s, o) {
    const r = t.slice(2);
    if (Array.isArray(n)) {
        const t = n;
        const s = [];
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            if (Array.isArray(e)) {
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    n && s.push(I.bind(null, n));
                }
            } else {
                e && s.push(I.bind(null, e));
            }
        }
        s.length > 0 && ((e._qDispatch ||= {})[r] = s.length === 1 ? s[0] : s);
    } else {
        n && ((e._qDispatch ||= {})[r] = I.bind(null, n));
    }
    t.charAt(2) !== "e" && No(o.M, s, t, "");
    (function i(t, n) {
        const e = window;
        e && (e._qwikEv ||= []).push(n);
    })(0, r);
}

function at(t, n, e) {
    if (t.Z) {
        ct(t, n, e, null);
    } else {
        const s = t.R && Eo(t.R);
        const o = s && e === rl(t.R);
        const r = n.key;
        const i = s && t.R.key;
        if (o && r === i) {
            dt(t, e, r);
        } else {
            const s = ht(e, r);
            pt(t, e, r, s, t.k) && ct(t, n, e, null);
        }
    }
    const s = n.varProps;
    const o = t.W || t.R;
    s && function r(t, n, e, s) {
        t.Z || Co(t.$, n);
        const o = n.props;
        for (const r in e) {
            const i = e[r];
            if (o && so.call(o, r)) {
                const e = o[r];
                if (i !== e) {
                    if (i instanceof oi && e instanceof oi && Tt(i, e)) {
                        continue;
                    }
                    lo(t, n, r, i, s);
                }
            } else {
                i != null && lo(t, n, r, i, s);
            }
        }
        if (o) {
            for (const r in o) {
                so.call(e, r) || r.charAt(0) === ":" || br(r) || lo(t, n, r, null, s);
            }
        }
    }(t, o, s, null);
}

const lo = (t, n, e, s, o) => {
    if (br(e)) {
        ft(e, s, n.node, n, t);
        return;
    }
    if (e === nr || e === er) {
        Mo(n, e, s);
        n.flags |= 192;
        return;
    }
    const r = s;
    if (e === "ref") {
        const t = n.node;
        if (st(s, t, o)) {
            return;
        }
    }
    const i = n[es]?.get(e);
    if (Ll(s)) {
        const o = s instanceof oi ? s.st() : s;
        if (i?.backRef?.has(o)) {
            return;
        }
        i && $n(t.$, i);
        const r = n;
        s = it(t.$, r, e, o, t.tt.rt);
    } else {
        i && $n(t.$, i);
    }
    if (dr(s)) {
        const o = n;
        const i = s.then(n => {
            L(t.M, o, e, n, t.j, r);
        });
        t.D.push(i);
        return;
    }
    L(t.M, n, e, s, t.j, r);
};

function ht(t, n) {
    if (n == null) {
        return null;
    }
    return t ? t + ":" + n : n;
}

function dt(t, n, e) {
    const s = ht(n, e);
    if (s && t.B?.has(s)) {
        t.B.delete(s);
        return !0;
    }
    return !1;
}

function pt(t, n, e, s, o, r) {
    t.W = function i(t, n, e) {
        let s = null;
        if (t.U === null) {
            const o = t.R;
            if (o) {
                const s = Eo(o) ? rl(o) : null;
                const r = vt(o) || gt(o, t.$._);
                if (r === e && s === n) {
                    return o;
                }
            }
            t.U = new Map;
            t.X = [];
            const r = j(t);
            let i = t.R;
            for (;i && i !== r; ) {
                const o = Eo(i) ? rl(i) : null;
                const r = vt(i) || gt(i, t.$._);
                s === null && r == e && o == n ? s = i : r === null ? t.X.push(o, i) : t.U.set(ht(o, r), i);
                i = i.nextSibling;
            }
        } else if (e === null) {
            for (let e = 0; e < t.X.length; e += 2) {
                if (t.X[e] === n) {
                    s = t.X[e + 1];
                    t.X.splice(e, 2);
                    break;
                }
            }
        } else {
            const o = ht(n, e);
            const r = t.U.get(o);
            if (r) {
                s = r;
                t.U.delete(o);
            }
        }
        (function o(t, n) {
            if (!n) {
                if (t.R) {
                    const n = Eo(t.R) ? rl(t.R) : null;
                    const e = vt(t.R) || gt(t.R, t.$._);
                    if (e != null) {
                        const s = ht(n, e);
                        t.B ||= new Map;
                        t.B.set(s, t.R);
                        t.U?.delete(s);
                    }
                }
                return;
            }
            const e = j(t);
            let s = t.R;
            for (;s && s !== n && s !== e; ) {
                const n = Eo(s) ? rl(s) : null;
                const e = vt(s) || gt(s, t.$._);
                if (e != null) {
                    const o = ht(n, e);
                    t.B ||= new Map;
                    t.B.set(o, s);
                    t.U?.delete(o);
                }
                s = s.nextSibling;
            }
        })(t, s);
        return s;
    }(t, n, e);
    if (t.W) {
        s || Ko(t.M, o, t.W, O(t));
        t.R = t.W;
        t.W = null;
        return !1;
    }
    if (s != null) {
        const n = t.B?.get(s) || null;
        if (n) {
            t.B.delete(s);
            if (r && t.R) {
                const n = vt(t.R) || gt(t.R, t.$._);
                if (n != null) {
                    const e = Eo(t.R) ? rl(t.R) : null;
                    const s = ht(e, n);
                    if (s != null) {
                        t.B ||= new Map;
                        t.B.set(s, t.R);
                    }
                }
            }
            n !== t.R && Ko(t.M, o, n, O(t));
            t.R = n;
            t.W = null;
            return !1;
        }
    }
    return !0;
}

function $t(t, n, e) {
    const s = n === "F";
    const o = vt(t.R);
    const r = t.R && Po(t.R);
    const i = r && o === e && (!s || !!e);
    if (i) {
        dt(t, null, o);
        return;
    }
    if (e === null || t.Z) {
        Ho(t.M, t.k, t.W = So(), Q(t));
        t.W.key = e;
        return;
    }
    if (pt(t, null, e, ht(null, e), t.k, !0)) {
        Ho(t.M, t.k, t.W = So(), Q(t));
        t.W.key = e;
    }
}

function yt(t, n) {
    const e = n[hf];
    let s = t.W || t.R;
    const o = t.J;
    if (e) {
        const n = o.props;
        let r = !1;
        const [i] = e;
        const c = i.it;
        const l = gt(s, t.$._);
        const u = o.key || c;
        const f = vt(s) || l;
        const a = u === f;
        const h = c === l;
        if (a) {
            if (h) {
                dt(t, null, u);
            } else {
                mt(t, s, i, n);
                s = t.W;
                r = !0;
            }
        } else {
            if (pt(t, null, u, u, t.k)) {
                mt(t, s, i, n);
                r = !0;
            }
            s = t.W || t.R;
        }
        if (s) {
            const e = Ao(s, Ke, t.$._);
            if (!r) {
                const c = function l(t, n, e, s) {
                    let o = !1;
                    if (e) {
                        const t = St(n[Ps], e[Ps], e[Ms], s, !1);
                        o ||= t;
                        const r = St(n[Rs], e[Rs], e[Ms], s, !0);
                        o ||= r;
                        e[As] = n[As];
                    } else if (n) {
                        Mo(t, Ke, n);
                        e = n;
                    }
                    return o;
                }(s, n, e, t.$);
                if (c && o.key == null) {
                    mt(t, s, i, n);
                    s = t.W;
                    r = !0;
                }
                r ||= c;
            }
            if (r) {
                Mo(s, xe, i);
                s.flags &= -33;
                sn(t.$, s, 4, t.N);
            }
        }
        (function d(t, n, e) {
            const s = Array.isArray(n) ? n : [ n ];
            const o = t => new ci(_t, null, null, [], 0, t);
            const r = [];
            if (e) {
                const t = e.props;
                if (t) {
                    for (const n in t) {
                        if (q(n)) {
                            const t = n;
                            he(r, t, o(t), 0);
                        }
                    }
                }
            }
            if (r.length === 0 && n == null) {
                return;
            }
            for (let t = 0; t < s.length; t++) {
                const n = s[t];
                const e = (ai(n) && Ds(n, Pe) || "") + "";
                const i = ae(r, e, 0);
                let c;
                i >= 0 ? c = r[i + 1] : r.splice(~i, 0, e, c = o(e));
                const l = n === !1;
                l || c.children.push(n);
            }
            for (let t = r.length - 2; t >= 0; t -= 2) {
                r.splice(t, 1);
            }
            B(t, r, !0);
        })(t, o.children, s);
    } else {
        const e = o.key;
        const r = vt(s);
        const i = e === r;
        const c = gt(s, t.$._);
        const l = c == null;
        if (s && !l || !s) {
            wt(t);
            s = t.W;
        } else if (i) {
            dt(t, null, e);
        } else {
            pt(t, null, e, e, t.k) && wt(t);
            s = t.W || t.R;
        }
        if (s) {
            let e = s;
            for (;e && (!Po(e) || Ao(e, xe, null) === null); ) {
                e = e.parent || Nl(e);
            }
            const r = Ai(t.$, s, e || t.$.rootVNode, n, o.props);
            t.L.push(r, s);
        }
    }
}

function mt(t, n, e, s) {
    n && pn(t.$, n);
    Ho(t.M, t.k, t.W = So(), Q(t));
    const o = t.J;
    Mo(t.W, xe, e);
    Mo(t.W, Ke, s);
    t.W.key = o.key;
}

function wt(t) {
    Ho(t.M, t.k, t.W = So(), Q(t));
    const n = t.J;
    Mo(t.W, Ke, n.props);
    n.key && (t.W.key = n.key);
}

function bt(t, n) {
    if (t.R !== null) {
        const e = Al(t.R);
        if (e === 3) {
            if (n !== sl(t.R)) {
                il(t.M, t.R, n);
                return;
            }
            return;
        }
    }
    Bo(t.M, t.k, t.W = _o(document.createTextNode(n), n), O(t));
}

function vt(t) {
    if (t == null || To(t)) {
        return null;
    }
    return t.key;
}

function gt(t, n) {
    if (t == null || To(t)) {
        return null;
    }
    const e = Ao(t, xe, n);
    return e ? e.it : null;
}

function _t() {}

function St(t, n, e, s, o = !0) {
    if (kt(t) && kt(n)) {
        return !1;
    }
    e.$ = s;
    let r = !1;
    if (t) {
        for (const s in t) {
            if (s === "children" || s === je) {
                continue;
            }
            if (!n || t[s] !== n[s]) {
                if (!o) {
                    return !0;
                }
                {
                    n && (n[s] = t[s]);
                    const o = Ls(e, s);
                    o || (r = !0);
                }
            }
        }
    }
    if (n) {
        for (const s in n) {
            if (s === "children" || s === je) {
                continue;
            }
            if ((!t || !so.call(t, s)) && o) {
                delete n[s];
                const t = Ls(e, s);
                t || (r = !0);
            }
        }
    }
    return r;
}

function kt(t) {
    if (!t) {
        return !0;
    }
    return Kr(t);
}

function Et(t, n, e, s = null) {
    let o = e;
    if (To(e)) {
        qt(o);
        return;
    }
    let r = null;
    for (;;) {
        const i = o.flags;
        if (i & 3) {
            pn(t, o);
            qt(o);
            const r = i & 2 && Ao(o, xe, null) !== null;
            if (r) {
                const e = t.getHostProp(o, Ze);
                if (e) {
                    for (let n = 0; n < e.length; n++) {
                        const r = e[n];
                        if (ye(r)) {
                            const n = Ol(r);
                            if (n && r.h & 1) {
                                r.h |= 16;
                                sn(t, o, 64, s);
                                continue;
                            }
                            (r instanceof Es || Zl(r)) && pn(t, r);
                            (n || r instanceof Ts) && ro(r);
                        }
                    }
                }
                const r = o.props;
                if (r) {
                    const e = Object.keys(r);
                    for (let o = 0; o < e.length; o++) {
                        const i = e[o];
                        if (q(i)) {
                            const e = r[i];
                            if (e) {
                                r[i] = null;
                                const o = typeof e === "string" ? Lo(t.rootVNode, e) : e;
                                let c = ol(o);
                                for (;c; ) {
                                    Et(t, n, c, s);
                                    c = c.nextSibling;
                                }
                                xt(n, o);
                            }
                        }
                    }
                }
            }
            const c = Ro(o);
            if (c) {
                if (o === e) {
                    const t = ol(o);
                    if (t) {
                        cn(t, () => {});
                        return;
                    }
                }
            } else {
                const t = ol(o);
                if (t) {
                    o = t;
                    continue;
                }
            }
        } else {
            i & 4 && qt(o);
        }
        if (o === e) {
            return;
        }
        const c = o.nextSibling;
        if (c) {
            o = c;
            continue;
        }
        r = o.parent;
        for (;r; ) {
            if (r === e) {
                return;
            }
            const t = r.nextSibling;
            if (t) {
                o = t;
                break;
            }
            r = r.parent;
        }
        if (r == null) {
            return;
        }
    }
}

function xt(t, n) {
    const e = n.parent;
    if (e) {
        const s = e.flags;
        s & 1 && rl(e) === ze && nl(t, e, n, !0);
    }
}

function qt(t) {
    t.flags |= 32;
}

function Tt(t, n) {
    if (t === n) {
        return !0;
    }
    return n.ot === t.ot && function e(t, n) {
        if (t === n) {
            return !0;
        }
        if (!t || !n || t.length !== n.length) {
            return !1;
        }
        for (let e = 0; e < t.length; e++) {
            if (t[e] !== n[e]) {
                return !1;
            }
        }
        return !0;
    }(n.lt, t.lt);
}

function Pt(t, n) {
    if (!(n instanceof oi)) {
        return !1;
    }
    for (let e = 0; e < t.length; e++) {
        const s = t[e];
        if (s instanceof oi && Tt(s, n)) {
            return !0;
        }
    }
    return !1;
}

function Rt(t, n, e, s) {
    const o = s(t, n);
    o.key = e;
    return o;
}

function At(t, n, e, s, o, r) {
    const i = Array(r - o + 1);
    for (let c = o; c <= r; c++) {
        const r = n[c] ?? (n[c] = e(t[c], c));
        i[c - o] = Rt(t[c], c, r, s);
    }
    return i;
}

function Mt(t, n, e) {
    let s = n ? n.previousSibling : t.lastChild;
    for (let t = 1; t < e && s; t++) {
        s = s.previousSibling;
    }
    return s;
}

function Nt(t, n, e, s, o, r, i) {
    const c = t;
    const l = o.length;
    const u = ol(e);
    const f = D(c, n, s, null);
    const a = Array(l);
    if (u === null) {
        if (l > 0) {
            return oo(c, n, At(o, a, r, i, 0, l - 1), e, null, null, s, null, !0, f);
        }
        return;
    }
    if (l === 0) {
        el(n, e, u, !0);
        return;
    }
    let h = 0;
    let d = l - 1;
    let p = u;
    for (;p && h <= d && p.key === (a[h] ??= r(o[h], h)); ) {
        p = p.nextSibling;
        h++;
    }
    if (p === null) {
        if (h > d) {
            return;
        }
        return oo(c, n, At(o, a, r, i, h, d), e, null, null, s, null, !0, f);
    }
    if (h > d) {
        el(n, e, p, !0);
        return;
    }
    const $ = p.previousSibling;
    let y = e.lastChild;
    for (;y !== $ && d >= h && y.key === (a[d] ??= r(o[d], d)); ) {
        y = y.previousSibling;
        d--;
    }
    const m = y ? y.nextSibling : p;
    if (h > d) {
        let t = p;
        for (;t && t !== m; ) {
            const s = t.nextSibling;
            nl(n, e, t, !0);
            t = s;
        }
        return;
    }
    if (y === $) {
        const t = m;
        return oo(c, n, At(o, a, r, i, h, d), e, t, t, s, null, !0, f);
    }
    for (let t = h; t <= d; t++) {
        a[t] ??= r(o[t], t);
    }
    const w = d - h + 1;
    const b = new Map;
    for (let t = h; t <= d; t++) {
        b.set(a[t], t - h);
    }
    const v = function g(t, n = null) {
        const e = [];
        let s = t;
        for (;s; ) {
            e.push(s);
            if (s === n) {
                break;
            }
            s = s.nextSibling;
        }
        return e;
    }(p, y);
    const _ = [];
    const k = new Map;
    for (let t = 0; t < v.length; t++) {
        const s = v[t];
        const o = s.key;
        if (b.has(o)) {
            k.set(o, _.length);
            _.push(s);
        } else {
            nl(n, e, s, !0);
        }
    }
    const S = new Int32Array(w);
    S.fill(-1);
    const E = [];
    const x = [];
    for (let t = 0; t < w; t++) {
        const n = k.get(a[h + t]);
        if (n !== void 0) {
            S[t] = n;
            x.push(t);
            E.push(n);
        }
    }
    const q = new Uint8Array(w);
    const T = function P(t) {
        const n = t.length;
        if (n === 0) {
            return [];
        }
        const e = [];
        const s = Array(n).fill(-1);
        for (let o = 0; o < n; o++) {
            const n = t[o];
            let r = 0;
            let i = e.length;
            for (;r < i; ) {
                const s = r + i >> 1;
                t[e[s]] < n ? r = s + 1 : i = s;
            }
            r > 0 && (s[o] = e[r - 1]);
            r === e.length ? e.push(o) : e[r] = o;
        }
        const o = [];
        let r = e[e.length - 1];
        for (;r !== -1; ) {
            o.push(r);
            r = s[r];
        }
        o.reverse();
        return o;
    }(E);
    for (let t = 0; t < T.length; t++) {
        q[x[T[t]]] = 1;
    }
    let R = d;
    let M = m;
    const A = () => {
        for (;R >= h; ) {
            const t = R - h;
            if (q[t] === 1) {
                M = _[S[t]];
                R--;
                continue;
            }
            const r = S[t];
            if (r !== -1) {
                const t = _[r];
                const s = M === null ? e.lastChild === t : t.nextSibling === M;
                s || Ko(n, e, t, M);
                M = t;
                R--;
                continue;
            }
            let l = R;
            for (;l > h; ) {
                const t = l - 1 - h;
                if (q[t] === 1 || S[t] !== -1) {
                    break;
                }
                l--;
            }
            const u = R - l + 1;
            const d = oo(c, n, At(o, a, null, i, l, R), e, M, M, s, null, !0, f);
            return $r(d, () => {
                const t = Mt(e, M, u);
                M = t;
                R = l - 1;
                return A();
            });
        }
    };
    return A();
}

function It(t, n, e) {
    t.dirty &= -2;
    const s = n.getHostProp(t, Ze);
    if (!s || s.length === 0) {
        return;
    }
    let o;
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (i instanceof jl) {
            const s = i;
            if (!(s.h & 4)) {
                continue;
            }
            if (s.h & 1) {
                (e.afterFlushTasks ||= []).push(s);
            } else {
                const r = !!(s.h & 8);
                const i = Cl(s, n, t);
                dr(i) && (r ? o = o ? o.then(() => i) : i : (e.extraPromises ||= []).push(i));
            }
        }
    }
    return o;
}

function Ct(t, n) {
    const e = t.props ||= {};
    e[ys] = n;
}

function jt(t, n) {
    t.dirty &= -257;
    const e = function s(t) {
        const n = t.props;
        return n?.[ms] ?? null;
    }(t);
    if (!e) {
        return;
    }
    (function o(t, n) {
        const e = t.props ||= {};
        e[ms] = n;
    })(t, null);
    const r = t;
    const i = r.parent;
    const c = r.nextSibling;
    const l = Xo(n, document, r, e);
    const u = Eo(r) && i || r;
    const f = u === r ? null : c;
    Bo(n, u, l, f);
    t.dirty &= -33;
    t.dirtyChildren = null;
}

function Ot(t, n, e, s) {
    t.dirty &= -3;
    const o = t;
    let r = function i(t) {
        const n = t.props;
        return n?.[ys];
    }(t);
    if (!r) {
        return;
    }
    Ct(t, null);
    Ll(r) && (r = r.value);
    return io(n, e, r, o, s, null);
}

function Ft(t, e, s, o) {
    t.dirty &= -5;
    const r = t;
    const i = e.getHostProp(r, xe);
    if (!i) {
        return;
    }
    const c = e.getHostProp(r, Ke) || null;
    const l = pr(() => Ai(e, r, r, i, c), t => {
        const i = e.getHostProp(r, Ie);
        return n(() => io(e, s, t, r, o, wr(i)));
    }, t => {
        e.handleError(t, r);
    });
    if (dr(l)) {
        return l;
    }
    return;
}

function Lt(t, n, e, s, o, r = null) {
    n.push(Gi(t.node, e, s, r, (t.flags & 512) !== 0));
    o || (t.props && s == null ? delete t.props[e] : (t.props ||= {})[e] = s);
}

function Dt(t, n) {
    t.dirty &= -9;
    if (!(t.flags & 1)) {
        return;
    }
    const e = function s(t) {
        const n = t.props ||= {};
        return n[$s] ?? null;
    }(t);
    if (!e || e.size === 0) {
        return;
    }
    const o = t;
    for (const [t, s] of e.entries()) {
        let e = s.value;
        Ll(e) && (e = e.value);
        const r = s.isConst;
        Lt(o, n, t, e, r, s.scopedStyleIdPrefix);
    }
    (function r(t) {
        const n = t.props ||= {};
        delete n[$s];
    })(t);
}

function Vt(t, n) {
    t.dirty &= -65;
    const e = n.getHostProp(t, Ze);
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n instanceof jl && n.h & 16) {
            n.h &= -17;
            const t = n;
            ro(t);
        }
    }
}

function Wt(t, e) {
    t.dirty &= -17;
    const s = e.getHostProp(t, ws);
    if (!s) {
        return;
    }
    const o = s.ut;
    const r = re();
    r.$ = e;
    return $r(n(() => te.call(s, r, s.p)), () => {
        if (s.h & 2) {
            s.h &= -3;
            return Ul(e, s, o);
        }
    });
}

function Ut(t, n, e, s) {
    t.dirty &= -129;
    const o = t;
    const r = n.getHostProp(o, Ke) || null;
    if (!r) {
        return;
    }
    let i = Vs(r, "items");
    Ll(i) && (i = Pc(i));
    const c = Vs(r, "key$");
    const l = Vs(r, "item$");
    const u = c.resolved;
    const f = l.resolved;
    if (u !== void 0 && f !== void 0) {
        return Nt(n, e, o, s, i, u, f);
    }
    return $r(c.resolve(), t => $r(l.resolve(), r => Nt(n, e, o, s, i, t, r)));
}

let uo = null;

const co = (t, n, e) => {
    uo || (uo = t.insertBefore);
    uo.call(t, n, e);
};

function Xt(t) {
    let n = null;
    let e = null;
    let s = null;
    const o = new Set;
    const i = () => {
        if (s) {
            if (s.length === 1) {
                co(n, s[0], e);
            } else {
                const t = n.ownerDocument || n;
                const o = t.createDocumentFragment();
                for (let t = 0; t < s.length; t++) {
                    o.appendChild(s[t]);
                }
                co(n, o, e);
            }
            s = null;
            n = null;
            e = null;
            o.clear();
        }
    };
    for (let c = 0; c < t.length; c++) {
        const l = t[c];
        if (l instanceof zi) {
            if (n === l.parent && e === l.beforeTarget) {
                s || (s = []);
                s.push(l.target);
                o.add(l.target);
                continue;
            }
            if (!s) {
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (n === l.parent) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (o.has(l.target) || e && l.target === e || n && l.target === n) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            co(l.parent, l.target, l.beforeTarget);
            continue;
        }
        if (l instanceof Wi) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && i();
            l.target.remove();
            continue;
        }
        if (l instanceof Ui) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && i();
            const t = l.target;
            t.textContent = "";
            continue;
        }
        if (l instanceof Xi) {
            l.target.nodeValue = l.text;
        } else if (l instanceof Bi) {
            const t = l.target;
            const e = l.attrName;
            const s = l.attrValue;
            const o = s != null ? r(e, s, l.scopedStyleIdPrefix) : null;
            const c = o == null || o === !1;
            if (fo(t, e)) {
                t[e] = ao(o);
            } else if (e === fr) {
                n === t && i();
                t.innerHTML = o;
                t.setAttribute(Ue, "html");
            } else {
                c ? t.removeAttribute(e) : e === "value" && e in t ? t.value = o : x(t, e, o, l.isSvg);
            }
        }
    }
    i();
}

const fo = (t, n) => {
    const e = n == "allowfullscreen" || n == "async" || n == "autofocus" || n == "autoplay" || n == "checked" || n == "controls" || n == "default" || n == "defer" || n == "disabled" || n == "formnovalidate" || n == "inert" || n == "ismap" || n == "itemscope" || n == "loop" || n == "multiple" || n == "muted" || n == "nomodule" || n == "novalidate" || n == "open" || n == "playsinline" || n == "readonly" || n == "required" || n == "reversed" || n == "selected";
    return e && n in t;
};

const ao = t => {
    if (t === "false") {
        return !1;
    }
    return !!t;
};

const ho = (t => () => queueMicrotask(t))(Ht);

const $o = Tr(Ht);

let yo = !1;

function zt() {
    if (!yo) {
        yo = !0;
        ho();
    }
}

function Bt() {
    if (!yo) {
        yo = !0;
        $o();
    }
}

function Ht() {
    yo = !1;
    const t = performance.now();
    const n = t + 15;
    let e = null;
    for (;e = u(); ) {
        if (Jt(e, n)) {
            Bt();
            return;
        }
    }
}

function Jt(t, n) {
    const e = oe;
    const s = d(t);
    const o = s.promise;
    if (o) {
        return;
    }
    const r = s.container;
    if (!t.dirty) {
        Qt(r, t, s, e);
        return;
    }
    const i = s.journal ||= [];
    let l = null;
    for (;l = s.position; ) {
        if (s.promise) {
            return;
        }
        if (!(l.dirty & 511)) {
            __EXPERIMENTAL__.suspense && R(l);
            h(r, s, Kt(l, t, r));
            continue;
        }
        if (l.flags & 32) {
            if (l.dirty & 64) {
                Vt(l, r);
            } else if (l.dirty & 32) {
                const n = Gt(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            }
            l.dirty &= -512;
            h(r, s, Kt(l, t, r));
            continue;
        }
        let e;
        try {
            if (l.dirty & 1) {
                e = It(l, r, s);
            } else if (l.dirty & 2) {
                e = Ot(l, r, i, t);
            } else if (l.dirty & 4) {
                e = Ft(l, r, i, t);
            } else if (l.dirty & 128) {
                e = Ut(l, r, i, t);
            } else if (l.dirty & 8) {
                Dt(l, i);
            } else if (l.dirty & 16) {
                e = Wt(l, r);
            } else if (l.dirty & 32) {
                const n = Gt(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            } else {
                l.dirty & 256 && jt(l, i);
            }
        } catch (t) {
            r.handleError(t, l);
        }
        if (e && dr(e)) {
            T(s, l);
            s.promise = e;
            c(t, r);
            const n = l;
            e.catch(t => {
                r.handleError(t, n);
            }).finally(() => {
                s.promise = null;
                f(t, r);
                zt();
            });
            return;
        }
        if (performance.now() >= n) {
            return !0;
        }
    }
    Qt(r, t, s, e);
}

function Qt(t, n, e, s) {
    if (!(n.dirty & 511)) {
        a(n, t);
        s || function o(t, n) {
            const e = d(t);
            const s = e.journal;
            if (s && s.length > 0) {
                Xt(s);
                e.journal = null;
            }
            (function o(t, n) {
                const e = n.afterFlushTasks;
                if (!e || e.length === 0) {
                    n.afterFlushTasks = null;
                    return;
                }
                let s;
                for (let n = 0; n < e.length; n++) {
                    const o = e[n];
                    const r = Cl(o, t, o.ct);
                    dr(r) && (s = s ? s.then(() => r) : r);
                }
                s && (n.extraPromises ||= []).push(s);
                n.afterFlushTasks = null;
            })(n, e);
        }(n, t);
        (function r(t) {
            if (!__EXPERIMENTAL__.suspense) {
                return;
            }
            const n = t.boundaries;
            if (!n) {
                return;
            }
            t.boundaries = null;
            for (let t = 0; t < n.length; t++) {
                const e = n[t];
                e.pending.value = Math.max(0, e.pending.value - 1);
                e.version.value++;
            }
        })(e);
        if (e.extraPromises) {
            Promise.all(e.extraPromises).then(() => {
                Yt(t);
            });
            return;
        }
        Yt(t);
    }
}

function Yt(t) {
    t.ft();
}

function Gt(t, n, e, s) {
    const o = e.dirtyChildren;
    if (!o || o.length === 0) {
        e.dirty &= -33;
        R(e);
        return null;
    }
    (function r(t, n) {
        let e = 0;
        for (let s = 0; s < t.length; s++) {
            const o = t[s];
            if (o.parent === n) {
                if (e !== s) {
                    const n = t[e];
                    t[e] = o;
                    t[s] = n;
                }
                e++;
            }
        }
    })(o, e);
    e.nextDirtyChildIndex = 0;
    const i = Kt(o[0], s, t);
    h(t, n, i);
    return i;
}

function Kt(t, n, e) {
    if (t === n) {
        if (n.dirty & 511) {
            return n;
        }
        return null;
    }
    let s = null;
    t.slotParent && t.slotParent.dirty & 32 ? s = t.slotParent : t.parent && t.parent.dirty & 32 && (s = t.parent);
    if (!s) {
        if (n.dirty & 511) {
            return n;
        }
        return null;
    }
    const o = s.dirtyChildren;
    let r = s.nextDirtyChildIndex;
    const i = o.length;
    let c = i;
    for (;c-- > 0; ) {
        const t = o[r];
        if (t.dirty & 511) {
            if (e && Zt(e, t)) {
                r++;
                r === i && (r = 0);
                continue;
            }
            s.nextDirtyChildIndex = (r + 1) % i;
            return t;
        }
        r++;
        r === i && (r = 0);
    }
    s.dirty &= -33;
    s.dirtyChildren = null;
    s.nextDirtyChildIndex = 0;
    __EXPERIMENTAL__.suspense && R(s);
    return Kt(s, n, e);
}

function Zt(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    if (!n.props || !(lr in n.props) || !t.getHostProp(n, lr)) {
        return !1;
    }
    nn(n) || tn(t, n, 0);
    return !0;
}

function tn(t, n, e) {
    const s = {
        afterFlushTasks: null,
        extraPromises: null,
        journal: null,
        container: t,
        position: n,
        priority: e,
        promise: null,
        boundaries: null
    };
    (function o(t, n) {
        ps.set(t, n);
    })(n, s);
    const r = n;
    r.flags |= 256;
    l(t, r);
    zt();
    return r;
}

function nn(t) {
    return (t.flags & 256) !== 0;
}

function en(t, n) {
    if (!(n.flags & 1)) {
        n.dirty & 8 && function e(t, n) {
            n.dirty &= -9;
            const e = n.getProp($s);
            if (!e || e.size === 0) {
                return;
            }
            for (const [s, o] of e.entries()) {
                let e = o.value;
                Ll(e) && (e = e.value);
                const i = r(s, e, o.scopedStyleIdPrefix);
                t.addBackpatchEntry(n.id, s, i);
            }
        }(t, n);
        n.dirty & 16 && Wt(n, t);
        n.dirty &= -512;
        return;
    }
    let e = null;
    if (n.dirty & 1) {
        const s = function o(t, n) {
            n.dirty &= -2;
            const e = n.getProp(Ze);
            if (!e || e.length === 0) {
                return null;
            }
            let s = null;
            for (let o = 0; o < e.length; o++) {
                const r = e[o];
                if (r instanceof jl) {
                    const e = r;
                    if (!(e.h & 4)) {
                        continue;
                    }
                    const o = Cl(e, t, n);
                    s = s ? s.then(() => o) : o;
                }
            }
            return s;
        }(t, n);
        dr(s) && (e = s);
    }
    if (n.dirty & 128) {
        const s = async function o(t, n) {
            n.dirty &= -129;
            const e = n;
            const s = t.getHostProp(e, Ke) || null;
            if (!s) {
                return;
            }
            let o = Vs(s, "items");
            Ll(o) && (o = Pc(o));
            const r = await Vs(s, "key$").resolve();
            const i = await Vs(s, "item$").resolve();
            const c = [];
            for (let t = 0; t < o.length; t++) {
                const n = o[t];
                const e = i(n, t);
                const s = r(n, t);
                e.key = s;
                c.push(e);
            }
            await t.renderJSX(c, {
                currentStyleScoped: null,
                parentComponentFrame: t.getComponentFrame(0)
            });
        }(t, n);
        e = e ? e.then(() => s) : s;
    }
    n.dirty &= -508;
    if (e) {
        return e;
    }
}

const mo = [];

function rn(t) {
    for (let n = 0; n < mo.length; n++) {
        const e = mo[n];
        const s = mo[n + 1] || t;
        s.dirty |= 32;
        s.dirtyChildren ||= [];
        s.dirtyChildren.includes(e) || s.dirtyChildren.push(e);
    }
}

function sn(t, n, e, s = null) {
    const o = n.dirty;
    n.dirty |= e;
    if (function r() {
        return oe;
    }()) {
        const e = en(t, n);
        dr(e) && (t.l = t.l ? t.l.then(() => e) : e);
        return;
    }
    const i = e & 511;
    if ((i ? o & 511 : o) || n === s) {
        return;
    }
    const c = n.slotParent || n.parent;
    if (s && i && c && !c.dirty) {
        (function e(t, n, s) {
            mo.push(n);
            let o = P(t, n);
            let r = n.slotParent || n.parent;
            for (;r; ) {
                const e = r.dirty & 511;
                const i = nn(r);
                __EXPERIMENTAL__.suspense && (o ||= P(t, r) || (e ? A(t, r) : null));
                if (r === s || e) {
                    M(n, o);
                    rn(r);
                    if (i) {
                        const t = d(r);
                        t.position !== r && (t.position = n);
                    }
                    mo.length = 0;
                    return;
                }
                if (i) {
                    const t = d(r);
                    t.position !== r && (t.position = n);
                }
                mo.push(r);
                r = r.slotParent || r.parent;
            }
            mo.length = 0;
            ((t, ...n) => {
                const e = fe(!1, t, ...n);
                debugger;
                throw e;
            })("Cursor root not found in current path!");
        })(t, n, s);
        return;
    }
    if (c && c.dirty & 511) {
        M(n, P(t, n) || A(t, c));
        i && (c.dirty |= 32);
        c.dirtyChildren ||= [];
        c.dirtyChildren.includes(n) || c.dirtyChildren.push(n);
        if (i && n.dirtyChildren) {
            const t = function e(t) {
                for (;t; ) {
                    if (nn(t)) {
                        return t;
                    }
                    t = t.parent || t.slotParent;
                }
                return null;
            }(n);
            if (t) {
                const e = d(t);
                let s = e.position;
                if (s) {
                    for (;s !== t; ) {
                        s = s.slotParent || s.parent;
                        if (s === n) {
                            e.position = n;
                            break;
                        }
                    }
                }
            }
        }
    } else {
        nn(n) ? M(n, P(t, n)) : function l(t, n) {
            mo.push(n);
            let e = __EXPERIMENTAL__.suspense ? P(t, n) : null;
            let s = n.slotParent || n.parent;
            for (;s; ) {
                const o = nn(s);
                __EXPERIMENTAL__.suspense && (e ||= P(t, s) || (o ? A(t, s) : null));
                if (o) {
                    M(n, e);
                    rn(s);
                    mo.length = 0;
                    return !0;
                }
                mo.push(s);
                s = s.slotParent || s.parent;
            }
            M(n, e);
            mo.length = 0;
            return !1;
        }(t, n) || tn(t, n, 0);
    }
}

function on(t, n) {
    t.push(n);
}

const wo = (t, n) => {
    let e;
    for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
        t = Object.getPrototypeOf(t);
    }
    return e || function() {
        return this[n];
    };
};

const bo = t => {
    let n = null;
    return e => {
        n || (n = wo(e, t));
        return n.call(e);
    };
};

const vo = (t, n, e = null) => {
    const s = new fs(e, -4087, null, null, null, null, null, null, t, n);
    t.vNode = s;
    return s;
};

const go = t => {
    const n = new fs(null, -4095, null, null, null, null, void 0, void 0, t, void 0);
    t.vNode = n;
    return n;
};

const _o = (t, n) => {
    const e = new as(-4084, null, null, null, null, t, n);
    return e;
};

const So = () => {
    const t = new cs(null, -4094, null, null, null, null, null, null);
    return t;
};

const ko = t => t instanceof us;

const Eo = t => (t.flags & 1) === 1;

const xo = t => {
    const n = t.flags;
    return (n & 5) !== 0;
};

const qo = t => {
    const n = t.flags;
    return (n & 1) === 1 && t.firstChild !== void 0 && t.lastChild !== void 0;
};

const To = t => (t.flags & 4) === 4;

const Po = t => (t.flags & 2) === 2;

const Ro = t => {
    const n = t.flags;
    return (n & 2) === 2 && Ao(t, Pe, null) !== null;
};

const Ga = t => t;

const Ao = (t, n, e) => {
    if (Eo(t) || Po(t)) {
        const s = t.props?.[n] ?? null;
        if (typeof s === "string" && e) {
            const o = e(s);
            t.props[n] = o;
            return o;
        }
        return s;
    }
    return null;
};

const Mo = (t, n, e) => {
    if (e == null && t.props) {
        delete t.props[n];
    } else {
        t.props ||= {};
        t.props[n] = e;
    }
};

const No = (t, n, e, s, o = null) => {
    if (Eo(n)) {
        Mo(n, e, s);
        on(t, Gi(n.node, e, s, o, (n.flags & 512) !== 0));
    }
};

const Io = t => {
    if (t.key) {
        return;
    }
    const n = al(t.node, cr);
    n && (t.key = n);
};

const Co = (t, n) => {
    if ((n.flags & 15) === 1) {
        const e = n;
        e.flags ^= 8;
        const s = e.node;
        const o = s.attributes;
        let r = !1;
        for (let n = 0; n < o.length; n++) {
            const i = o[n];
            const c = i.name;
            if (br(c)) {
                ln(i, c, t, s);
                continue;
            }
            if (r) {} else if (c !== cr && c) {
                if (c.startsWith(Ue)) {
                    const t = i.value;
                    t === "html" ? Mo(e, "dangerouslySetInnerHTML", s.innerHTML) : t === "text" && "value" in s && Mo(e, "value", s.value);
                } else {
                    const t = i.value;
                    Mo(e, c, t);
                }
            } else {
                const t = i.value;
                t && (e.key = t);
                r = !0;
            }
        }
        Ao(e, nr, null) === null && Ao(e, er, null) === null || (n.flags |= 64);
    }
};

const jo = t => {
    if (t.bt === "_run") {
        const n = t.getCaptured()?.[0];
        if (_e(n)) {
            return n;
        }
    }
    return t;
};

function ln(t, n, e, s) {
    const o = t.value;
    const r = n.slice(2);
    const i = o.split("|");
    const c = [];
    for (let t = 0; t < i.length; t++) {
        const n = jo(qn(i[t], e));
        c.push(I.bind(null, n));
    }
    (s._qDispatch ||= {})[r] = c.length === 1 ? c[0] : c;
}

function un(t, n, e) {
    let s = ol(n);
    for (;s; ) {
        if (To(s)) {
            Fo(t, s);
            e(s, n);
        } else {
            Eo(s) ? e(s, n) : un(t, s, e);
        }
        s = s.nextSibling;
    }
}

function cn(t, n) {
    let e = t;
    if (To(t)) {
        n?.(t, null);
        return;
    }
    let s = null;
    for (;;) {
        if (n?.(e, s)) {
            return;
        }
        const o = ol(e);
        if (o) {
            e = o;
            continue;
        }
        if (e === t) {
            return;
        }
        const r = e.nextSibling;
        if (r) {
            e = r;
            continue;
        }
        s = e.parent;
        for (;s; ) {
            if (s === t) {
                return;
            }
            const n = s.nextSibling;
            if (n) {
                e = n;
                break;
            }
            s = s.parent;
        }
        if (s == null) {
            return;
        }
    }
}

const Oo = (t, n, e) => {
    let s = t;
    for (;e && s && Po(s); ) {
        const t = n ? s.firstChild : s.lastChild;
        if (!t) {
            break;
        }
        if (t.flags & 5) {
            return t;
        }
        s = t;
    }
    for (;s; ) {
        let t = n ? s.nextSibling : s.previousSibling;
        if (t && t.flags & 5) {
            return t;
        }
        if (!t) {
            let e = s.parent;
            if (e && !Po(e)) {
                return null;
            }
            for (;e && !(t = n ? e.nextSibling : e.previousSibling); ) {
                e = e.parent;
                if (e && !Po(e)) {
                    return null;
                }
            }
            if (!t) {
                return null;
            }
            if (To(t) && e && Eo(e)) {
                return null;
            }
        }
        for (;t; ) {
            s = t;
            if (s.flags & 5 && ql(s)) {
                return s;
            }
            t = n ? s.firstChild : s.lastChild;
        }
    }
    return null;
};

const Fo = (t, n) => {
    const e = (t => t)(n);
    const s = e.flags;
    if ((s & 8) === 0) {
        const s = Zo(n, !0);
        const o = e.node;
        const r = gl(s);
        let i = Oo(n, !1, !0);
        const c = Oo(n, !0, !0);
        const l = o || (c && Eo(c) ? c.node : c?.node) || null;
        let u = l;
        for (;i && To(i); ) {
            if ((i.flags & 8) === 0) {
                const n = r.createTextNode(i.text);
                on(t, Yi(n, s, u));
                u = n;
                i.node = n;
                i.flags |= 8;
            }
            i = Oo(i, !1, !0);
        }
        i = n;
        for (;i && To(i); ) {
            const n = Oo(i, !0, !0);
            const e = !n || !To(n);
            if ((i.flags & 8) === 0) {
                if (e && o) {
                    on(t, Qi(o, i.text));
                } else {
                    const n = r.createTextNode(i.text);
                    on(t, Yi(n, s, l));
                    i.node = n;
                }
                i.flags |= 8;
            }
            i = n;
        }
    }
};

const Lo = (t, n) => {
    let e = t;
    const s = t.node;
    const {qVNodeRefs: o} = s;
    let r = -1;
    let i;
    if (typeof n === "string") {
        r = parseInt(n);
        i = o.get(r);
    } else {
        i = n;
        const t = i.vNode;
        if (t) {
            return t;
        }
    }
    if (ko(i)) {
        e = i;
    } else {
        let t = i;
        const n = [ i ];
        for (;t && t !== s && !t.vNode; ) {
            t = t.parentElement;
            n.push(t);
        }
        t.vNode && (e = t.vNode);
        for (let t = n.length - 2; t >= 0; t--) {
            e = Wo(e, n[t]);
        }
        if (r != -1) {
            i.vNode = e;
            o.set(r, e);
        }
    }
    if (typeof n === "string") {
        const t = n.length;
        let s = Uo(n, t);
        let o = 0;
        for (;s < t; ) {
            const t = n.charCodeAt(s);
            o *= 26;
            if (t >= 97) {
                o += t - 97;
            } else {
                o += t - 65;
                e = Do(e, o);
                o = 0;
            }
            s++;
        }
    }
    return e;
};

const Do = (t, n) => {
    let e = ol(t);
    for (;e.flags >>> 12 !== n; ) {
        e = e.nextSibling;
    }
    return e;
};

const Vo = [];

const Wo = (t, n) => {
    let e = ol(t);
    for (;e && (!(e instanceof fs) || e.node !== n); ) {
        if (Po(e)) {
            const t = e.nextSibling;
            const n = ol(e);
            if (n) {
                t && Vo.push(t);
                e = n;
            } else {
                e = t || (Vo.length ? Vo.pop() : null);
            }
        } else {
            const t = e.nextSibling;
            e = t || t || Vo.pop();
        }
    }
    for (;Vo.length; ) {
        Vo.pop();
    }
    return e;
};

const Uo = (t, n) => {
    let e = 0;
    for (;e < n; ) {
        if (!(t.charCodeAt(e) <= 57)) {
            return e;
        }
        e++;
    }
    return n;
};

const Xo = (t, n, e, s) => {
    const o = n.createElement("errored-host");
    s && s instanceof Error && (o.props = {
        error: s
    });
    o.setAttribute("q:key", "_error_");
    const r = vo(o, "errored-host");
    if (xo(e)) {
        Ko(t, r, e, null);
    } else {
        const n = [];
        un(t, e, t => {
            n.push(t);
        });
        for (let e = 0; e < n.length; e++) {
            Ko(t, r, n[e], null);
        }
    }
    return r;
};

const zo = Xt;

const Bo = (t, n, e, s) => {
    const o = Eo(n);
    o && ll(n);
    const r = e.parent;
    if (e === s) {
        if (r) {
            return;
        }
        s = null;
    }
    Yo(t, r, n, e);
    const i = e.node;
    const c = n.flags & 32;
    const l = o ? n.node : Zo(n, !1);
    l && !c && on(t, Yi(i, l, Jo(t, n, s)?.node ?? null));
    Qo(n, e, s);
    c && (e.flags |= 32);
};

const Ho = (t, n, e, s) => {
    const r = Eo(n);
    r && ll(n);
    const c = e.parent;
    if (e === s) {
        if (c) {
            return;
        }
        s = null;
    }
    Yo(t, c, n, e);
    const l = n.flags & 32;
    const u = !r && n.flags & 2048 ? n.props?.[qe] : null;
    const f = u ? null : r ? n : tl(n, !1);
    const a = u || f?.node;
    const h = Jo(t, n, s);
    const d = h?.node ?? null;
    const p = Ro(e);
    if (p && f && (f.flags & 1536) !== 0) {
        const r = tl(n, !1);
        const c = Jo(t, n, s)?.node ?? null;
        const {elementNamespace: l, elementNamespaceFlag: u} = o(r, e);
        un(t, e, n => {
            if (To(n)) {
                on(t, Yi(n.node, a, c));
            } else {
                if ((n.flags & 1536) !== u) {
                    const t = function e(t, n, s, r) {
                        let c = t;
                        let l = null;
                        let u = null;
                        let f = null;
                        for (;c; ) {
                            let e = null;
                            let a = null;
                            if (Eo(c)) {
                                e = c.node;
                                const t = rl(c);
                                const l = c.parent;
                                const h = u == null ? n : l && tl(l, !0);
                                if (h) {
                                    const t = o(h, rl(c));
                                    s = t.elementNamespace;
                                    r = t.elementNamespaceFlag;
                                }
                                const d = ol(c);
                                a = i(e, t, s, !d);
                                e.remove();
                                u == null && (u = a);
                                f && f.appendChild(a);
                                c.node = a;
                                c.flags &= -1537;
                                c.flags |= r;
                                if (d) {
                                    c = d;
                                    f = a;
                                    continue;
                                }
                                if (cl(e)) {
                                    const t = Yn(e);
                                    if (t) {
                                        const n = ol(t.rootVNode);
                                        if (n) {
                                            c = n;
                                            f = a;
                                            continue;
                                        }
                                    }
                                }
                            }
                            if (c === t) {
                                return u;
                            }
                            const h = c.nextSibling;
                            if (h) {
                                c = h;
                                continue;
                            }
                            l = c.parent;
                            for (;l; ) {
                                if (l === t) {
                                    return u;
                                }
                                const n = l.nextSibling;
                                if (n) {
                                    c = n;
                                    return u;
                                }
                                l = l.parent;
                            }
                            if (l == null) {
                                return u;
                            }
                        }
                        return u;
                    }(n, r, l, u);
                    t && (n.node = t);
                }
                on(t, Yi(n.node, a, c));
            }
        });
    } else {
        a && !l && un(t, e, n => {
            on(t, Yi(n.node, a, d));
        });
    }
    Qo(n, e, s);
    l && (e.flags |= 32);
};

const Jo = (t, n, e) => {
    let s = null;
    e == null ? Po(n) && (s = Oo(n, !0, !1)) : s = Po(e) ? Oo(e, !0, !0) : e;
    s && To(s) && Fo(t, s);
    return s;
};

const Qo = (t, n, e) => {
    const s = e ? e.previousSibling : t.lastChild;
    e ? e.previousSibling = n : t.lastChild = n;
    s ? s.nextSibling = n : t.firstChild = n;
    n.previousSibling = s;
    n.nextSibling = e;
    n.parent = t;
};

const Yo = (t, n, e, s) => {
    n && (s.previousSibling || s.nextSibling || n !== e) && nl(t, n, s, !1);
};

const Go = (t, n) => {
    let e = n;
    for (;e && Po(e); ) {
        e = e.lastChild;
    }
    e && To(e) && (e.flags & 8) === 0 && Fo(t, e);
};

const Ko = (t, n, e, s) => {
    xo(e) ? Bo(t, n, e, s) : Ho(t, n, e, s);
};

const Zo = (t, n) => {
    for (;t && !Eo(t); ) {
        if (t.flags & 2048) {
            return t.props?.[qe];
        }
        t = t.parent || (n ? t.slotParent : null);
    }
    return t ? t.node : null;
};

const tl = (t, n) => {
    for (;t && !Eo(t); ) {
        t = t.parent || (n ? t.slotParent : null);
    }
    return t;
};

const nl = (t, n, e, s) => {
    To(e) && Fo(t, e);
    if (s) {
        const s = Ao(n, fr, null) !== null;
        if (s) {
            return;
        }
        xo(e) ? on(t, Hi(e.node)) : un(t, e, n => {
            on(t, Hi(n.node));
        });
    }
    const o = e.previousSibling;
    const r = e.nextSibling;
    o ? o.nextSibling = r : n.firstChild = r;
    r ? r.previousSibling = o : n.lastChild = o;
    e.previousSibling = null;
    e.nextSibling = null;
};

const el = (t, n, e, s = !0) => {
    const o = Zo(n, !0);
    if (o && s) {
        if (xo(n)) {
            on(t, Ji(n.node));
        } else {
            const e = tl(n, !1);
            e && e.firstChild === n && e.lastChild === n ? on(t, Ji(o)) : un(t, n, n => {
                on(t, Hi(n.node));
            });
        }
    }
    const r = e.previousSibling;
    r ? r.nextSibling = null : n.firstChild = null;
    n.lastChild = r;
};

const rl = t => {
    const n = Ga(t);
    let e = n.elementName;
    if (e === void 0) {
        const t = n.node;
        const s = vl(t).toLowerCase();
        e = n.elementName = s;
        n.flags |= (t => {
            const n = bl(t);
            switch (n) {
              case He:
                return 512;

              case Je:
                return 1024;

              default:
                return 0;
            }
        })(t);
    }
    return e;
};

const sl = t => {
    let n = t.text;
    n === void 0 && (n = t.text = t.node.nodeValue);
    return n;
};

const il = (t, n, e) => {
    Fo(t, n);
    n.text = e;
    on(t, Qi(n.node, e));
};

const ol = t => {
    if (To(t)) {
        return null;
    }
    let n = t.firstChild;
    n === void 0 && (n = ll(t));
    return n;
};

const ll = n => {
    const e = Ga(n);
    let s = e.firstChild;
    if (s === void 0) {
        const n = e.node;
        s = e.parent && cl(n) ? e.firstChild = e.lastChild = null : (n => {
            const e = n.node;
            const s = wl(e);
            const o = gl(e)?.qVNodeData?.get(e);
            const r = ((n, e, s, o) => {
                Io(n);
                if (o) {
                    if (o.charCodeAt(0) === Ee && o.charCodeAt(1) === Ee) {
                        const t = (t => {
                            const n = t.indexOf("||", 2);
                            const e = t.substring(2, n);
                            const s = t.substring(n + 2);
                            return {
                                elementVNodeData: e,
                                virtualVNodeData: s
                            };
                        })(o);
                        const e = t.elementVNodeData;
                        o = t.virtualVNodeData;
                        const r = _l(n, s, e);
                        if (!o) {
                            return r;
                        }
                    }
                    return function r(n, e, s, o) {
                        let r = 0;
                        let i = null;
                        let c = null;
                        let l = null;
                        const u = t => {
                            t.flags = t.flags & 4095 | r << 12;
                            r++;
                            c && (c.nextSibling = t);
                            t.previousSibling = c;
                            t.parent = n;
                            i || (n.firstChild = i = t);
                            c = t;
                        };
                        let f = 0;
                        let a = null;
                        let h = null;
                        const d = t => {
                            const n = Ml(t);
                            return !n || n && dn(t);
                        };
                        let p = null;
                        Sl(e, ($, y, m, w, b) => {
                            if (Tl($())) {
                                for (;d(o); ) {
                                    o = $l(o);
                                    if (!o) {
                                        throw ve(27, [ e, $(), b ]);
                                    }
                                }
                                a = null;
                                l = null;
                                let t = 0;
                                for (;Tl($()); ) {
                                    t *= 10;
                                    t += m() - 48;
                                }
                                for (;t--; ) {
                                    const n = go(o);
                                    Io(n);
                                    u(n);
                                    o = $l(o);
                                    for (;Ml(o) && dn(o); ) {
                                        o = $l(o);
                                        if (!o && t > 0) {
                                            throw ve(27, [ e, $(), b ]);
                                        }
                                    }
                                }
                            } else if ($() === 59) {
                                Mo(n, Ie, y());
                            } else if ($() === 60) {
                                (p ||= []).push(n);
                                Mo(n, xe, y());
                            } else if ($() === 61) {
                                h || (h = Qn(s));
                                const t = y();
                                h.Pn(parseInt(t), n);
                            } else if ($() === 62) {
                                Mo(n, Ke, y());
                            } else if ($() === 64) {
                                const e = w(b + 1) === Ee;
                                let s;
                                if (e) {
                                    m();
                                    s = decodeURIComponent(t(y()));
                                    m();
                                } else {
                                    s = y();
                                }
                                n.key = s;
                            } else if ($() === 91) {
                                Mo(n, Ze, y());
                            } else if ($() === 94) {
                                Mo(n, tr, y());
                            } else if ($() === 96) {
                                h || (h = Qn(s));
                                an(n, y(), h);
                            } else if ($() === 63) {
                                h || (h = Qn(s));
                                n.slotParent = Lo(h.rootVNode, y());
                            } else if ($() === 93) {
                                Mo(n, Ce, y());
                            } else if ($() === 123) {
                                m();
                                u(So());
                                Rl.push(n, i, c, l, r);
                                r = 0;
                                n = c;
                                i = c = null;
                            } else if ($() === Ee) {
                                const e = t(y());
                                const s = t(y());
                                Mo(n, e, s);
                            } else if ($() === 125) {
                                m();
                                n.lastChild = c;
                                r = Rl.pop();
                                l = Rl.pop();
                                c = Rl.pop();
                                i = Rl.pop();
                                n = Rl.pop();
                            } else if ($() === 126) {
                                const e = t(y());
                                Mo(n, Pe, e);
                            } else {
                                for (;Ml(o) && dn(o); ) {
                                    o = $l(o);
                                }
                                const t = o && hl(o) === 3 ? o : null;
                                if (a === null) {
                                    a = t ? t.nodeValue : null;
                                    f = 0;
                                }
                                let n = 0;
                                for (;Pl($()); ) {
                                    n += m() - 97;
                                    n *= 26;
                                }
                                n += m() - 65;
                                const e = a === null ? "" : a.substring(f, f + n);
                                u(l = ((t, n, e) => {
                                    const s = new as(-4092, null, t, null, null, n, e);
                                    return s;
                                })(l, t, e));
                                f += n;
                            }
                        });
                        if (p) {
                            h || (h = Qn(s));
                            for (let t = 0; t < p.length; t++) {
                                h.ensureProjectionResolved(p[t]);
                            }
                            p = null;
                        }
                        n.lastChild = c;
                        return i;
                    }(n, o, e, s);
                }
                return _l(n, s);
            })(n, e, s, o);
            return r;
        })(e);
    }
    return s;
};

let ul = null;

const cl = t => {
    ul || (ul = t.hasAttribute);
    return ul.call(t, Ue);
};

let fl = null;

const al = (t, n) => {
    fl || (fl = t.getAttribute);
    return fl.call(t, n);
};

const hl = bo("nodeType");

const dl = t => {
    const n = hl(t);
    return n === 3 || n === 1;
};

let pl = null;

const $l = t => {
    pl || (pl = wo(t, "nextSibling"));
    ml || (ml = wo(t, "firstChild"));
    for (;t; ) {
        t = pl.call(t);
        if (t !== null) {
            const n = hl(t);
            if (n === 3 || n === 1) {
                break;
            }
            if (n === 8) {
                const n = t.nodeValue;
                if (n?.startsWith(Ve)) {
                    return fn(t, Le, pl, ml);
                }
                if (t.nodeValue?.startsWith(De)) {
                    return fn(t, [ Le, We ], pl, ml);
                }
                if (n?.startsWith(Ue)) {
                    for (;t && (t = pl.call(t)) && (hl(t) !== 8 || !t.nodeValue?.startsWith(Xe)); ) {}
                }
            }
        }
    }
    return t;
};

function fn(t, n, e, s) {
    const o = typeof n === "string";
    const r = n.length;
    for (;t; ) {
        const i = t.nodeValue;
        let c;
        if (o) {
            c = i?.startsWith(n);
        } else {
            for (let t = 0; t < r; t++) {
                if (i?.startsWith(n[t])) {
                    c = !0;
                    break;
                }
            }
        }
        if (c) {
            t = e.call(t) || null;
            return t;
        }
        let l = s.call(t);
        l || (l = e.call(t));
        for (;!l; ) {
            l = yl(t);
            if (!l) {
                break;
            }
            t = l;
            l = e.call(l);
        }
        t = l;
    }
    return null;
}

const yl = bo("parentNode");

let ml = null;

const wl = t => {
    ml || (ml = wo(t, "firstChild"));
    t = t && ml.call(t);
    if (t && hl(t) === 8 && t.nodeValue?.startsWith(Ve)) {
        pl || (pl = wo(t, "nextSibling"));
        return fn(t, Le, pl, ml);
    }
    for (;t && !dl(t); ) {
        t = $l(t);
    }
    return t;
};

const bl = bo("namespaceURI");

const vl = bo("nodeName");

const gl = bo("ownerDocument");

const _l = (t, n, e) => {
    let s = null;
    const o = () => {
        for (;Ml(r) && dn(r); ) {
            r = $l(r);
        }
    };
    let r = n;
    o();
    let i = null;
    for (;r; ) {
        const n = hl(r);
        let e = null;
        if (n === 3) {
            e = _o(r, r.textContent ?? void 0);
        } else if (n === 1) {
            e = go(r);
            Io(e);
        }
        if (e) {
            e.parent = t;
            i && (i.nextSibling = e);
            e.previousSibling = i;
            i = e;
        }
        s || (t.firstChild = s = i);
        r = $l(r);
        o();
    }
    t.lastChild = i || null;
    t.firstChild = s;
    if (e) {
        let n = null;
        Sl(e, (e, s) => {
            if (e() === 61) {
                n || (n = Qn(t.node));
                const e = s();
                n.Pn(parseInt(e), t);
            } else if (e() === 96) {
                n || (n = Qn(t.node));
                an(t, s(), n);
            } else {
                s();
            }
        });
    }
    return s;
};

function an(t, n, e) {
    if (t[es]) {
        const s = t[es];
        ((t, n) => {
            for (const [e, s] of n) {
                t.set(e, s);
            }
        })(s, e._(n));
    } else {
        Object.defineProperty(t, es, {
            get() {
                const s = e._(n);
                t[es] = s;
                return s;
            },
            set(n) {
                Object.defineProperty(t, es, {
                    value: n,
                    writable: !0,
                    enumerable: !0,
                    configurable: !0
                });
            },
            enumerable: !0,
            configurable: !0
        });
    }
}

const Sl = (t, n) => {
    let e = 0;
    let s = 0;
    let o = 0;
    const r = n => n < t.length ? t.charCodeAt(n) : 0;
    const i = () => o !== 0 ? o : o = r(e);
    const c = () => {
        s = i();
        o = 0;
        e++;
        return s;
    };
    const l = () => {
        c();
        const n = e;
        for (;i() <= 58 && o !== 0 || o === 92 || o === 95 || o >= 65 && o <= 90 || o >= 97 && o <= 122; ) {
            c();
        }
        return t.substring(n, e);
    };
    for (;i() !== 0; ) {
        n(i, l, c, r, e);
    }
};

const kl = (t, n) => {
    const e = n.flags;
    if ((e & 3) !== 0) {
        Co(t, n);
        const e = [];
        const s = n.props;
        if (s) {
            for (const t in s) {
                t.startsWith(cr) || e.push(t);
            }
        }
        return e;
    }
    return [];
};

const El = (t, n) => {
    let e = xl(t);
    for (;e; ) {
        if (e === n) {
            return !0;
        }
        e = xl(e);
    }
    return !1;
};

const xl = t => t.parent || t.slotParent;

const ql = t => {
    if (t === null || Po(t)) {
        return null;
    }
    return t.node;
};

function hn(t = 20, n = "", e = !1, s = !1, o = !0, r = null) {
    if (this && !r) {
        try {
            r = function t(n) {
                let e = n;
                for (;e; ) {
                    if (Eo(e)) {
                        const t = Gn(e.node);
                        if (!t) {
                            return null;
                        }
                        return Yn(t);
                    }
                    e = e.parent;
                }
                return null;
            }(this);
        } catch {}
    }
    let i = this;
    if (t === 0) {
        return "...";
    }
    if (i === null) {
        return "null";
    }
    if (i === void 0) {
        return "undefined";
    }
    const c = [];
    do {
        if (To(i)) {
            c.push(vn(sl(i)));
        } else if (Po(i)) {
            const e = i.flags >>> 12;
            const s = [ "[" + e + "]" ];
            i.dirty && s.push(" dirty:" + i.dirty);
            if (r) {
                const t = kl(r, i);
                for (let n = 0; n < t.length; n++) {
                    const e = t[n];
                    if (e !== Se && e !== "__scopedStyleIdPrefix__") {
                        const t = Ao(i, e, null);
                        s.push(" " + e + "=" + vn(t));
                    }
                }
            }
            const l = (o ? "[34m" : "") + (ke[Ao(i, Se, null) || "V"] || ke.V) + (o ? "[0m" : "");
            c.push("<" + l + s.join("") + ">");
            const u = ol(i);
            u && c.push("  " + hn.call(u, t - 1, n + "  ", !0, !0, o));
            c.push("</" + l + ">");
        } else if (Eo(i)) {
            const s = rl(i);
            const l = [];
            nn(i) && l.push(" cursor");
            i.dirty && l.push(" dirty:" + i.dirty);
            i.dirtyChildren && l.push(` dirtyChildren[${i.dirtyChildren.length}]`);
            const u = r ? kl(r, i) : [];
            for (let t = 0; t < u.length; t++) {
                const n = u[t];
                const e = Ao(i, n, null);
                l.push(" " + n + "=" + vn(e));
            }
            const f = ql(i);
            if (f) {
                const t = gl(f).qVNodeData?.get(f);
                t && l.push(" q:vnodeData=" + vn(t));
            }
            const a = f.attributes;
            for (let t = 0; t < a.length; t++) {
                const n = a[t];
                u.indexOf(n.name) === -1 && l.push(" " + n.name + (n.value ? "=" + vn(n.value) : ""));
            }
            c.push("<" + s + l.join("") + ">");
            if (qo(i) || e) {
                const e = ol(i);
                e && c.push("  " + hn.call(e, t - 1, n + "  ", !0, !0, o));
            } else {
                c.push("  \x3c!-- not materialized --!>");
            }
            c.push("</" + s + ">");
        }
        i = s && i.nextSibling || null;
    } while (i);
    return c.join("\n" + n);
}

const Tl = t => 48 <= t && t <= 57;

const Pl = t => 97 <= t && t <= 122;

function dn(t) {
    return !t.hasAttribute(cr) || t.nodeName === "STYLE" && (t.hasAttribute(Ie) || t.hasAttribute(Ae));
}

const Rl = [];

const Al = t => {
    const n = t.flags;
    if (n & 1) {
        return 1;
    }
    if (n & 2) {
        return 11;
    }
    if (n & 4) {
        return 3;
    }
    throw ve(26, [ n ]);
};

const Ml = t => t && typeof t == "object" && hl(t) === 1;

const Nl = t => {
    let n = 1;
    for (;n--; ) {
        for (;t && (!Po(t) || Ao(t, xe, null) === null); ) {
            const e = t.slotParent;
            const s = Po(t) && e;
            s && n++;
            t = s || t.parent;
        }
        n > 0 && (t = t.parent);
    }
    return t;
};

function pn(t, n) {
    ko(n) && Eo(n) && ll(n);
    const e = n[es];
    if (!e) {
        return;
    }
    for (const [, n] of e) {
        $n(t, n);
    }
    e.clear();
}

function $n(t, n) {
    const e = n.backRef;
    if (!e) {
        return;
    }
    for (const s of e) {
        if (s instanceof Ts) {
            mn(s, n);
        } else if (s instanceof Es) {
            yn(t, s, n);
        } else if (Xs(s)) {
            const t = s[Ms];
            wn(t, n);
        } else if (t.ht.has(s)) {
            const e = t.ht.get(s);
            const o = Jl(e);
            wn(o, n);
        }
    }
    e.clear();
}

function yn(t, n, e) {
    const s = n.ut;
    s && s.has(e) && s.delete(e);
    if (n instanceof oi && !s?.size) {
        n.m = void 0;
        pn(t, n);
    }
}

function mn(t, n) {
    const e = t.ut;
    e && e.has(n) && e.delete(n);
    const s = t.dt;
    s && s.has(n) && s.delete(n);
    const o = t.$t;
    o && o.has(n) && o.delete(n);
    t.yt();
}

function wn(t, n) {
    const e = t?.ut;
    if (e) {
        for (const [t, s] of e.entries()) {
            if (s.has(n)) {
                s.delete(n);
                s.size === 0 && e.delete(t);
            }
        }
    }
}

const Il = (t, n) => {
    const {val: e, set: s, iCtx: o, i: r} = Ki();
    if (e) {
        return;
    }
    s(1);
    const i = n?.deferUpdates === !1 ? 0 : 8;
    const c = new jl(6 | i, r, o.m, t, void 0, null);
    s(c);
    const l = o.$;
    const {Ft: u} = o;
    const f = $r(u, () => Cl(c, l, o.m));
    dr(f) && (o.Ft = f);
};

const Cl = (t, n, e) => {
    const s = t.Rn;
    if (s) {
        return s;
    }
    t.h &= -5;
    const o = t => n.handleError(t, e);
    let r = null;
    const i = $r(((t, n) => {
        const e = t.An;
        if (e) {
            return e;
        }
        const s = t.En;
        if (!s) {
            return;
        }
        t.En = null;
        try {
            const e = s();
            if (dr(e)) {
                const s = Promise.resolve(e).then(() => {}, t => {
                    n(t);
                }).finally(() => {
                    t.An === s && (t.An = void 0);
                });
                t.An = s;
                return s;
            }
        } catch (t) {
            n(t);
        }
        return;
    })(t, o), () => {
        const s = re(n.Ct, e, "qTask");
        s.$ = n;
        const i = t.wt.getFn(s, () => pn(n, t));
        const c = ks(t, n);
        const [l] = ((t, n) => {
            let e = null;
            return [ s => {
                if (typeof s == "function") {
                    if (!e) {
                        e = [];
                        t.En = () => {
                            t.En = null;
                            let s = null;
                            for (let t = 0; t < e.length; t++) {
                                const o = e[t];
                                try {
                                    const t = o();
                                    dr(t) && (s ||= []).push(t.catch(n));
                                } catch (t) {
                                    n(t);
                                }
                            }
                            e = null;
                            if (s?.length) {
                                return Promise.all(s).then(() => {});
                            }
                        };
                    }
                    e.push(s);
                }
            }, e ?? [] ];
        })(t, o);
        const u = {
            track: c,
            cleanup: l
        };
        return pr(() => i(u), l, s => {
            if (dr(s)) {
                return s.then(() => {
                    t.Rn === r && (t.Rn = null);
                    return Cl(t, n, e);
                });
            }
            o(s);
        });
    });
    if (dr(i)) {
        r = i.finally(() => {
            t.Rn === r && (t.Rn = null);
        });
        t.Rn = r;
        return r;
    }
    return i;
};

class jl extends rs {
    h;
    Ht;
    ct;
    wt;
    It;
    En;
    An;
    Rn=null;
    constructor(t, n, e, s, o, r) {
        super();
        this.h = t;
        this.Ht = n;
        this.ct = e;
        this.wt = s;
        this.It = o;
        this.En = r;
    }
}

const Ol = t => t instanceof jl;

function bn(t, n) {
    const e = Qn(n);
    typeof this === "string" && Hc(Jc(e, this));
    const s = Bc[0];
    s.h |= 4;
    sn(e, s.ct, 1);
}

const Fl = t => {
    const n = t.resolved;
    if (!n) {
        throw t.resolve();
    }
};

const Ll = t => t instanceof Es;

const Dl = (t, n) => {
    t.add(n);
};

const Vl = (t, n) => {
    (t.backRef ||= new Set).add(n);
};

const Wl = (t, n) => {
    if (n?.serializationCtx) {
        const e = t.consumer;
        const s = t.property;
        let o = null;
        Ol(e) ? o = e.wt : e instanceof xs ? o = e.Zt : s === ":" && (o = n.getHostProp(e, xe));
        o && n.serializationCtx.At.add(o);
    }
};

const Ul = (t, n, e) => {
    const s = le;
    if (e) {
        const o = e => {
            const o = e.consumer;
            const r = e.property;
            if (Ol(o)) {
                o.h |= 4;
                sn(t, o.ct, 1);
            } else if (o instanceof Es) {
                o.invalidate();
            } else if (r === ":") {
                sn(t, o, 4);
            } else if (r === ".") {
                if (s) {
                    Ct(o, n);
                    sn(t, o, 2);
                }
            } else {
                const i = e.data;
                if (i instanceof li) {
                    const e = i.data;
                    const c = {
                        isConst: e.et,
                        scopedStyleIdPrefix: e.j,
                        value: n
                    };
                    if (s) {
                        (function l(t, n, e) {
                            const s = t.props ||= {};
                            let o = s[$s];
                            if (!o) {
                                o = new Map;
                                s[$s] = o;
                            }
                            o.set(n, e);
                        })(o, r, c);
                    } else {
                        const t = o;
                        let n = t.getProp($s);
                        if (!n) {
                            n = new Map;
                            t.setProp($s, n);
                        }
                        n.set(r, c);
                    }
                    sn(t, o, 8);
                }
            }
        };
        const r = Array.from(e);
        for (let t = 0; t < r.length; t++) {
            o(r[t]);
        }
    }
};

const Xl = t => ye(t) && typeof t[pc] === "function";

const zl = t => {
    let n = 1;
    switch (t) {
      case "never":
        n |= 8;
        break;

      case "always":
        n |= 16;
        break;
    }
    return n;
};

const Bl = [];

function vn(t) {
    try {
        if (t === null) {
            return "null";
        }
        if (t === void 0) {
            return "undefined";
        }
        if (typeof t === "string") {
            return '"' + t + '"';
        }
        if (typeof t === "number" || typeof t === "boolean") {
            return t + "";
        }
        if (Ol(t)) {
            return `Task(${vn(t.wt)})`;
        }
        if (_e(t)) {
            return `Qrl(${t.bt})`;
        }
        if (typeof t === "object" || typeof t === "function") {
            if (Bl.includes(t)) {
                return "*";
            }
            try {
                Bl.push(t);
                if (Array.isArray(t)) {
                    return ko(t) ? "(" + (Ao(t, Se, null) || "vnode") + ")" : t.map(vn);
                }
                if (Ll(t)) {
                    return t instanceof oi ? "WrappedSignal" : t instanceof xs ? "ComputedSignal" : "Signal";
                }
                if (Zl(t)) {
                    return "Store";
                }
                if (ai(t)) {
                    return Hl(t);
                }
                if (ko(t)) {
                    return "(" + (Ao(t, Se, null) || "vnode") + ")";
                }
            } finally {
                Bl.pop();
            }
        }
    } catch (t) {
        console.error("ERROR in qwikDebugToString", t);
        return "*error*";
    }
    return t;
}

const Hl = t => {
    if (ai(t)) {
        if (typeof t.type === "function") {
            const n = t.type[hf];
            if (n) {
                const [t] = n;
                return "Component(" + t.bt + ")";
            }
            return "Function(" + t.type.name + ")";
        }
        let n = "<" + t.type;
        if (t.props) {
            const e = Object.entries(t.props);
            for (let t = 0; t < e.length; t++) {
                const [s, o] = e[t];
                n += " " + s + "=" + vn(o);
            }
            const s = t.children;
            if (s != null) {
                n += ">";
                if (Array.isArray(s)) {
                    for (let t = 0; t < s.length; t++) {
                        const e = s[t];
                        n += Hl(e);
                    }
                } else {
                    n += Hl(s);
                }
                n += "</" + t.type + ">";
            } else {
                n += "/>";
            }
        }
        return n;
    }
    return t + "";
};

const Jl = t => t[_s];

const Ql = t => t?.[gs] || null;

const Yl = (t, n) => {
    const e = Jl(t);
    e && e.force(n);
};

const Gl = (t, n) => {
    const e = Jl(t);
    if (e) {
        return (e.ut?.get(n)?.size ?? 0) > 0;
    }
    return !1;
};

const Kl = t => Ql(t) || t;

const Zl = t => gs in t;

function gn(t, n, e) {
    return new Proxy(n, new nu(e, t || null));
}

const tu = (t, n, e) => {
    if ($e(t) && e) {
        let s = e.ht.get(t);
        if (!s) {
            s = gn(e, t, n);
            e.ht.set(t, s);
        }
        return s;
    }
    return t;
};

class nu {
    h;
    $;
    ut=void 0;
    constructor(t, n) {
        this.h = t;
        this.$ = n;
    }
    toString() {
        return "[Store]";
    }
    force(t) {
        const n = Ql(this);
        Ul(this.$, this, kn(n, t, this.ut));
    }
    get(t, n) {
        if (typeof n === "symbol") {
            if (n === gs) {
                return t;
            }
            if (n === _s) {
                return this;
            }
            return t[n];
        }
        const e = Ec();
        const s = t[n];
        if (e) {
            if (this.$ === null) {
                if (!e.$) {
                    return s;
                }
                this.$ = e.$;
            }
            const o = e.Ot;
            o && _n(t, Array.isArray(t) ? Ss : n, this, o);
        }
        if (n === "toString" && s === Object.prototype.toString) {
            return this.toString;
        }
        const o = this.h;
        if (o & 1 && ye(s) && !Object.isFrozen(s) && !Zl(s) && !Object.isFrozen(t)) {
            return tu(s, this.h, this.$);
        }
        return s;
    }
    set(t, n, e) {
        if (typeof n === "symbol") {
            t[n] = e;
            return !0;
        }
        const s = this.h & 1 ? Kl(e) : e;
        if (n in t) {
            const e = t[n];
            s !== e && Sn(n, s, t, this);
        } else {
            Sn(n, s, t, this);
        }
        return !0;
    }
    deleteProperty(t, n) {
        if (typeof n != "string" || !delete t[n]) {
            return !1;
        }
        Array.isArray(t) || Ul(this.$, this, kn(t, n, this.ut));
        return !0;
    }
    has(t, n) {
        if (n === gs) {
            return !0;
        }
        if (typeof n === "string") {
            const e = Ec();
            if (e) {
                const s = e.Ot;
                s && _n(t, Array.isArray(t) ? Ss : n, this, s);
            }
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    ownKeys(t) {
        const n = Ec();
        const e = n?.Ot;
        e && _n(t, Ss, this, e);
        return Reflect.ownKeys(t);
    }
    getOwnPropertyDescriptor(t, n) {
        const e = Reflect.getOwnPropertyDescriptor(t, n);
        if (Array.isArray(t) || typeof n === "symbol") {
            return e;
        }
        if (e && !e.configurable) {
            return e;
        }
        return {
            enumerable: !0,
            configurable: !0
        };
    }
}

function _n(t, n, e, s) {
    const o = e.ut ||= new Map;
    let r = o.get(n);
    if (!r) {
        r = new Set;
        o.set(n, r);
    }
    Dl(r, s);
    Vl(s, t);
    oe && Wl(s, e.$);
}

function Sn(t, n, e, s) {
    e[t] = n;
    const o = kn(e, t, s.ut);
    o && Ul(s.$, s, o);
}

function kn(t, n, e) {
    let s;
    if (e) {
        if (Array.isArray(t)) {
            for (const t of e.values()) {
                s ||= new Set;
                for (const n of t) {
                    s.add(n);
                }
            }
        } else {
            s = e.get(n);
        }
    }
    const o = e?.get(Ss);
    if (o) {
        s ||= new Set;
        for (const t of o) {
            s.add(t);
        }
    }
    return s;
}

const eu = Symbol();

const ru = [ void 0, null, !0, !1, "", Cs, js, bs, Ss, Is, Mi, Pi, NaN, Infinity, -Infinity, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER - 1, Number.MIN_SAFE_INTEGER ];

const su = [ "undefined", "null", "true", "false", "''", "EMPTY_ARRAY", "EMPTY_OBJ", "NEEDS_COMPUTATION", "STORE_ALL_PROPS", "_UNINITIALIZED", "Slot", "Fragment", "NaN", "Infinity", "-Infinity", "MAX_SAFE_INTEGER", "MAX_SAFE_INTEGER-1", "MIN_SAFE_INTEGER" ];

const iu = [ "Plain", "RootRef", "ForwardRef", "Constant", "Array", "Object", "URL", "Date", "Regex", "QRL", "VNode", "RefVNode", "BigInt", "URLSearchParams", "ForwardRefs", "TemporalDuration", "TemporalInstant", "TemporalPlainDate", "TemporalPlainDateTime", "TemporalPlainMonthDay", "TemporalPlainTime", "TemporalPlainYearMonth", "TemporalZonedDateTime", "Error", "Promise", "Set", "Map", "Uint8Array", "Task", "Component", "Signal", "WrappedSignal", "ComputedSignal", "AsyncSignal", "SerializerSignal", "Store", "FormData", "JSXNode", "PropsProxy", "SubscriptionData", "EffectSubscription" ];

function En(t, n, e) {
    let s = n.bt;
    let o = n.vt;
    const r = Nr();
    if (r) {
        const t = r.chunkForSymbol(s, o);
        if (t) {
            o = t[1];
            s = t[0];
        }
    }
    const i = (t => _e(t) && t.bt == ge)(n);
    if (i) {
        const e = n.resolved;
        o = "";
        s = t.gt(null, 0, e) + "";
    } else {
        o || (o = t._t(n.it));
        if (!o) {
            throw ve(14, [ n.bt ]);
        }
        o.startsWith("./") && (o = o.slice(2));
    }
    const c = n.getCaptured();
    let l = null;
    c && c.length > 0 && (l = c.map(n => "" + t.St(n)).join(" "));
    if (e) {
        return [ o, s, l ];
    }
    let u = `${o}#${s}`;
    l && (u += "#" + l);
    return u;
}

function xn(t, n, e, s) {
    return Kc(t, n, null, null, e, s);
}

function qn(t, n) {
    const [e, s, o] = t.split("#");
    return xn(e, s, o || null, n);
}

class ou {
    Mn;
    Nn=0;
    Et=[];
    In=0;
    Cn=new Set;
    jn=new Map;
    On;
    Fn=new Map;
    Nt;
    Ln=typeof Temporal !== "undefined";
    constructor(t) {
        this.Mn = t;
        this.Nt = t.Nt;
    }
    async serialize() {
        await this.outputRoots();
    }
    outputArray(t, n, e) {
        this.Nt.write("[");
        let s = !1;
        let o;
        if (n) {
            o = t.length;
        } else {
            o = t.length - 1;
            for (;o >= 0 && t[o] === void 0; ) {
                o--;
            }
            o++;
        }
        for (let n = 0; n < o; n++) {
            s ? this.Nt.write(Zr) : s = !0;
            e(t[n], n);
        }
        this.Nt.write("]");
    }
    stringNeedsJsonEscape$(t) {
        for (let n = 0; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 32 || e === 34 || e === 92) {
                return !0;
            }
        }
        return !1;
    }
    maybeNumericObjectKey$(t) {
        if (t.length === 0 || t.length >= 8) {
            return t;
        }
        let n = 0;
        if (t.charCodeAt(0) === 45) {
            if (t.length === 1) {
                return t;
            }
            n = 1;
        }
        const e = t.charCodeAt(n);
        if (e < 49 || e > 57) {
            return t;
        }
        for (n++; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 48 || e > 57) {
                return t;
            }
        }
        return +t;
    }
    output(t, n, e) {
        if (typeof n === "number") {
            this.Nt.write(t + Zr + n);
        } else if (typeof n === "string") {
            const e = this.stringNeedsJsonEscape$(n) ? JSON.stringify(n) : '"' + n + '"';
            this.Nt.write(t + Zr);
            let s = -1;
            let o = 0;
            for (;(s = e.indexOf("</", o)) !== -1; ) {
                this.Nt.write(e.slice(o, s));
                this.Nt.write("<\\/");
                o = s + 2;
            }
            this.Nt.write(o === 0 ? e : e.slice(o));
        } else {
            this.Nt.write(t + Zr);
            this.outputArray(n, !!e, (t, n) => {
                this.writeValue(t, n);
            });
        }
    }
    getSeenRefOrOutput(t, n, e) {
        let s = this.Mn.getSeenRef(t);
        const o = !e && this.jn.get(t);
        if (!s) {
            if (e) {
                return !0;
            }
            if (typeof o !== "number") {
                return this.Mn.Dn(t, this.On, n);
            }
            s = this.Mn.St(t, !0);
        }
        if (s.On) {
            if (this.On) {
                this.Mn.Vn(s);
            } else {
                this.Mn.Vn(s, n);
                t = this.Mn.Wn[n];
            }
        }
        if (typeof o === "number") {
            this.Et[o] = s.Ht;
            this.jn.delete(t);
        }
        const r = t instanceof du ? t.Un : s.Ht;
        if (!this.On && r === n) {
            return s;
        }
        this.output(1, r);
    }
    writeValue(t, n) {
        if (ac(t)) {
            this.output(3, 0);
        } else {
            switch (typeof t) {
              case "undefined":
                this.output(3, 0);
                break;

              case "boolean":
                this.output(3, t ? 2 : 3);
                break;

              case "number":
                Number.isNaN(t) ? this.output(3, 12) : Number.isFinite(t) ? t === Number.MAX_SAFE_INTEGER ? this.output(3, 15) : t === Number.MAX_SAFE_INTEGER - 1 ? this.output(3, 16) : t === Number.MIN_SAFE_INTEGER ? this.output(3, 17) : this.output(0, t) : this.output(3, t < 0 ? 14 : 13);
                break;

              case "string":
                t.length === 0 ? this.output(3, 4) : (t.length < 4 || this.getSeenRefOrOutput(t, n)) && this.output(0, t);
                break;

              case "bigint":
                (t < 1e4 && t > -1e3 || this.getSeenRefOrOutput(t, n)) && this.output(12, "" + t);
                break;

              case "symbol":
                t === bs ? this.output(3, 7) : t === Ss ? this.output(3, 8) : t === Is ? this.output(3, 9) : t === eu && this.output(3, 0);
                break;

              case "function":
                if (t === Mi) {
                    this.output(3, 10);
                } else if (t === Pi) {
                    this.output(3, 11);
                } else if (_e(t)) {
                    if (this.getSeenRefOrOutput(t, n)) {
                        const [n, e, s] = En(this.Mn, t, !0);
                        let o;
                        if (n !== "") {
                            o = `${this.Mn.St(n)}#${this.Mn.St(e)}${s ? "#" + s : ""}`;
                            const r = this.Fn.get(o);
                            if (r) {
                                const t = this.Mn.St(r);
                                this.output(1, t);
                                return;
                            }
                            this.Fn.set(o, t);
                        } else {
                            o = +e;
                        }
                        this.output(9, o);
                    }
                } else {
                    if (!df(t)) {
                        throw ve(34, [ "" + t ]);
                    }
                    {
                        const [n] = t[hf];
                        this.Mn.Xn.add(n.bt);
                        this.output(29, [ n ]);
                    }
                }
                break;

              case "object":
                if (t === Cs) {
                    this.output(3, 5);
                } else if (t === js) {
                    this.output(3, 6);
                } else if (t === null) {
                    this.output(3, 1);
                } else if (t instanceof du) {
                    this.output(1, t.Un);
                } else {
                    const e = this.getSeenRefOrOutput(t, n);
                    if (e) {
                        const n = this.On;
                        this.On = e;
                        this.writeObjectValue(t);
                        this.On = n;
                    }
                }
                break;

              default:
                throw ve(20, [ typeof t ]);
            }
        }
    }
    writeObjectValue(t) {
        if (Xs(t)) {
            const n = t[As];
            this.output(38, [ au(n), n.varProps, n.constProps, t[Ms].ut ]);
        } else if (t instanceof li) {
            this.output(39, [ t.data.j, t.data.et ]);
        } else if (t instanceof vs) {
            this.output(40, [ t.consumer, t.property, t.data ]);
        } else if (Zl(t)) {
            const n = Jl(t);
            const e = Ql(t);
            const s = n.h;
            const o = n.ut;
            const r = [];
            for (const t in e) {
                const n = e[t];
                const s = this.Mn.ht.get(n);
                s && r.push(s);
            }
            const i = [ e, s, o, ...r ];
            for (;i[i.length - 1] === void 0; ) {
                i.pop();
            }
            this.output(35, i);
        } else if (Xl(t)) {
            const n = t[pc](t);
            if (dr(n)) {
                const t = this.resolvePromise(n, (t, n) => new lu(34, t, n, void 0, void 0));
                this.output(2, t);
            } else {
                const t = this.On.Ht;
                this.On = this.On.On;
                this.writeValue(n, t);
            }
        } else if (function n(t) {
            const n = Object.getPrototypeOf(t);
            return n == null || n === Object.prototype || n === Array.prototype;
        }(t)) {
            if (Array.isArray(t)) {
                this.output(4, t);
            } else {
                const n = [];
                for (const e in t) {
                    if (Object.prototype.hasOwnProperty.call(t, e)) {
                        const s = t[e];
                        ac(s) || n.push(this.maybeNumericObjectKey$(e), s);
                    }
                }
                this.output(5, n.length ? n : 0);
            }
        } else if (this.Mn.zn(t)) {
            t.Bn.vnodeData[0] |= 16;
            this.output(11, t.Bn.id);
        } else if (t instanceof Es) {
            if (t instanceof Bs) {
                const n = function e(t, n) {
                    if (n === bs) {
                        return n;
                    }
                    return $r(t.Zt.resolved || t.Zt.resolve(), t => {
                        let e;
                        typeof t === "function" && (t = t());
                        t.serialize ? e = t.serialize(n) : typeof n === "object" && pc in n && (e = n[pc](n));
                        e === void 0 && (e = bs);
                        return e;
                    });
                }(t, t.Gt);
                if (dr(n)) {
                    const e = this.resolvePromise(n, (n, e) => new lu(34, n, e, t.ut, t.Zt));
                    this.output(2, e);
                } else {
                    this.output(34, [ t.Zt, t.ut, n ]);
                }
                return;
            }
            if (t instanceof oi) {
                this.output(31, [ ...Tn(this.Mn, t), t.h, t.m, ...t.ut || [] ]);
            } else if (t instanceof xs) {
                let n = t.Gt;
                const e = t.h & 16;
                const s = t.h & 8;
                const o = t.h & 1;
                const r = ac(t.Gt);
                const i = t instanceof Ts;
                const c = i && t.xt !== 0 ? t.xt : void 0;
                const l = i && t.dn !== 1 ? t.dn : void 0;
                const u = i && t.$n !== 0 ? t.$n : void 0;
                const f = i && t.h & -25 || void 0;
                o || r ? n = bs : e ? n = t.Gt : s && (n = bs);
                const a = [ t.Zt, t.ut ];
                if (i) {
                    a.push(t.dt, t.$t, t.an);
                    a.push(f || void 0);
                }
                n === bs && c === void 0 && l === void 0 && u === void 0 || a.push(n === void 0 ? eu : n);
                if (i) {
                    a.push(c);
                    a.push(l);
                    a.push(u);
                }
                this.output(i ? 33 : 32, a);
            } else {
                const n = t.Gt;
                const e = [ n === void 0 ? eu : n ];
                t.ut && e.push(...t.ut);
                this.output(30, e);
            }
        } else if (t instanceof URL) {
            this.output(6, t.href);
        } else if (t instanceof Date) {
            this.output(7, Number.isNaN(t.valueOf()) ? "" : t.valueOf());
        } else if (this.Ln && t instanceof Temporal.Duration) {
            this.output(15, t.toJSON());
        } else if (this.Ln && t instanceof Temporal.Instant) {
            this.output(16, t.toJSON());
        } else if (this.Ln && t instanceof Temporal.PlainDate) {
            this.output(17, t.toJSON());
        } else if (this.Ln && t instanceof Temporal.PlainDateTime) {
            this.output(18, t.toJSON());
        } else if (this.Ln && t instanceof Temporal.PlainMonthDay) {
            this.output(19, t.toJSON());
        } else if (this.Ln && t instanceof Temporal.PlainTime) {
            this.output(20, t.toJSON());
        } else if (this.Ln && t instanceof Temporal.PlainYearMonth) {
            this.output(21, t.toJSON());
        } else if (this.Ln && t instanceof Temporal.ZonedDateTime) {
            this.output(22, t.toJSON());
        } else if (t instanceof RegExp) {
            this.output(8, "" + t);
        } else if (t instanceof Error) {
            const n = [ t.message ];
            n.push(...Object.entries(t).flat());
            this.output(23, n);
        } else if (this.Mn.Hn(t)) {
            const n = this.Mn.St(t);
            this.Mn.Jn(t, "q:id", n + "");
            this.output(10, t.id);
            const e = t.vnodeData;
            if (e) {
                uu(e, t => this.Mn.St(t));
                e[0] |= 16;
            }
            if (t.children) {
                const n = t.children.length;
                for (let e = 0; e < n; e++) {
                    const n = t.children[e];
                    const s = n.vnodeData;
                    s && (s[0] |= 16);
                }
            }
        } else if (typeof FormData !== "undefined" && t instanceof FormData) {
            const n = [];
            for (const [e, s] of t.entries()) {
                typeof s === "string" && n.push(e, s);
            }
            this.output(36, n);
        } else if (t instanceof URLSearchParams) {
            this.output(13, "" + t);
        } else if (t instanceof Set) {
            this.output(25, [ ...t.values() ]);
        } else if (t instanceof Map) {
            const n = [];
            for (const [e, s] of t.entries()) {
                n.push(e, s);
            }
            this.output(26, n);
        } else if (ai(t)) {
            const n = [ t.type, t.key, t.varProps, t.constProps, t.children, t.toSort || void 0 ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(37, n);
        } else if (t instanceof jl) {
            const n = [ t.wt, t.h, t.Ht, t.ct, t.It ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(28, n);
        } else if (dr(t)) {
            const n = this.resolvePromise(t, (t, n) => new lu(24, t, n));
            this.output(2, n);
        } else if (t instanceof lu) {
            if (t.Qn === 34) {
                if (t.wt) {
                    this.output(34, [ t.wt, t.ut, t.Yn ]);
                } else {
                    if (!t.Gn) {
                        console.error(t.Yn);
                        throw ve(33);
                    }
                    {
                        const n = this.On.Ht;
                        this.On = this.On.On;
                        this.writeValue(t.Yn, n);
                    }
                }
            } else {
                this.output(24, [ t.Gn, t.Yn ]);
            }
        } else if (t instanceof Uint8Array) {
            let n = "";
            const e = t.length;
            for (let s = 0; s < e; s++) {
                n += String.fromCharCode(t[s]);
            }
            const s = btoa(n).replace(/=+$/, "");
            this.output(27, s);
        } else if (t instanceof fu) {
            const n = t.Kn;
            if (this.getSeenRefOrOutput(n, this.On.Ht, !0)) {
                let t = this.jn.get(n);
                if (t === void 0) {
                    t = this.In++;
                    this.jn.set(n, t);
                    this.Et[t] = -1;
                }
                this.output(2, t);
            }
        } else {
            if (!ko(t)) {
                throw ve(20, [ typeof t ]);
            }
            this.output(3, 0);
        }
    }
    resolvePromise(t, n) {
        const e = this.In++;
        t.then(s => {
            this.Cn.delete(t);
            this.Et[e] = this.Mn.St(n(!0, s));
        }).catch(s => {
            this.Cn.delete(t);
            this.Et[e] = this.Mn.St(n(!1, s));
        });
        this.Cn.add(t);
        return e;
    }
    async outputRoots() {
        this.Nt.write("[");
        const {Wn: t} = this.Mn;
        for (;this.Nn < t.length || this.Cn.size; ) {
            this.Nn !== 0 && this.Nt.write(Zr);
            let n = !1;
            for (;this.Nn < t.length; this.Nn++) {
                n ? this.Nt.write(Zr) : n = !0;
                this.writeValue(t[this.Nn], this.Nn);
            }
            if (this.Cn.size) {
                try {
                    await Promise.race(this.Cn);
                } catch {}
            }
        }
        if (this.Et.length) {
            let t = this.Et.length - 1;
            for (;t >= 0 && this.Et[t] === -1; ) {
                t--;
            }
            if (t >= 0) {
                this.Nt.write(Zr);
                this.Nt.write(14 + Zr);
                const n = t === this.Et.length - 1 ? this.Et : this.Et.slice(0, t + 1);
                this.outputArray(n, !0, t => {
                    this.Nt.write(t + "");
                });
            }
        }
        this.Nt.write("]");
    }
}

class lu {
    Qn;
    Gn;
    Yn;
    ut;
    wt;
    constructor(t, n, e, s, o) {
        this.Qn = t;
        this.Gn = n;
        this.Yn = e;
        this.ut = s;
        this.wt = o;
    }
}

const uu = (t, n) => {
    const e = t.length;
    for (let s = 0; s < e; s++) {
        const e = t[s];
        if (cu(e)) {
            for (const t in e) {
                const s = e[t];
                if (s == null || typeof s === "string" || t === Ke && Kr(s)) {
                    continue;
                }
                n(s);
            }
        }
    }
};

const cu = t => typeof t === "object" && t !== null && !Kr(t);

function Tn(t, n) {
    n.kt && n.kt[0] === "{" && (n.kt = `(${n.kt})`);
    const e = t.gt(n.kt, n.lt.length, n.ot);
    return [ e, n.lt ];
}

class fu {
    Kn;
    constructor(t) {
        this.Kn = t;
    }
}

const au = t => new fu(t);

let hu = () => !1;

class du {
    Un;
    constructor(t) {
        this.Un = t;
    }
}

class pu {
    NodeConstructor;
    DomRefConstructor;
    _t;
    Jn;
    ht;
    Nt;
    Zn=new Map;
    te=new Map;
    ne=[];
    Wn=[];
    qt=new Set;
    At=new Set;
    Rt=new Set;
    Xn=new Set;
    ee;
    constructor(t, n, e, s, o, r) {
        this.NodeConstructor = t;
        this.DomRefConstructor = n;
        this._t = e;
        this.Jn = s;
        this.ht = o;
        this.Nt = r;
        this.ee = new ou(this);
    }
    async Mt() {
        return await this.ee.serialize();
    }
    getSeenRef(t) {
        return this.Zn.get(t);
    }
    Dn(t, n, e) {
        const s = {
            Ht: e,
            On: n
        };
        this.Zn.set(t, s);
        return s;
    }
    re(t) {
        const n = [];
        for (;t.On; ) {
            n.unshift(t.Ht);
            t = t.On;
        }
        n.unshift(t.Ht);
        return n.join(" ");
    }
    Vn(t, n) {
        const e = this.re(t);
        n === void 0 && (n = this.Wn.length);
        this.Wn[n] = new du(e);
        t.On = null;
        t.Ht = n;
    }
    St(t, n = !1) {
        let e = this.Zn.get(t);
        let s;
        if (e) {
            e.On && this.Vn(e);
            s = e.Ht;
        } else {
            s = this.Wn.length;
            e = {
                Ht: s
            };
            this.Zn.set(t, e);
            this.Wn.push(t);
        }
        return n ? e : s;
    }
    Hn(t) {
        return !!this.NodeConstructor && t instanceof this.NodeConstructor;
    }
    zn(t) {
        return !!this.DomRefConstructor && t instanceof this.DomRefConstructor;
    }
    se(t) {
        const n = this.Zn.get(t);
        return n && (n.On ? void 0 : n.Ht);
    }
    gt(t, n, e) {
        const s = t == null;
        s && (t = e.serialized || "" + e);
        let o = this.te.get(t);
        if (o === void 0) {
            o = this.ne.length;
            this.te.set(t, o);
            if (s) {
                this.ne.push(t);
            } else {
                let e = "(";
                for (let t = 0; t < n; t++) {
                    e += (t == 0 ? "p" : ",p") + t;
                }
                this.ne.push(e += ")=>" + t);
            }
        }
        return o;
    }
}

const $u = (t, n, e, s, o, r) => {
    if (!r) {
        const t = [];
        r = {
            write: n => {
                t.push(n);
            },
            toString: () => t.join("")
        };
    }
    hu = n ? t => t instanceof n : () => !1;
    return new pu(t, n, e, s, o, r);
};

const yu = (t, n) => t[n];

const mu = (t, n = new WeakSet) => {
    const e = typeof Temporal !== "undefined";
    if (t == null || typeof t === "string" || typeof t === "number" || typeof t === "boolean" || typeof t === "bigint") {
        return !0;
    }
    if (typeof t === "object") {
        if (n.has(t)) {
            return !0;
        }
        n.add(t);
        const s = Object.getPrototypeOf(t);
        Zl(t) && (t = Ql(t));
        if (s == Object.prototype) {
            for (const e in t) {
                if (!mu(Pc(yu, t, e), n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (s == Array.prototype) {
            for (let e = 0; e < t.length; e++) {
                if (!(e in t)) {
                    return !1;
                }
                if (!mu(t[e], n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (Ol(t)) {
            return !0;
        }
        if (Xs(t)) {
            return !0;
        }
        if (dr(t)) {
            return !0;
        }
        if (ai(t)) {
            return !0;
        }
        if (Xl(t)) {
            return !0;
        }
        if (t instanceof Error) {
            return !0;
        }
        if (t instanceof URL) {
            return !0;
        }
        if (t instanceof Date) {
            return !0;
        }
        if (e && t instanceof Temporal.Duration) {
            return !0;
        }
        if (e && t instanceof Temporal.Instant) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDate) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDateTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainMonthDay) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainYearMonth) {
            return !0;
        }
        if (e && t instanceof Temporal.ZonedDateTime) {
            return !0;
        }
        if (t instanceof RegExp) {
            return !0;
        }
        if (t instanceof URLSearchParams) {
            return !0;
        }
        if (t instanceof FormData) {
            return !0;
        }
        if (t instanceof Set) {
            return !0;
        }
        if (t instanceof Map) {
            return !0;
        }
        if (t instanceof Uint8Array) {
            return !0;
        }
        if (t instanceof li) {
            return !0;
        }
        if (hu?.(t)) {
            return !0;
        }
    } else if (typeof t === "function") {
        if (_e(t) || df(t) || t === Mi || t === Pi) {
            return !0;
        }
    } else if (t === Is || t === bs || t === Ss) {
        return !0;
    }
    return !1;
};

const wu = (t, n) => {
    let e = ko(t) ? hn.call(t, 1, "", !0).replaceAll(/\n.*/gm, "") : typeof t === "function" ? t + "" : (t => {
        const n = new WeakSet;
        return JSON.stringify(t, (t, e) => {
            if (ye(e)) {
                if (n.has(e)) {
                    return `[Circular ${e.constructor.name}]`;
                }
                n.add(e);
            }
            return e;
        }, 2);
    })(t);
    e.length > 500 && (e = e.slice(0, 500) + '"...');
    e = e.replace(/\n/g, "\n" + n);
    return e.includes("\n") ? e = `\n${n}${e}` : e;
};

let bu = !1;

const vu = (t, n = !1, e = "", s = 20) => {
    const o = n ? "[31m" : "";
    const r = n ? "[0m" : "";
    const i = e === "";
    const c = [];
    for (let i = 0; i < t.length; i++) {
        if (s && i > 2 * s) {
            c.push("...");
            break;
        }
        const l = t[i];
        let u = t[++i];
        if (l === 0) {
            const t = typeof u !== "number" && typeof u !== "string";
            t && (bu = !0);
            const n = `{${ye(u) ? u.constructor.name : typeof u}}`;
            c.push(`${o}${n}${r} ${wu(u, e + "  ")}`);
        } else {
            if (l === 3) {
                u = _u(u);
            } else if (typeof u === "string") {
                u = JSON.stringify(u);
                u.length > 120 && (u = u.slice(0, 120) + '"...');
            } else {
                l === 14 ? u = `[\n${e}  ${u.join(`\n${e}  `)}\n${e}]` : Array.isArray(u) && (u = u.length ? `[\n${vu(u, n, e + "  ")}\n${e}]` : "[]");
            }
            c.push(`${o}${gu(l)}${r} ${u}`);
        }
    }
    const l = c.map((t, n) => `${e}${i ? n + " " : ""}${t}`).join("\n");
    if (i) {
        const n = bu ? "" : `(${JSON.stringify(t).length} chars)`;
        bu = !1;
        return `\n${l}\n${n}`;
    }
    return l;
};

const gu = t => iu[t] || `Unknown(${t})`;

const _u = t => su[t] || `Unknown(${t})`;

function Pn(t, n) {
    const e = (t, n) => t === 1 && typeof n === "string";
    const s = t => t === 14;
    const o = n => {
        const e = t[n + 1].split(" ");
        let s = t;
        let o = 1;
        let r = 0;
        let i = 0;
        let c = null;
        for (let n = 0; n < e.length; n++) {
            c = s;
            r = parseInt(e[n], 10) * 2;
            i = r + 1;
            o = s[r];
            s = s[i];
            if (o === 1) {
                const n = s;
                const e = n * 2;
                o = t[e];
                s = t[e + 1];
            }
        }
        if (c) {
            c[r] = 1;
            c[i] = n / 2;
        }
        t[n] = o;
        t[n + 1] = s;
    };
    for (let r = 0; r < t.length; r += 2) {
        e(t[r], t[r + 1]) ? o(r) : s(t[r]) && (n.Et = t[r + 1]);
    }
}

const Su = new WeakMap;

const ku = new Map;

const Eu = (t, n, e) => {
    switch (n) {
      case 0:
        return e;

      case 1:
        return t._(e);

      case 2:
        if (!t.Et) {
            return Is;
        }
        const s = t.Et[e];
        return s === -1 || s === void 0 ? Is : t._(s);

      case 14:
        return e;

      case 3:
        return ru[e];

      case 4:
        return Array(e.length / 2);

      case 5:
        return {};

      case 9:
        {
            let n;
            if (typeof e === "string") {
                const [s, o, r] = e.split("#");
                const i = t._(s);
                const c = t._(o);
                n = xn(i, c, r || null, t);
            } else {
                n = xn("", e + "", null, t);
            }
            return n;
        }

      case 28:
        return new jl(-1, -1, null, null, null, null);

      case 6:
        return new URL(e);

      case 7:
        return new Date(e);

      case 15:
        return Temporal.Duration.from(e);

      case 16:
        return Temporal.Instant.from(e);

      case 17:
        return Temporal.PlainDate.from(e);

      case 18:
        return Temporal.PlainDateTime.from(e);

      case 19:
        return Temporal.PlainMonthDay.from(e);

      case 20:
        return Temporal.PlainTime.from(e);

      case 21:
        return Temporal.PlainYearMonth.from(e);

      case 22:
        return Temporal.ZonedDateTime.from(e);

      case 8:
        const o = e.lastIndexOf("/");
        return RegExp(e.slice(1, o), e.slice(o + 1));

      case 23:
        return Error();

      case 29:
        return af(null);

      case 30:
        return new Es(t, 0);

      case 31:
        return new oi(t, null, null, null);

      case 32:
        return new xs(t, null);

      case 33:
        return new Ts(t, null, void 0, {});

      case 34:
        return new Bs(t, null);

      case 35:
        {
            const n = e;
            const s = n[0];
            const o = n[1];
            const r = Eu(t, s, o);
            const i = tu(r, 0, t);
            ec(s) && ku.set(r, {
                t: s,
                v: o
            });
            n[0] = 0;
            n[1] = r;
            return i;
        }

      case 13:
        return new URLSearchParams(e);

      case 36:
        return new FormData;

      case 37:
        return new ci(null, null, null, null, 0, null);

      case 12:
        return BigInt(e);

      case 25:
        return new Set;

      case 26:
        return new Map;

      case 24:
        let r;
        let i;
        const c = new Promise((t, n) => {
            r = t;
            i = n;
        });
        Su.set(c, [ r, i ]);
        c.catch(() => {});
        return c;

      case 27:
        const l = e.length;
        const u = l >>> 2;
        const f = l & 3;
        const a = u * 3 + (f ? f - 1 : 0);
        return new Uint8Array(a);

      case 38:
        return $(null);

      case 10:
        return Rn(t, e);

      case 11:
        const h = Rn(t, e);
        if (ko(h)) {
            ll(h);
            return ql(h);
        }
        throw ve(17, [ typeof h ]);

      case 39:
        return new li({});

      case 40:
        return new vs(null, null, null, null);

      default:
        throw ve(18, [ n ]);
    }
};

function Rn(t, n) {
    return n ? t.rootVNode ? Lo(t.rootVNode, n) : void 0 : t.element?.ownerDocument;
}

const xu = (t, n, e) => {
    let s = null;
    let o = null;
    if (be(t)) {
        o = t;
    } else {
        if (!we(t)) {
            throw ve(7, [ t ]);
        }
        s = t;
    }
    return Kc(s, n, null, o, e);
};

const qu = (t, n, e) => Kc(null, n, t, null, e);

const Tu = (t, n) => Kc(null, t, null, null, n);

const Pu = (t, n, e) => {
    const s = Tu(t, e);
    return s;
};

const Ru = (t, n, e, s) => Kc(t, e, null, n, s);

const Au = (t, n, e, s, o) => {
    const r = Ru(t, n, e, o);
    r.ie(s);
    return r;
};

const Mu = (t, n, e, s) => {
    const o = xu(t, n, s);
    return o;
};

const Nu = (t, n, e, s) => {
    const o = qu(t, n, s);
    return o;
};

const Iu = (t, n) => {
    typeof globalThis.__qwik_reg_symbols === "undefined" && (globalThis.__qwik_reg_symbols = new Map);
    globalThis.__qwik_reg_symbols.set(n, t);
    return t;
};

const Cu = () => {
    const t = globalThis.process;
    return t?.getBuiltinModule?.("node:async_hooks")?.AsyncLocalStorage;
};

function An(t) {
    return t === null || typeof t === "string" || typeof t === "number" || typeof t === "boolean";
}

const ju = (t, n, e) => new oi(null, t, n, e || null);

class Ou {
    oe;
    ht;
    Ct;
    _;
    Lt;
    le=0;
    ue=null;
    ce=null;
    l=null;
    u=null;
    o=0;
    constructor(t, n) {
        this.Lt = t;
        this.Ct = n;
        this.oe = ts;
        this.ht = new WeakMap;
        this._ = () => {
            throw Error("Not implemented");
        };
    }
    trackSignalValue(t, n, e, s) {
        return Mc(t, n, e, this, s);
    }
    serializationCtxFactory(t, n, e, s) {
        return $u(t, n, e, this.setHostProp.bind(this), this.ht, s);
    }
    ft() {
        if (this.o === 0) {
            this.u?.();
            this.l = null;
        }
    }
}

class Fu {}

function Mn(t, n, e) {
    return () => {
        t.currentStyleScoped = n;
        t.parentComponentFrame = e;
    };
}

async function Nn(t, e, s) {
    const o = [ e ];
    const r = t => o.push(t);
    await (async () => {
        for (;o.length; ) {
            try {
                const e = o.pop();
                if (e === Fu) {
                    const t = o.pop();
                    await n(() => o.push(t()));
                    continue;
                }
                if (typeof e === "function") {
                    e === Promise ? o.push(await o.pop()) : await e.apply(t);
                    continue;
                }
                In(t, r, e, s);
            } finally {
                const n = t.streamHandler.waitForPendingFlush();
                dr(n) && await n;
            }
        }
    })();
}

function In(t, n, e, s) {
    if (e == null) {
        t.textNode("");
    } else if (typeof e === "boolean") {
        t.textNode("");
    } else if (typeof e === "number") {
        t.textNode(e + "");
    } else if (typeof e === "string") {
        t.textNode(e);
    } else if (typeof e === "object") {
        if (Array.isArray(e)) {
            for (let t = e.length - 1; t >= 0; t--) {
                n(e[t]);
            }
        } else if (Ll(e)) {
            (function s(t, n) {
                const e = n instanceof oi ? n.st() : n;
                if (e instanceof Ts) {
                    const n = e.xt;
                    if (n && !(e.h & 256)) {
                        t.St(e);
                        t.qt.add(e);
                    }
                }
            })(t.serializationCtx, e);
            t.openFragment(js);
            const o = t.getOrCreateLastNode();
            const r = e instanceof oi ? e.st() : e;
            n(t.closeFragment);
            n(() => Mc(r, o, ".", t));
            n(Fu);
        } else if (dr(e)) {
            t.openFragment(js);
            n(t.closeFragment);
            n(e);
            n(Promise);
            n(() => t.streamHandler.flush());
        } else if (function o(t) {
            return !!t[Symbol.asyncIterator];
        }(e)) {
            n(async () => {
                for await (const n of e) {
                    await Nn(t, n, {
                        currentStyleScoped: s.currentStyleScoped,
                        parentComponentFrame: s.parentComponentFrame
                    });
                    await t.streamHandler.flush();
                }
            });
        } else {
            const o = e;
            const r = o.type;
            if (typeof r === "string") {
                (function e(t, n) {
                    const e = Ds(t, "class") != null;
                    if (!e && n) {
                        t.constProps || (t.constProps = {});
                        t.constProps.class = "";
                    }
                })(o, s.currentStyleScoped);
                let i = null;
                const c = t.openElement(r, o.key, o.varProps, o.constProps, s.currentStyleScoped, i, !!(o.flags & 4));
                c && t.htmlNode(c);
                n(t.closeElement);
                if (r === "head") {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    n(t.additionalHeadNodes);
                } else if (r === "body") {
                    n(t.additionalBodyNodes);
                } else if (!t.isHtml && !t._didAddQwikLoader && !t.Tt) {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    t._didAddQwikLoader = !0;
                }
                const l = o.children;
                l != null && n(l);
            } else if (be(r)) {
                if (r === Pi) {
                    const e = o.key != null ? {
                        [Ge]: o.key
                    } : {};
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = o.children;
                    s != null && n(s);
                } else if (r === Mi) {
                    const e = s.parentComponentFrame;
                    if (e) {
                        const r = e.componentNode.id || "";
                        const i = {};
                        const c = Ds(o, lr);
                        c && (i[lr] = c);
                        i["q:sparent"] = r;
                        t.openProjection(i);
                        const l = e.componentNode;
                        const u = t.getOrCreateLastNode();
                        const f = function a(t, n, e) {
                            const s = n.constProps;
                            if (s && typeof s == "object" && "name" in s) {
                                const n = s.name;
                                if (n instanceof oi) {
                                    return Mc(n, t, ":", e);
                                }
                            }
                            return Ds(n, "name") || "";
                        }(l, o, t);
                        i[Pe] = f;
                        n(Mn(s, s.currentStyleScoped, s.parentComponentFrame));
                        n(t.closeProjection);
                        const h = o.children || null;
                        const d = e.consumeChildrenForSlot(u, f) || h;
                        h && d !== h && t.addUnclaimedProjection(e, "", h);
                        n(d);
                        n(Mn(s, e.projectionScopedStyle, e.projectionComponentFrame));
                    } else {
                        let n = js;
                        t.openFragment(n);
                        t.closeFragment();
                    }
                } else if (r === Ci) {
                    t.commentNode(Ds(o, "data") || "");
                } else if (r === Oi) {
                    t.streamHandler.flush();
                    const e = o.children;
                    let r;
                    r = be(e) ? e({
                        async write(n) {
                            await Nn(t, n, {
                                currentStyleScoped: s.currentStyleScoped,
                                parentComponentFrame: s.parentComponentFrame
                            });
                            await t.streamHandler.flush();
                        }
                    }) : e;
                    n(r);
                    dr(r) && n(Promise);
                } else if (r === Ii) {
                    t.htmlNode(Ds(o, "data"));
                } else if (r === ji) {
                    t.streamHandler.streamBlockStart();
                    n(() => t.streamHandler.streamBlockEnd());
                    n(o.children);
                } else if (df(r)) {
                    const e = {};
                    t.openComponent(e);
                    const i = t.getOrCreateLastNode();
                    const c = t.getParentComponentFrame();
                    c.distributeChildrenIntoSlots(o.children, s.currentStyleScoped, s.parentComponentFrame);
                    const l = ((t, n, e) => {
                        const s = t.getOrCreateLastNode();
                        const [o] = e[hf];
                        const r = n.props;
                        r && r.children && delete r.children;
                        s.setProp(xe, o);
                        s.setProp(Ke, r);
                        n.key !== null && s.setProp(Ge, n.key);
                        return Ai(t, s, s, o, r);
                    })(t, o, r);
                    n(Mn(s, s.currentStyleScoped, s.parentComponentFrame));
                    n(t.closeComponent);
                    if (dr(l)) {
                        n(async () => {
                            const t = await l;
                            const e = wr(i.getProp(Ie));
                            n(t);
                            n(Mn(s, e, c));
                        });
                    } else {
                        n(l);
                        const t = wr(i.getProp(Ie));
                        n(Mn(s, t, c));
                    }
                } else {
                    const e = {
                        [Ge]: o.key
                    };
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = t.getParentComponentFrame();
                    const i = ((t, n, e, s) => {
                        const o = t.getOrCreateLastNode();
                        return Ai(t, o, n, e, s.props);
                    })(t, s && s.componentNode, r, o);
                    n(i);
                    dr(i) && n(Promise);
                }
            }
        }
    }
}

const Lu = () => Bc;

const Du = async t => {
    const [n, e] = Bc;
    const s = await n(t);
    s && typeof s === "object" ? e.r ? Object.assign(e.r, s) : e.r = gn(n.$, s, 1) : e.r = s;
    return {
        r: e.r
    };
};

const Vu = (t, n) => {
    const {val: e, set: s, iCtx: o} = Ki();
    if (e) {
        return e;
    }
    const r = Kc(null, "_rsc", Du, null, [ t, {} ], o.$);
    const i = Js(r, {
        timeout: n?.timeout,
        container: o.$,
        concurrency: 0
    });
    i.p();
    const c = {
        __brand: "resource",
        signal: i,
        get value() {
            return i.promise().then(() => i.error ? Promise.reject(i.error) : i.value.r);
        },
        get loading() {
            return i.loading;
        }
    };
    s(c);
    return c;
};

const Wu = ({value: t, onResolved: n, onPending: e, onRejected: s}) => {
    if (dr(t)) {
        return t.then(n, s);
    }
    const o = Uu(t);
    const r = o ? t.signal : t;
    if (e && r.loading) {
        return e();
    }
    if (s && r.error) {
        return s(r.error);
    }
    const i = o ? r.value?.r : r.value;
    return dr(i) ? i.then(n, s) : n(i);
};

const Uu = t => t && t.__brand === "resource";

function Cn(t, n, e, s) {
    let o = null;
    const r = e;
    const i = t => {
        o = (o == null ? "" : o + "|") + t;
    };
    const c = n => {
        n.bt.startsWith("_") || !n.Pt?.length && !s || (n = Kc(null, "_run", C, null, [ n ]));
        return En(t, n);
    };
    if (Array.isArray(r)) {
        for (let e = 0; e < r.length; e++) {
            const o = r[e];
            if (_e(o)) {
                i(c(o));
                jn(t, n, o);
            } else if (o != null) {
                const e = Cn(t, n, o, s);
                e && i(e);
            }
        }
    } else if (_e(r)) {
        o = c(r);
        jn(t, n, r);
    }
    return o;
}

function jn(t, n, e) {
    const s = _r(n);
    if (s) {
        const [n, o] = s;
        const r = ((t, n) => t + ":" + n)(n, o);
        t.Rt.add(r);
        t.At.add(e);
    }
}

const Xu = (t, n, e) => {
    Hu(e?.passive ? "q-ep:" : "q-e:", t, n, e);
};

const zu = (t, n, e) => {
    Hu(e?.passive ? "q-dp:" : "q-d:", t, n, e);
};

const Bu = (t, n, e) => {
    Hu(e?.passive ? "q-wp:" : "q-w:", t, n, e);
};

const Hu = (t, n, e, s) => {
    const {isAdded: o, addEvent: r} = Ju();
    if (o) {
        return;
    }
    if (e) {
        if (Array.isArray(n)) {
            for (let o = 0; o < n.length; o++) {
                const i = n[o];
                r(t + gr(i), e, s);
            }
        } else {
            r(t + gr(n), e, s);
        }
    }
};

const Ju = () => {
    const t = qc();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, sr);
    if (s === null) {
        s = {};
        t.$.setHostProp(e, sr, s);
    }
    let o = t.$.getHostProp(e, ir);
    o === null && (o = 0);
    t.$.setHostProp(e, ir, o + 1);
    let r = t.$.getHostProp(e, or);
    if (r === null) {
        r = [];
        t.$.setHostProp(e, or, r);
    }
    for (;r.length <= o; ) {
        r.push(!1);
    }
    return {
        isAdded: r[o],
        addEvent: (t, n, e) => {
            r[o] = !0;
            let i = s[t];
            i || (s[t] = i = {
                qrls: [],
                capture: !1,
                preventdefault: !1,
                stoppropagation: !1
            });
            i.qrls.push(n);
            e?.capture && (i.capture = !0);
            e?.preventdefault && (i.preventdefault = !0);
            e?.stoppropagation && (i.stoppropagation = !0);
        }
    };
};

const Qu = function(t, n) {
    if (!t.detail.files.some(t => n.getAttribute("data-qwik-inspector")?.startsWith(t))) {
        return;
    }
    if (typeof this === "string") {
        const t = Qn(n);
        Hc(Jc(t, this));
    }
    const e = Bc[0];
    const s = Qn(n);
    sn(s, e, 4);
    const o = n.ownerDocument;
    o.__hmrDone = o.__hmrT;
};

let Yu;

function On() {
    const t = Ec();
    if (!t) {
        return;
    }
    Yu ||= qu(Qu, "_hmr");
    const n = t.m;
    const e = Yu.w([ n ]);
    zu("qHmr", e);
}

function Fn(t, n, e, s, o) {
    const r = So();
    Mo(r, Pe, o);
    r.parent = n;
    Mo(n, o, r);
    Mo(r, xe, e);
    Mo(r, Ke, s);
    r.dirty = 4;
    tn(t, r, 1);
    return r;
}

function Ln(t, n) {
    Mo(t, qe, n);
    t.flags |= 2048;
}

function Dn(t, n, e) {
    Mo(n, Ke, e);
    sn(t, n, 4);
}

function Vn(t, n, e, s) {
    Mo(n, s, null);
    const o = [];
    Et(t, o, e);
    zo(o);
    if (e.flags & 2048) {
        const t = Ao(e, qe, null);
        t && t.replaceChildren();
        Mo(e, qe, null);
        e.flags &= -2049;
    }
}

let Gu = Promise.resolve();

const Ku = new Set([ "constructor", "prototype", "toString", "valueOf", "toJSON", "then" ]);

const Zu = (t, n) => {
    if (typeof t === "number") {
        return !0;
    }
    return typeof t === "string" && t !== "__proto__" && (typeof n !== "function" || !Ku.has(t));
};

const tc = (t, n, e, s) => {
    if (e === 0) {
        return;
    }
    e !== 4 && Array.isArray(s) && (s = nc(t, s));
    switch (e) {
      case 4:
        nc(t, s, n);
        break;

      case 5:
        if (s === 0) {
            break;
        }
        for (let t = 0; t < s.length; t += 2) {
            const e = s[t];
            const o = s[t + 1];
            if (!Zu(e, o)) {
                continue;
            }
            n[e] = o;
        }
        break;

      case 28:
        const o = n;
        const r = s;
        o.wt = r[0];
        o.h = r[1];
        o.Ht = r[2];
        o.ct = r[3];
        o.It = r[4];
        break;

      case 29:
        n[hf][0] = s[0];
        break;

      case 35:
        {
            const e = Kl(n);
            const o = ku.get(e);
            if (o) {
                ku.delete(e);
                tc(t, e, o.t, o.v);
            }
            const [, r, i] = s;
            const c = Jl(n);
            c.h = r;
            c.ut = i;
            Xn(c.ut, e);
            break;
        }

      case 30:
        {
            const t = n;
            const e = s;
            t.Gt = e[0];
            t.ut = new Set(e.slice(1));
            Un(t.ut, t);
            break;
        }

      case 31:
        {
            const e = n;
            const o = s;
            e.ot = t.getSyncFn(o[0]);
            e.lt = o[1];
            e.Gt = bs;
            e.h = o[2];
            e.h |= 1;
            e.m = o[3];
            e.ut = new Set(o.slice(4));
            (function r(t) {
                if (t.m !== null && ko(t.m)) {
                    const n = t.m;
                    const e = t.ut;
                    let s = !1;
                    if (e) {
                        for (const o of e) {
                            const e = o.property;
                            if (we(e)) {
                                const o = Ao(n, e, null);
                                if (o !== null) {
                                    t.Gt = o;
                                    s = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (!s) {
                        const e = ol(n);
                        e && n.firstChild === n.lastChild && To(e) && (t.Gt = sl(e));
                    }
                }
            })(e);
            Un(e.ut, e);
            break;
        }

      case 33:
        {
            const t = n;
            const e = s;
            t.Zt = e[0];
            e[1] && (t.ut = new Set(e[1]));
            e[2] && (t.dt = new Set(e[2]));
            e[3] && (t.$t = new Set(e[3]));
            e[4] && (t.an = e[4]);
            t.h = e[5] ?? 0;
            t.h & 64 && (t.fn = !0);
            const o = e.length > 6;
            o && (t.Gt = e[6]);
            t.Gt === bs && (t.h |= 1);
            const r = e[7] ?? 0;
            t.expires = Math.abs(r);
            r < 0 && (t.h |= 256);
            if (e[8] !== void 0 && e[8] !== 1) {
                t.dn = e[8] ?? 1;
                t.pn = [];
            }
            t.$n = e[9] ?? 0;
            Un(t.ut, t);
            Un(t.dt, t);
            Un(t.$t, t);
            break;
        }

      case 34:
      case 32:
        {
            const o = n;
            const r = s;
            o.Zt = r[0];
            const i = o.Zt.resolve(t).catch(() => {});
            Gu = Gu.finally(() => i);
            r[1] && (o.ut = new Set(r[1]));
            const c = r.length > 2;
            c && (o.Gt = r[2]);
            e !== 34 && o.Gt !== bs && (o.h &= -2);
            Un(o.ut, o);
            break;
        }

      case 23:
        {
            const t = s;
            n.message = t[0];
            for (let e = 1; e < t.length; e += 2) {
                n[t[e]] = t[e + 1];
            }
            break;
        }

      case 36:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.append(e[n++], e[n]);
            }
            break;
        }

      case 37:
        {
            const t = n;
            const [e, o, r, i, c, l] = s;
            t.type = e;
            t.key = o;
            t.varProps = r;
            t.constProps = i || null;
            t.children = c;
            t.toSort = !!l;
            break;
        }

      case 25:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.add(e[n]);
            }
            break;
        }

      case 26:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.set(e[n++], e[n]);
            }
            break;
        }

      case 24:
        {
            const t = n;
            const [e, o] = s;
            const [r, i] = Su.get(t);
            e ? r(o) : i(o);
            break;
        }

      case 27:
        const i = n;
        const c = atob(s);
        let l = 0;
        for (let t = 0; t < c.length; t++) {
            const n = c[t];
            i[l++] = n.charCodeAt(0);
        }
        break;

      case 38:
        const u = n;
        const f = s;
        let a = f[0];
        if (a === Is) {
            a = new ci(Pi, f[1], f[2], null, 0, null);
            a._proxy = u;
        }
        u[As] = a;
        const h = u[Ms];
        h.ut = f[3];
        Xn(h.ut, u);
        break;

      case 39:
        {
            const t = n;
            t.data.j = s[0];
            t.data.et = s[1];
            break;
        }

      case 40:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = e[2];
            (function o(t) {
                const n = oe;
                const e = t.consumer;
                if (n && !e) {
                    return;
                }
                e[es] ||= new Map;
                e[es].set(t.property, t);
            })(t);
            break;
        }

      default:
        throw ve(16, [ e ]);
    }
};

const nc = (t, n, e = Array(n.length / 2)) => {
    for (let s = 0; s < n.length; s += 2) {
        e[s / 2] = Wn(t, n[s], n[s + 1]);
    }
    return e;
};

function Wn(t, n, e) {
    if (n === 0) {
        return e;
    }
    const s = Eu(t, n, e);
    ec(n) && tc(t, s, n, e);
    return s;
}

function Un(t, n) {
    if (t) {
        for (const e of t) {
            e.backRef ||= new Set;
            e.backRef.add(n);
        }
    }
}

function Xn(t, n) {
    if (t) {
        for (const [, e] of t) {
            Un(e, n);
        }
    }
}

const ec = t => t >= 23 || t === 4 || t === 5;

const rc = new WeakMap;

const sc = Symbol();

const ic = (t, n) => {
    if (!Array.isArray(n) || ko(n) || (t => ye(t) && sc in t)(n)) {
        return n;
    }
    let e = rc.get(n);
    if (!e) {
        const s = Array(n.length / 2).fill(void 0);
        e = new Proxy(s, new oc(t, n));
        rc.set(n, e);
    }
    return e;
};

class oc {
    $;
    fe;
    ae;
    constructor(t, n) {
        this.$ = t;
        this.fe = n;
        this.ae = this.fe.length / 2;
    }
    get(t, n, e) {
        if (n === sc) {
            return t;
        }
        const s = typeof n === "number" ? n : typeof n === "string" ? parseInt(n, 10) : NaN;
        if (Number.isNaN(s) || s < 0 || s >= this.ae) {
            return Reflect.get(t, n, e);
        }
        const o = s * 2;
        const r = this.fe[o];
        const i = this.fe[o + 1];
        if (r === 0) {
            return i;
        }
        const c = this.$;
        const l = Eu(c, r, i);
        Reflect.set(t, n, l);
        this.fe[o] = 0;
        this.fe[o + 1] = l;
        ec(r) && tc(c, l, r, i);
        return l;
    }
    has(t, n) {
        if (n === sc) {
            return !0;
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    set(t, n, e, s) {
        if (n === sc) {
            return !1;
        }
        const o = Reflect.set(t, n, e, s);
        const r = typeof n === "number" ? n : parseInt(n, 10);
        if (Number.isNaN(r) || r < 0 || r >= this.fe.length / 2) {
            return o;
        }
        const i = r * 2;
        this.fe[i] = 0;
        this.fe[i + 1] = e;
        return !0;
    }
}

async function zn(t) {
    const n = $u(null, null, () => "", () => {}, new WeakMap);
    n.St(t);
    await n.Mt();
    return "" + n.Nt;
}

function Bn(t) {
    if (t == null) {
        throw Error("No state data to deserialize");
    }
    const n = JSON.parse(t);
    if (!Array.isArray(n) || n.length < 2 || typeof n[0] !== "number") {
        throw Error("Invalid state data");
    }
    const e = Jn(n);
    return Wn(e, n[0], n[1]);
}

function Hn(t, n) {
    if (typeof t === "string") {
        t = parseInt(t, 10);
        return n[t];
    }
    return n[t];
}

function Jn(t) {
    let n;
    const e = {
        _: t => Hn(t, n),
        getSyncFn: () => () => {},
        ht: new WeakMap,
        element: null,
        Et: null
    };
    Pn(t, e);
    n = ic(e, t);
    e.It = n;
    return e;
}

const lc = (t, n) => {
    const e = new WeakSet;
    return Pc(uc, t, e, "_", n);
};

const uc = (t, n, e, s) => {
    const o = Kl(t);
    if (o == null) {
        return t;
    }
    if (fc(o)) {
        if (typeof o === "object") {
            if (n.has(o)) {
                return t;
            }
            n.add(o);
        }
        if (Ll(o)) {
            return t;
        }
        if (mu(o)) {
            return t;
        }
        if (o.__brand || o.__brand__) {
            return t;
        }
        const r = typeof o;
        switch (r) {
          case "object":
            if (dr(o)) {
                return t;
            }
            if ((t => t && typeof t.nodeType === "number")(o)) {
                return t;
            }
            if (me(o)) {
                let s = 0;
                for (let t = 0; t < o.length; t++) {
                    if (!(t in o)) {
                        throw ve(3, [ o ]);
                    }
                    const r = o[t];
                    if (t !== s) {
                        throw ve(3, [ o ]);
                    }
                    uc(r, n, e + "[" + t + "]");
                    s = t + 1;
                }
                return t;
            }
            if (o instanceof us) {
                return t;
            }
            if ($e(o)) {
                for (const [t, s] of Object.entries(o)) {
                    uc(s, n, e + "." + t);
                }
                return t;
            }
            break;
        }
        let i;
        i = s || "Value cannot be serialized";
        e !== "_" && (i += ` in ${e},`);
        if (r === "object") {
            i += ` because it's an instance of "${t?.constructor.name}". You might need to use 'noSerialize()' or use an object literal instead. Check out https://qwik.dev/docs/advanced/dollar/`;
        } else if (r === "function") {
            const n = t.name;
            i += ` because it's a function named "${n}". You might need to convert it to a QRL using $(fn):\n\nconst ${n} = $(${t + ""});\n\nPlease check out https://qwik.dev/docs/advanced/qrl/ for more information.`;
        }
        throw ve(3, [ i ]);
    }
    return t;
};

const cc = /*#__PURE__*/ new WeakSet;

const fc = t => {
    if (ye(t) || be(t)) {
        return !cc.has(t) && !(dc in t);
    }
    return !0;
};

const ac = t => !!t && (ye(t) || typeof t === "function") && (cc.has(t) || dc in t);

const hc = t => {
    (ye(t) && t !== null || typeof t === "function") && cc.add(t);
    return t;
};

const dc = Symbol();

const pc = Symbol();

const $c = t => /*#__PURE__*/ Object.freeze({
    id: gr(t)
});

const yc = (t, n) => {
    const {val: e, set: s, iCtx: o} = Ki();
    if (e !== void 0) {
        return;
    }
    o.$.setContext(o.m, t, n);
    s(1);
};

const mc = (t, n) => {
    const {val: e, set: s, iCtx: o} = Ki();
    if (e !== void 0) {
        return e;
    }
    const r = o.$.resolveContext(o.m, t);
    if (typeof n === "function") {
        return s(te(void 0, n, r));
    }
    if (r !== void 0) {
        return s(r);
    }
    if (n !== void 0) {
        return s(n);
    }
    throw ve(8, [ t.id ]);
};

const wc = t => {
    const n = xc();
    const e = n.m;
    if (!e) {
        return;
    }
    return n.$?.resolveContext(e, t);
};

const bc = /*#__PURE__*/ $c("qk-error");

const vc = t => 33 <= t && t <= 46;

const gc = (t, n, e) => {
    let s = 0;
    for (;n < e; ) {
        const e = t.charCodeAt(n);
        if (e === 92) {
            n += 2;
        } else {
            if (s === 0 && vc(e)) {
                break;
            }
            e === 123 ? s++ : e === 125 && s--;
            n++;
        }
    }
    return n;
};

function Qn(t) {
    const n = Gn(t);
    if (!n) {
        throw ve(24);
    }
    return Yn(n);
}

function Yn(t) {
    const n = t;
    return n.qContainer ||= new _c(n);
}

function Gn(t) {
    return t.closest("[q\\:container]:not([q\\:container=html]):not([q\\:container=text])");
}

class _c extends Ou {
    element;
    qContainer;
    qManifestHash;
    rootVNode;
    document;
    ht=new WeakMap;
    he;
    ue;
    Et=null;
    vNodeLocate=t => Lo(this.rootVNode, t);
    de;
    pe;
    $e=null;
    constructor(t) {
        super({}, t.getAttribute("q:locale"));
        this.qContainer = t.getAttribute(Ue);
        if (!this.qContainer) {
            throw ve(25);
        }
        this.document = t.ownerDocument;
        this.element = t;
        this.ce = t.getAttribute(Fe);
        this.ue = t.getAttribute("q:instance");
        this.qManifestHash = t.getAttribute("q:manifest-hash");
        this.rootVNode = go(this.element);
        this.de = [];
        this.pe = [];
        const n = this.element.ownerDocument;
        n.qVNodeData || function e(t) {
            const n = "q:container";
            const e = "/" + n;
            const s = "q:ignore";
            const o = "/" + s;
            const r = "q:container-island";
            const i = "/" + r;
            const c = t;
            const l = c.qVNodeData || (c.qVNodeData = new WeakMap);
            const u = t.body;
            const f = u.getAttribute;
            const a = u.hasAttribute;
            const h = ((t, n) => {
                let e;
                for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
                    t = Object.getPrototypeOf(t);
                }
                return e || function() {
                    return this[n];
                };
            })(u, "nodeType");
            const d = t => {
                const n = t.querySelectorAll('script[type="qwik/vnode"]');
                for (let t = 0; t < n.length; t++) {
                    const e = n[t];
                    const s = e.closest("[q\\:container]");
                    s.qVnodeData = e.textContent;
                    s.qVNodeRefs = new Map;
                }
                const e = t.querySelectorAll("[q\\:shadowroot]");
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    const s = n.shadowRoot;
                    s && d(s);
                }
            };
            d(t);
            const p = t => {
                const c = h.call(t);
                if (c === 1) {
                    const e = f.call(t, n);
                    if (e === null) {
                        if (a.call(t, "q:shadowroot")) {
                            return 6;
                        }
                        const n = a.call(t, ":");
                        return n ? 2 : 0;
                    }
                    return 3;
                }
                if (c === 8) {
                    const c = t.nodeValue || "";
                    if (c.startsWith(r)) {
                        return 65;
                    }
                    if (c.startsWith(s)) {
                        return 16;
                    }
                    if (c.startsWith(n)) {
                        return 9;
                    }
                    if (c.startsWith(i)) {
                        return 64;
                    }
                    if (c.startsWith(o)) {
                        return 32;
                    }
                    if (c.startsWith(e)) {
                        return 8;
                    }
                }
                return 0;
            };
            const $ = t => {
                for (;t && (t = t.nextSibling) && p(t) === 0; ) {}
                return t;
            };
            const y = (n, e, s, o, r, i) => {
                const c = r.length;
                let u = 0;
                let f = -1;
                let a = 0;
                let h = 0;
                let d = 0;
                let m = -1;
                let w = null;
                const b = () => {
                    let t = 0;
                    for (;vc(d = r.charCodeAt(a)); ) {
                        t += 1 << d - 33;
                        a++;
                        if (a >= c) {
                            break;
                        }
                    }
                    return t;
                };
                do {
                    if (s === o) {
                        return;
                    }
                    w = null;
                    const v = s == e ? 2 : p(s);
                    if (v === 3) {
                        const t = s;
                        let e = s;
                        for (;e && !(w = $(e)); ) {
                            e = e.parentNode;
                        }
                        y(n, t, s, w, t.qVnodeData || "", t.qVNodeRefs);
                    } else if (v === 16) {
                        let t = s;
                        do {
                            t = n.nextNode();
                            if (!t) {
                                throw Error(`Island inside \x3c!--${s?.nodeValue}--\x3e not found!`);
                            }
                        } while (p(t) !== 65);
                        w = null;
                    } else if (v === 64) {
                        w = s;
                        let t;
                        do {
                            w = n.nextNode();
                            if (!w) {
                                throw Error("Ignore block not closed!");
                            }
                            t = p(w);
                        } while (t !== 32 && t !== 65);
                        w = null;
                    } else if (v === 9) {
                        w = s;
                        do {
                            w = $(w);
                            if (!w) {
                                throw Error(`\x3c!--${s?.nodeValue}--\x3e not closed!`);
                            }
                        } while (p(w) !== 8);
                        y(n, s, s, w, "", null);
                    } else if (v === 6) {
                        w = $(s);
                        const n = s;
                        const e = n?.shadowRoot;
                        e && y(t.createTreeWalker(e, 129), null, e, null, "", null);
                    }
                    if ((v & 2) === 2) {
                        if (f < u) {
                            f === -1 && (f = 0);
                            a = h;
                            if (a < c) {
                                f += b();
                                const t = d === 126;
                                if (t) {
                                    m = f;
                                    a++;
                                    d = a < c ? r.charCodeAt(h) : 33;
                                }
                                h = gc(r, a, c);
                            } else {
                                f = Number.MAX_SAFE_INTEGER;
                            }
                        }
                        if (u === f) {
                            m === u && i.set(u, s);
                            const t = r.substring(a, h);
                            l.set(s, t);
                        }
                        u++;
                    }
                } while (s = w || n.nextNode());
            };
            const m = t.createTreeWalker(t, 129);
            y(m, null, m.firstChild(), null, "", null);
        }(n);
        this.he = Oe(n, this.ue) || Cs;
        this.ye();
        t.setAttribute(Ue, "resumed");
        t.qContainer = this;
        t.qDestroy = () => this.En();
        const s = t.querySelectorAll('script[type="qwik/state"]');
        if (s.length !== 0) {
            const t = s[s.length - 1];
            this.de = JSON.parse(t.textContent);
            Pn(this.de, this);
            this.pe = ic(this, this.de);
        }
        this.me();
        t.isConnected && t.dispatchEvent(new CustomEvent("qresume", {
            bubbles: !0
        }));
    }
    En() {
        this.vNodeLocate = () => null;
        this.de.length = 0;
        this.pe.length = 0;
        this._ = () => {};
        const t = this.element;
        t.qContainer = void 0;
        t.qVnodeData = void 0;
        t.qVNodeRefs = void 0;
        t.removeAttribute(Ue);
        t.ownerDocument.qVNodeData = void 0;
    }
    me() {
        const t = this.element.ownerDocument;
        const n = t.head;
        const e = t.body.querySelectorAll(Ne);
        const s = e.length;
        if (s) {
            const o = t.createDocumentFragment();
            for (let t = 0; t < s; t++) {
                o.appendChild(e[t]);
            }
            n.appendChild(o);
        }
    }
    Pn(t, n) {
        this.pe[t] = n;
    }
    parseQRL(t) {
        const n = qn(t, this);
        return n;
    }
    handleError(t, n) {
        const e = n && this.resolveContext(n, bc);
        if (!e) {
            throw t;
        }
        e.error = t;
    }
    setContext(t, n, e) {
        let s = this.getHostProp(t, Ce);
        s == null && this.setHostProp(t, Ce, s = []);
        he(s, n.id, e, 0, !0);
    }
    resolveContext(t, n) {
        for (;t; ) {
            const e = this.getHostProp(t, Ce);
            if (e != null && pe(e, n.id, 0)) {
                return de(e, n.id, 0);
            }
            t = this.getParentHost(t);
        }
        return;
    }
    getParentHost(t) {
        let n = t.parent;
        for (;n; ) {
            if (Po(n)) {
                if (Ao(n, xe, null) !== null) {
                    return n;
                }
                n = n.parent || n.slotParent;
            } else {
                n = n.parent;
            }
        }
        return null;
    }
    setHostProp(t, n, e) {
        const s = t;
        Mo(s, n, e);
    }
    getHostProp(t, n) {
        const e = t;
        let s = null;
        switch (n) {
          case Ze:
          case Ke:
          case xe:
          case Ce:
          case je:
          case lr:
            s = this._;
            break;

          case tr:
          case ir:
            s = parseInt;
            break;
        }
        return Ao(e, n, s);
    }
    ensureProjectionResolved(t) {
        if ((t.flags & 16) === 0) {
            t.flags |= 16;
            const n = t.props;
            if (n) {
                const t = Object.keys(n);
                for (let e = 0; e < t.length; e++) {
                    const s = t[e];
                    if (q(s)) {
                        const t = n[s];
                        if (typeof t == "string") {
                            const e = this.vNodeLocate(t);
                            n[s] = e;
                        }
                    }
                }
            }
        }
    }
    _=t => Hn(t, this.pe);
    getSyncFn(t) {
        const n = this.he[t];
        return n;
    }
    we(t, n, e, s) {
        if (s) {
            const t = this.getHostProp(e, Ie);
            const s = new Set(function o(t) {
                return t?.split(" ") ?? null;
            }(t));
            s.add(n);
            this.setHostProp(e, Ie, function r(t) {
                return Array.from(t).join(" ");
            }(s));
        }
        if (this.$e == null) {
            this.$e = new Set;
            const t = this.document.querySelectorAll(Me);
            for (let n = 0; n < t.length; n++) {
                const e = t[n];
                this.$e.add(e.getAttribute(Ae));
            }
        }
        if (!this.$e.has(n)) {
            this.$e.add(n);
            const e = this.document.createElement("style");
            e.setAttribute(Ae, n);
            e.textContent = t;
            this.document.head.appendChild(e);
        }
    }
    ye() {
        const t = {};
        const n = this.element.attributes;
        if (n) {
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                if (s.name === cr) {
                    continue;
                }
                t[s.name] = s.value;
            }
        }
        this.Lt = {
            containerAttributes: t
        };
    }
}

let Sc;

let Ka;

if (oe) {
    const t = Cu();
    t && (Ka = new t);
}

function Kn(t) {
    if (Ka) {
        const t = Ka.getStore();
        if (t) {
            return t;
        }
    }
    if (Sc === void 0) {
        const n = Ec();
        if (n && n.Ct) {
            return n.Ct;
        }
        if (t !== void 0) {
            return t;
        }
        throw Error("Reading `locale` outside of context.");
    }
    return Sc;
}

function Zn(t, n) {
    if (Ka) {
        return Ka.run(t, n);
    }
    const e = Sc;
    try {
        Sc = t;
        return n();
    } finally {
        Sc = e;
    }
}

let kc;

const Ec = () => kc;

const xc = () => {
    const t = Ec();
    if (!t) {
        throw ve(9);
    }
    return t;
};

const qc = () => {
    const t = Ec();
    if (!t || t.jt !== Qe) {
        throw ve(10);
    }
    return t;
};

function te(t, n, ...e) {
    return ne.call(this, t, n, e);
}

function ne(t, n, e) {
    const s = kc;
    try {
        kc = t;
        return n.apply(this, e);
    } finally {
        kc = s;
    }
}

const Tc = (t, n) => {
    const e = Qn(n);
    const s = Lo(e.rootVNode, n);
    const o = e.Ct;
    o && function r(t) {
        if (Ka) {
            Ka.enterWith(t);
            return;
        }
        Sc = t;
    }(o);
    const i = re(o, s, t);
    i.$ = e;
    return i;
};

function ee(t, n, e) {
    const s = {
        m: n,
        jt: Qe,
        Ot: void 0,
        Ct: t,
        $: e,
        Ft: void 0
    };
    return s;
}

function re(t, n, e) {
    const s = t || (e && ye(e) && "locale" in e ? e.locale : void 0);
    const o = {
        m: n,
        jt: e,
        Ot: void 0,
        Ct: s,
        $: void 0
    };
    return o;
}

const Pc = (t, ...n) => {
    if (typeof t === "function") {
        if (!kc) {
            return t(...n);
        }
        {
            const e = kc.Ot;
            try {
                kc.Ot = void 0;
                return t(...n);
            } finally {
                kc.Ot = e;
            }
        }
    }
    if (Ll(t)) {
        return t.untrackedValue;
    }
    return Kl(t);
};

const Rc = /*#__PURE__*/ ee(void 0, void 0, void 0);

const Ac = (t, n, e, s, o) => {
    const r = Rc.Ot;
    const i = Rc.$;
    try {
        Rc.Ot = p(n, e, o);
        Rc.$ = s;
        return ne(Rc, t);
    } finally {
        Rc.Ot = r;
        Rc.$ = i;
    }
};

const Mc = (t, n, e, s, o) => {
    t instanceof oi && t.m !== n && n && (t.m = n);
    return Ac(() => t.value, n, e, s, o);
};

const Nc = () => Ec()?.m;

const Ic = () => {
    const t = Ec();
    if (t) {
        return t.jt;
    }
};

const Cc = () => {
    const t = Ec();
    if (t) {
        return t.$;
    }
};

const jc = t => t;

const Oc = t => t.l || Promise.resolve();

let Fc = (t, n, e, s, o) => new Lc(t, n, e, s, o);

class Lc {
    vt;
    bt;
    be;
    ve;
    $;
    constructor(t, n, e, s, o) {
        this.vt = t;
        this.bt = n;
        this.be = e;
        this.ve = s;
        s && this.ge(s);
        !o || s || typeof t !== "string" || e || (this.$ = o);
        le && t && ie(t, .8);
    }
    get it() {
        return Ha(this.bt);
    }
    ge(t) {
        this.ve = t;
        dr(t) && t.then(t => this.ve = t, t => {
            console.error(`qrl ${this.bt} failed to load`, t);
            this.ve = null;
        });
    }
    _e() {
        if (this.ve != null) {
            return this.ve;
        }
        if (this.vt === "") {
            const t = this.$.ue;
            const n = this.$.element?.ownerDocument || document;
            const e = Oe(n, t);
            return this.ve = e[+this.bt];
        }
        le && this.vt && ie(this.vt, 1);
        const t = this.bt;
        const n = this.be ? this.be().then(n => n[t]) : Nr().importSymbol(this.$?.element, this.vt, t);
        this.ge(n);
        return this.ve;
    }
}

le && import.meta.hot && (t => {
    if (!le || !import.meta.hot) {
        return;
    }
    const n = new Map;
    (() => {
        Fc = (e, s, o, r, i) => {
            let c = n.get(s);
            if (!c) {
                c = new t(e, s, o, r, i);
                e !== "" && n.set(s, c);
            }
            return c;
        };
    })();
    const e = (t, n) => {
        const [e, s] = t.split("?", 2);
        if (!s) {
            return `${e}?t=${n}`;
        }
        const o = s.split("&").filter(t => !t.startsWith("t="));
        o.push("t=" + n);
        return `${e}?${o.join("&")}`;
    };
    document.addEventListener("qHmr", t => {
        const s = t.detail.files;
        const o = t.detail.t || document.__hmrT || Date.now();
        let r = !1;
        for (const t of n.values()) {
            const n = t.dev?.file || t.vt;
            if (!n || !s.some(t => n.startsWith(t))) {
                continue;
            }
            const i = t.vt;
            if (i) {
                t.vt = e(i, o);
                r = !0;
            }
            const c = t.be?.toString();
            if (c) {
                const n = c.replace(/import\((['"])(.+?)\1\)/, (t, n, s) => {
                    const r = e(s, o);
                    return `import(${n}${r}${n})`;
                });
                if (n !== c) {
                    try {
                        t.be = Function(`return (${n})`)();
                        r = !0;
                    } catch (n) {
                        console.error("Failed to update symbolFn for " + t.bt, n);
                    }
                } else {
                    console.warn(`Couldn't find import() in symbolFn for ${t.bt}, cannot update it for HMR`, c);
                }
            }
            if (r) {
                t.ve = void 0;
                document.__hmrDone = document.__hmrT;
                if (t.qrls) {
                    for (const n of t.qrls) {
                        const e = n.deref();
                        e ? e.resolved && (e.resolved = void 0) : t.qrls.delete(n);
                    }
                }
            }
        }
    });
})(Lc);

const Dc = Symbol();

const Vc = t => t?.[Dc] ?? t;

class Wc {
    Se;
    resolved=void 0;
    Pt;
    $;
    constructor(t, n, e) {
        this.Se = t;
        if (n) {
            this.Pt = n;
            typeof n === "string" && (this.$ = e);
        }
        t.ve == null || typeof this.Pt === "string" || dr(t.ve) || (this.resolved = Yc(this, t.ve));
    }
}

const Uc = function(t, ...n) {
    const e = Vc(this);
    if (e.resolved) {
        return e.resolved.apply(t, n);
    }
    const s = Ec();
    return Xc.call(e, s?.$).then(() => ne.call(t, s, e.resolved, n));
};

const Xc = async function(t) {
    const n = Vc(this);
    return $r(Gc(n, t), () => n.resolved);
};

const zc = Object.create(Function.prototype, {
    resolved: {
        get() {
            return this[Dc].resolved;
        },
        set(t) {
            this[Dc].resolved = t;
        }
    },
    Pt: {
        get() {
            return this[Dc].Pt;
        },
        set(t) {
            this[Dc].Pt = t;
        }
    },
    $: {
        get() {
            return this[Dc].$;
        },
        set(t) {
            this[Dc].$ = t;
        }
    },
    Se: {
        get() {
            return this[Dc].Se;
        }
    },
    vt: {
        get() {
            return this[Dc].Se.vt;
        }
    },
    bt: {
        get() {
            return this[Dc].Se.bt;
        }
    },
    it: {
        get() {
            return this[Dc].Se.it;
        }
    },
    dev: {
        get() {
            return this[Dc].Se.dev;
        }
    },
    ke: {
        value: Uc
    },
    w: {
        value: function(t) {
            const n = Vc(this);
            const e = new Wc(n.Se, t, n.Pt ? n.$ : void 0);
            return Zc(e);
        }
    },
    s: {
        value: function(t) {
            const n = Vc(this);
            n.Se.ge(t);
            n.resolved = Yc(n, t);
        }
    },
    resolve: {
        value: Xc
    },
    getSymbol: {
        value: function() {
            return Vc(this).Se.bt;
        }
    },
    getHash: {
        value: function() {
            return Vc(this).Se.it;
        }
    },
    getCaptured: {
        value: function() {
            const t = Vc(this);
            Qc(t);
            return t.Pt;
        }
    },
    getFn: {
        value: function(t, n) {
            const e = Vc(this);
            const s = (...o) => {
                if (!e.resolved) {
                    return Xc.call(e).then(() => s(...o));
                }
                if (n && n() === !1) {
                    return;
                }
                return ne(t, e.resolved, o);
            };
            return s;
        }
    }
});

let Bc = null;

const Hc = t => {
    Bc = t;
};

const Jc = (t, n) => {
    const e = [];
    const s = n.split(" ");
    for (let n = 0; n < s.length; n++) {
        const o = s[n];
        e.push(t._(o));
    }
    return e;
};

const Qc = t => {
    Bc = t.Pt;
    const n = t.$;
    if (typeof Bc === "string") {
        if (!n) {
            throw ve(13);
        }
        const e = Gu;
        Bc = t.Pt = Jc(n, Bc);
        if (Gu !== e) {
            return Gu;
        }
    }
};

const Yc = (t, n) => {
    if (typeof n !== "function" || !t.Pt) {
        return n;
    }
    return function e(...s) {
        Qc(t);
        return n.apply(this, s);
    };
};

const Gc = (t, n) => {
    const e = t.Se;
    const s = typeof t.Pt === "string";
    s && !t.$ && (t.$ = n || Ec()?.$);
    if (t.resolved) {
        return;
    }
    const o = rf();
    const r = Ec();
    const i = e._e();
    const c = $r(i, n => {
        t.resolved = Yc(t, n);
    });
    if (c) {
        const t = e.bt;
        nf(t, r?.m instanceof fs ? r?.m.node : void 0, o);
    }
    const l = s && t.$ && Qc(t);
    if (l) {
        return l.then(() => c);
    }
    return c;
};

const Kc = (t, n, e, s, o, r) => {
    const i = Fc(t, n, s, e, r);
    const c = new Wc(i, o, r);
    return Zc(c);
};

const Zc = t => {
    const n = async function(...t) {
        return Uc.call(n, this, ...t);
    };
    n[Dc] = t;
    Object.setPrototypeOf(n, zc);
    return n;
};

const tf = /*#__PURE__*/ new Set;

const nf = (t, n, e) => {
    if (!tf.has(t)) {
        tf.add(t);
        ef("qsymbol", {
            symbol: t,
            element: n,
            reqTime: e
        });
    }
};

const ef = (t, n) => {
    Ja() || typeof document !== "object" || document.dispatchEvent(new CustomEvent(t, {
        bubbles: !1,
        detail: n
    }));
};

const rf = () => {
    if (Ja()) {
        return 0;
    }
    if (typeof performance === "object") {
        return performance.now();
    }
    return 0;
};

let sf = 0;

const of = t => Kc(null, "s" + sf++, t, null, null);

const lf = of;

const uf = t => t;

const cf = t => Kc("", ge, t, null, null);

const ff = (t, n) => {
    n === void 0 && (n = "" + t);
    t.serialized = n;
    return Kc("", ge, t, null, null);
};

const af = t => {
    function n(n, e, s = 0) {
        const o = t.it.slice(0, 4);
        const r = o + ":" + (e || "");
        const i = () => {};
        i[hf] = [ t ];
        return gi(i, n, null, n.children, s, r);
    }
    n[hf] = [ t ];
    return n;
};

const hf = Symbol();

const df = t => typeof t == "function" && t[hf] !== void 0;

const pf = t => af(lf(t));

const $f = zs(uf);

const yf = () => {
    const t = globalThis.__QWIK_MANIFEST__;
    if (!globalThis.__QWIK_MANIFEST__) {
        throw Error("Client manifest is not available. It should have been automatically injected during the build process. Make sure that @qwik.dev/core is internal to the build.");
    }
    return t;
};

const mf = async (t, n, e = {}) => {
    if ((t => t.nodeType === 9)(t)) {
        let n = t.firstChild;
        for (;n && !ns(n); ) {
            n = n.nextSibling;
        }
        t = n;
    }
    t.setAttribute(Ue, "resumed");
    const s = Qn(t);
    s.Lt = e.serverData || {};
    const o = s.rootVNode;
    Mo(o, ys, n);
    sn(s, o, 2);
    await s.l;
    return {
        cleanup: () => {
            Et(s, [], s.rootVNode);
        }
    };
};

const wf = (t, n) => {
    const {val: e, set: s, iCtx: o} = Ki();
    if (e != null) {
        return e;
    }
    const r = be(t) ? te(void 0, t) : t;
    if (n?.reactive === !1) {
        s(r);
        return r;
    }
    {
        const t = o.$;
        const e = n?.deep ?? !0;
        const i = e ? 1 : 0;
        const c = tu(r, i, t);
        s(c);
        return c;
    }
};

const bf = () => {
    const {val: t, set: n, iCtx: e} = Ki();
    if (t != null) {
        return t;
    }
    const s = e.$.ce || "";
    const o = s ? kr(s).substring(0, 3) : "";
    const r = e.$.getHostProp(e.m, xe);
    const i = r?.getHash().substring(0, 3) || "";
    const c = (t => (t => t.toString(36))(t.le++))(e.$) || "";
    let l = `${o}${i}${c}`;
    let u = l.charCodeAt(0);
    if (u >= 48 && u <= 57) {
        u += 17;
        l = String.fromCharCode(u) + l.substring(1);
    }
    return n(l);
};

function se(t, n) {
    const e = Ec();
    return e?.$?.Lt[t] ?? n;
}

const vf = /*#__PURE__*/ new Map;

const gf = (t, n) => {
    let e = vf.get(n);
    e || vf.set(n, e = _f(t, n));
    return e;
};

const _f = (t, n) => {
    const e = t.length;
    const s = [];
    const o = [];
    let r = 0;
    let i = r;
    let c = qf;
    let l = 0;
    for (;r < e; ) {
        const n = r;
        let e = t.charCodeAt(r++);
        if (e === ta) {
            r++;
            e = Gf;
        }
        const s = ua[c];
        for (let d = 0; d < s.length; d++) {
            const p = s[d];
            const [$, y, m] = p;
            if (($ === l || $ === jf || $ === Of && Sf(l) || $ === Lf && xf(l)) && (y === e || y === jf || y === Of && Sf(e) || y === Ff && !Sf(e) && e !== Hf || y === Lf && xf(e)) && (p.length == 3 || a(p))) {
                p.length > 3 && (e = t.charCodeAt(r - 1));
                if (m === If || m == Cf) {
                    if (m === Cf) {
                        if (c !== Tf || h()) {
                            if (!kf(e)) {
                                const t = y == Ff ? 1 : y == zf ? 2 : 0;
                                f(r - t);
                            }
                        } else {
                            kf(e) ? u(r - 2) : f(r - 2);
                            i++;
                        }
                    }
                    if (y === Ff) {
                        r--;
                        e = l;
                    }
                    do {
                        c = o.pop() || qf;
                        if (c === Pf) {
                            u(r - 1);
                            i++;
                        }
                    } while (Ef(c));
                } else {
                    o.push(c);
                    if (c === Pf && m === qf) {
                        u(r - 8);
                        i = r;
                    } else {
                        m === Rf && f(n);
                    }
                    c = m;
                }
                break;
            }
        }
        l = e;
    }
    u(r);
    return s.join("");
    function u(n) {
        s.push(t.substring(i, n));
        i = n;
    }
    function f(t) {
        if (c === Pf || h()) {
            return;
        }
        u(t);
        s.push(".", Te, n);
    }
    function a(n) {
        let e = 0;
        if (t.charCodeAt(r) === Bf) {
            for (let n = 1; n < 10; n++) {
                if (t.charCodeAt(r + n) === Bf) {
                    e = n + 1;
                    break;
                }
            }
        }
        t: for (let s = 3; s < n.length; s++) {
            const o = n[s];
            for (let n = 0; n < o.length; n++) {
                if ((t.charCodeAt(r + n + e) | ea) !== o.charCodeAt(n)) {
                    continue t;
                }
            }
            r += o.length + e;
            return !0;
        }
        return !1;
    }
    function h() {
        return o.indexOf(Pf) !== -1 || o.indexOf(Af) !== -1;
    }
};

const Sf = t => t >= Jf && t <= Qf || t >= Gf && t <= Kf || t >= ra && t <= sa || t >= 128 || t === na || t === Bf;

const kf = t => t === Yf || t === Hf || t === Zf || t === Xf || Sf(t);

const Ef = t => t === Mf || t === Af || t === Nf || t === Pf;

const xf = t => t === Uf || t === Df || t === Vf || t === Wf;

const qf = 0;

const Tf = 2;

const Pf = 5;

const Rf = 6;

const Af = 10;

const Mf = 11;

const Nf = 12;

const If = 17;

const Cf = 18;

const jf = 0;

const Of = 1;

const Ff = 2;

const Lf = 3;

const Df = 9;

const Vf = 10;

const Wf = 13;

const Uf = 32;

const Xf = 35;

const zf = 41;

const Bf = 45;

const Hf = 46;

const Jf = 48;

const Qf = 57;

const Yf = 58;

const Gf = 65;

const Kf = 90;

const Zf = 91;

const ta = 92;

const na = 95;

const ea = 32;

const ra = 97;

const sa = 122;

const ia = 123;

const oa = 125;

const la = /*@__PURE__*/ (() => [ [ jf, 39, 14 ], [ jf, 34, 15 ], [ jf, 47, 16, "*" ] ])();

const ua = /*@__PURE__*/ (() => [ [ [ jf, 42, Tf ], [ jf, Zf, 7 ], [ jf, Yf, Rf, ":", "before", "after", "first-letter", "first-line" ], [ jf, Yf, Pf, "global" ], [ jf, Yf, 3, "has", "host-context", "not", "where", "is", "matches", "any" ], [ jf, Yf, 4 ], [ jf, Of, 1 ], [ jf, Hf, 1 ], [ jf, Xf, 1 ], [ jf, 64, Af, "keyframe" ], [ jf, 64, Mf, "media", "supports", "container" ], [ jf, 64, Nf ], [ jf, ia, 13 ], [ 47, 42, 16 ], [ jf, 59, If ], [ jf, oa, If ], [ jf, zf, If ], ...la ], [ [ jf, Ff, Cf ] ], [ [ jf, Ff, Cf ] ], [ [ jf, 40, qf ], [ jf, Ff, Cf ] ], [ [ jf, 40, 8 ], [ jf, Ff, Cf ] ], [ [ jf, 40, qf ], [ jf, Ff, If ] ], [ [ jf, Ff, If ] ], [ [ jf, 93, Cf ], [ jf, 39, 14 ], [ jf, 34, 15 ] ], [ [ jf, zf, If ], ...la ], [ [ jf, oa, If ], ...la ], [ [ jf, oa, If ], [ Lf, Of, 1 ], [ jf, Yf, Pf, "global" ], [ jf, ia, 13 ], ...la ], [ [ jf, ia, qf ], [ jf, 59, If ], ...la ], [ [ jf, 59, If ], [ jf, ia, 9 ], ...la ], [ [ jf, oa, If ], [ jf, ia, 13 ], [ jf, 40, 8 ], ...la ], [ [ jf, 39, If ] ], [ [ jf, 34, If ] ], [ [ 42, 47, If ] ] ])();

const ca = t => ({
    styleId: da(t, t => t, !1)
});

const fa = /*#__PURE__*/ zs(ca);

const aa = t => ({
    scopeId: Te + da(t, gf, !0)
});

const ha = /*#__PURE__*/ zs(aa);

const da = (t, n, e) => {
    let {val: s, set: o, iCtx: r, i} = Ki();
    if (s) {
        return s;
    }
    const c = ((t, n) => `${kr(t.it)}-${n}`)(t, i);
    const l = r.m;
    o(c);
    if (!t.resolved) {
        throw t.resolve().then(t => r.$.we(n(t, c), c, l, e));
    }
    r.$.we(n(t.resolved, c), c, l, e);
    return c;
};

const pa = (t, n) => {
    t.resolve();
    return Hs(t, n);
};

const $a = (t, n) => no(pa, t, n);

const ya = zs($a);

const ma = t => {
    t.resolve();
    return Qs(t);
};

const wa = t => no(ma, t);

const ba = zs(wa);

const va = (t, n) => {
    const {val: e, set: s, i: o, iCtx: r} = Ki();
    const i = n?.strategy ?? "intersection-observer";
    if (e) {
        if (!(e.h & 32) && !Ja()) {
            e.h |= 32;
            ga(e, i);
        }
        return;
    }
    let c;
    if (Ja()) {
        c = 1;
    } else {
        c = 5;
        t.resolve();
        sn(r.$, r.m, 1);
    }
    const l = new jl(c, o, r.m, t, void 0, null);
    s(l);
    ga(l, i);
};

const ga = (t, n) => {
    n === "intersection-observer" ? Xu("qvisible", _a(t)) : n === "document-ready" ? zu("qinit", _a(t)) : n === "document-idle" && zu("qidle", _a(t));
};

const _a = t => Kc(null, "_task", bn, null, [ t ]);

const Sa = zs(Vu);

const ka = /*#__PURE__*/ zs(Il);

const Ea = /*#__PURE__*/ zs(va);

const xa = (t, n) => {
    t.resolve();
    return Js(t, n);
};

const qa = (t, n) => no(xa, t, n);

const Ta = zs(qa);

const Pa = () => {
    const t = wf({
        error: void 0
    });
    yc(bc, t);
    return t;
};

const Ra = async ({track: t}) => {
    const n = Bc[0];
    t(() => n.items);
    const e = Ec();
    const s = e.m;
    const o = e.$;
    sn(o, s, 128);
    const r = oe;
    r && await o.l;
};

const Aa = t => {
    if (!__EXPERIMENTAL__.each) {
        throw Error('Each is experimental and must be enabled with `experimental: ["each"]` in the `qwikVite` plugin.');
    }
    Il(/*#__PURE__*/ qu(Ra, "_eaT", [ t ]));
    return Ni;
};

const Ma = /*#__PURE__*/ af(
/*#__PURE__*/ qu(Aa, "_eaC"));

const Na = /*#__PURE__*/ $c("qk-reveal");

const Ia = t => ({
    order: t.order ?? "parallel",
    collapsed: t.collapsed === !0,
    items: [],
    version: Ys(0)
});

const Ca = () => {
    const t = Bc[0];
    if (t === null) {
        return !0;
    }
    const n = t.reveal;
    const e = t.item;
    const s = n.items;
    if (n.version.value < 0) {
        return !1;
    }
    switch (n.order) {
      case "together":
        for (let t = 0; t < s.length; t++) {
            if (s[t].boundary.pending.untrackedValue > 0) {
                return !1;
            }
        }
        return !0;

      case "sequential":
        for (let t = 0; t < s.length; t++) {
            const n = s[t];
            if (n === e) {
                return !0;
            }
            if (n.boundary.pending.untrackedValue > 0) {
                return !1;
            }
        }
        return !0;

      case "reverse":
        for (let t = s.length - 1; t >= 0; t--) {
            const n = s[t];
            if (n === e) {
                return !0;
            }
            if (n.boundary.pending.untrackedValue > 0) {
                return !1;
            }
        }
        return !0;

      default:
        return !0;
    }
};

const ja = ({cleanup: t}) => {
    const n = Bc[0];
    t(() => {
        if (!le) {
            return;
        }
        const t = n.reveal.items;
        const e = t.indexOf(n.item);
        if (e !== -1) {
            t.splice(e, 1);
            n.reveal.version.value++;
        }
    });
};

const Oa = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Reveal is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = no(Ia, t);
    yc(Na, n);
    /*#__PURE__*/
    return vi(Mi, null, null, null, 0, "u7_0");
};

const Fa = /*#__PURE__*/ af(
/*#__PURE__*/ qu(Oa, "_reC"));

const La = (t, n, e, s) => ({
    display: n.value !== "fallback" || t.fallback == null || t.fallback === !1 || e !== null && !e.value && s.reveal.collapsed ? "none" : "contents"
});

const Da = (t, n, e) => ({
    display: e !== null && !e.value || n.value !== "content" && !t.showStale ? "none" : "contents"
});

const Va = ({track: t, cleanup: n}) => {
    const e = Bc[0], s = Bc[1], o = Bc[2], r = Bc[3];
    const i = t(e.pending);
    const c = le;
    r !== null && c && r.reveal.version.value++;
    if (!c || i === 0) {
        o.value = "content";
        return;
    }
    const l = setTimeout(() => {
        e.pending.value > 0 && (o.value = "fallback");
    }, s.delay ?? 0);
    n(() => clearTimeout(l));
};

const Wa = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Suspense is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = to("content");
    const e = (() => {
        if (!__EXPERIMENTAL__.suspense) {
            throw Error('useCursorBoundary is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
        }
        return no(eo);
    })();
    const s = (t => {
        const n = mc(Na, null);
        const e = no(() => {
            if (n === null) {
                return null;
            }
            const e = {
                boundary: t
            };
            n.items.push(e);
            return {
                reveal: n,
                item: e
            };
        });
        e !== null && Il(/*#__PURE__*/ qu(ja, "_reT", [ e ]), {
            deferUpdates: !1
        });
        return e;
    })(e);
    const o = $a(
    /*#__PURE__*/ qu(Ca, "_reR", [ s ]));
    Il(
    /*#__PURE__*/ qu(Va, "_suT", [ e, t, n, s ]));
    /*#__PURE__*/
    return vi(Pi, null, null, [ 
    /*#__PURE__*/ vi("div", {
        style: ju(La, [ t, n, o, s ], '{display:p1.value==="fallback"&&p0.fallback!=null&&p0.fallback!==false&&(p2===null||p2.value||!p3.reveal.collapsed)?"contents":"none"}')
    }, null, ri(t, "fallback"), 1, null), 
    /*#__PURE__*/ vi("div", null, {
        style: ju(Da, [ t, n, o ], '{display:(p2===null||p2.value)&&(p1.value==="content"||p0.showStale)?"contents":"none"}')
    }, 
    /*#__PURE__*/ vi(Mi, {
        [lr]: e
    }, null, null, 3, "u6_0"), 1, null) ], 1, "u6_1");
};

const Ua = /*#__PURE__*/ af(
/*#__PURE__*/ qu(Wa, "_suC"));

const Xa = t => {
    const n = import.meta.env?.BASE_URL || "/";
    const e = {
        path: "qwik-prefetch-service-worker.js",
        ...t
    };
    e.path = t?.path?.startsWith?.("/") ? t.path : n + e.path;
    let s = za.replace('"_URL_"', JSON.stringify(e.path.split("/").pop()));
    s = s.replaceAll(/\s\s+/gm, "");
    const o = {
        dangerouslySetInnerHTML: "(" + s + ")(navigator.serviceWorker);",
        nonce: e.nonce
    };
    return vi("script", null, o, null, 0, "prefetch-service-worker");
};

const za = /*#__PURE__*/ "" + (t => {
    "getRegistrations" in t && t.getRegistrations().then(t => {
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            e.active && e.active.scriptURL.endsWith("_URL_") && e.unregister().catch(console.error);
        }
    });
    "caches" in window && caches.keys().then(t => {
        const n = t.find(t => t.startsWith("QwikBundles"));
        n && caches.delete(n).catch(console.error);
    }).catch(console.error);
});

const Ba = () => null;

globalThis.__qwik && ve(30, [ globalThis.__qwik, ts ]);

globalThis.__qwik = ts;

import.meta.hot && import.meta.hot.dispose(() => {
    globalThis.__qwik = void 0;
});

export { of as $, Ma as Each, Pi as Fragment, dc as NoSerializeSymbol, Ba as PrefetchGraph, Xa as PrefetchServiceWorker, Ri as RenderOnce, Wu as Resource, Fa as Reveal, Ci as SSRComment, Ii as SSRRaw, Oi as SSRStream, ji as SSRStreamBlock, pc as SerializerSymbol, Ni as SkipRender, Mi as Slot, Ua as Suspense, Ps as _CONST_PROPS, _c as _DomContainer, es as _EFFECT_BACK_REF, Cs as _EMPTY_ARRAY, js as _EMPTY_OBJ, Ns as _IMMUTABLE, Ou as _SharedContainer, li as _SubscriptionData, Is as _UNINITIALIZED, Rs as _VAR_PROPS, Fn as _addProjection, Bc as _captures, m as _chk, Jn as _createDeserializeContainer, Kc as _createQRL, Bn as _deserialize, vu as _dumpState, Aa as _eaC, Ra as _eaT, en as _executeSsrChores, ju as _fnSignal, Cu as _getAsyncLocalStorage, Us as _getConstProps, Cc as _getContextContainer, Ic as _getContextEvent, Nc as _getContextHostElement, Qn as _getDomContainer, Gn as _getQContainerElement, Ws as _getVarProps, Gl as _hasStoreEffects, Qu as _hmr, ai as _isJSXNode, Zl as _isStore, An as _isStringifiable, Ol as _isTask, jc as _jsxBranch, _i as _jsxC, ki as _jsxQ, Si as _jsxS, vi as _jsxSorted, gi as _jsxSplit, ae as _mapApp_findIndx, de as _mapArray_get, he as _mapArray_set, Tu as _noopQrl, Pu as _noopQrlDEV, Pn as _preprocessState, ff as _qrlSync, En as _qrlToString, Ru as _qrlWithChunk, Au as _qrlWithChunkDEV, Oa as _reC, Ca as _reR, ja as _reT, Iu as _regSymbol, Vn as _removeProjection, w as _res, wc as _resolveContextWithoutSequentialScope, Vi as _restProps, Du as _rsc, C as _run, zn as _serialize, Cn as _setEvent, Ln as _setProjectionTarget, Wa as _suC, Va as _suT, bn as _task, Dn as _updateProjectionProps, On as _useHmr, y as _val, lc as _verifySerializable, Co as _vnode_ensureElementInflated, kl as _vnode_getAttrKeys, rl as _vnode_getElementName, ol as _vnode_getFirstChild, Ao as _vnode_getProp, Wo as _vnode_getVNodeForChildNode, Ko as _vnode_insertBefore, Eo as _vnode_isElementVNode, qo as _vnode_isMaterialized, To as _vnode_isTextVNode, Po as _vnode_isVirtualVNode, So as _vnode_newVirtual, nl as _vnode_remove, Mo as _vnode_setProp, hn as _vnode_toString, Oc as _waitUntilRendered, Nn as _walkJSX, ri as _wrapProp, ii as _wrapSignal, pf as component$, af as componentQrl, Ks as createAsync$, Js as createAsyncQrl, Gs as createComputed$, Hs as createComputedQrl, $c as createContextId, b as createElement, Zs as createSerializer$, Qs as createSerializerQrl, Ys as createSignal, $f as event$, uf as eventQrl, Yl as forceStoreEffects, yf as getClientManifest, Qn as getDomContainer, Kn as getLocale, Nr as getPlatform, b as h, zs as implicit$FirstArg, qu as inlinedQrl, Nu as inlinedQrlDEV, ue as isDev, Ll as isSignal, xi as jsx, qi as jsxDEV, Ti as jsxs, hc as noSerialize, xu as qrl, Mu as qrlDEV, mf as render, Mr as setPlatform, cf as sync$, Pc as untrack, Kl as unwrapStore, Ta as useAsync$, qa as useAsyncQrl, ya as useComputed$, $a as useComputedQrl, no as useConstant, mc as useContext, yc as useContextProvider, Pa as useErrorBoundary, bf as useId, Lu as useLexicalScope, Xu as useOn, zu as useOnDocument, Bu as useOnWindow, Sa as useResource$, Vu as useResourceQrl, ba as useSerializer$, wa as useSerializerQrl, se as useServerData, to as useSignal, wf as useStore, fa as useStyles$, ca as useStylesQrl, ha as useStylesScoped$, aa as useStylesScopedQrl, ka as useTask$, Il as useTaskQrl, Ea as useVisibleTask$, va as useVisibleTaskQrl, ts as version, Zn as withLocale };
